(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@beisen/chaos-ui"), require("react-dom"), require("es6-promise"), require("isomorphic-fetch"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@beisen/chaos-ui", "react-dom", "es6-promise", "isomorphic-fetch"], factory);
	else if(typeof exports === 'object')
		exports["TitaWidget"] = factory(require("react"), require("@beisen/chaos-ui"), require("react-dom"), require("es6-promise"), require("isomorphic-fetch"));
	else
		root["TitaWidget"] = factory(root["React"], root["@beisen/chaos-ui"], root["ReactDOM"], root["es6-promise"], root["isomorphic-fetch"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_288__, __WEBPACK_EXTERNAL_MODULE_289__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(161);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(176), __esModule: true };

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _defineProperty = __webpack_require__(165);

	var _defineProperty2 = _interopRequireDefault(_defineProperty);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _setPrototypeOf = __webpack_require__(166);

	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

	var _create = __webpack_require__(164);

	var _create2 = _interopRequireDefault(_create);

	var _typeof2 = __webpack_require__(80);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }

	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _typeof2 = __webpack_require__(80);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */

	(function () {
		'use strict';

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _assign = __webpack_require__(163);

	var _assign2 = _interopRequireDefault(_assign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.8' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _callFetch = __webpack_require__(159);

	var _callFetch2 = _interopRequireDefault(_callFetch);

	var _urlComplete = __webpack_require__(160);

	var _urlComplete2 = _interopRequireDefault(_urlComplete);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
		callFetch: _callFetch2.default,
		urlComplete: _urlComplete2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(58)('wks');
	var uid = __webpack_require__(48);
	var Symbol = __webpack_require__(12).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var core = __webpack_require__(10);
	var ctx = __webpack_require__(31);
	var hide = __webpack_require__(26);
	var has = __webpack_require__(25);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(32)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(230);

	/*
	 * Name: Feed主体容器
	 * Desc: Feed主体容器，用于定位主体位置，显示包含的所有子组件
	 * Author: lilei@beisen.com
	 */

	var FeedContent = function (_Component) {
		(0, _inherits3.default)(FeedContent, _Component);

		function FeedContent(props) {
			(0, _classCallCheck3.default)(this, FeedContent);
			return (0, _possibleConstructorReturn3.default)(this, (FeedContent.__proto__ || (0, _getPrototypeOf2.default)(FeedContent)).call(this, props));
		}

		(0, _createClass3.default)(FeedContent, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    children = _props.children,
				    isDetail = _props.isDetail;

				return React.createElement(
					'div',
					{ className: (0, _classnames2.default)('feed-content', {
							'detail': isDetail
						}) },
					children
				);
			}
		}]);
		return FeedContent;
	}(_react.Component);

	exports.default = FeedContent;
	module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _chaosUi = __webpack_require__(8);

	var _FeedTitleText = __webpack_require__(73);

	var _FeedTitleText2 = _interopRequireDefault(_FeedTitleText);

	var _FeedTitleDate = __webpack_require__(139);

	var _FeedTitleDate2 = _interopRequireDefault(_FeedTitleDate);

	var _FeedTitleJur = __webpack_require__(140);

	var _FeedTitleJur2 = _interopRequireDefault(_FeedTitleJur);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(263);

	/*
	 * Name: FeedTitle
	 * Desc: 包含标题中logo、人像、标题组、日周月报评分等内容，通过imgType判定渲染的是logo还是人像
	 * Author: lilei@beisen.com
	 */

	var FeedTitleContent = function (_Component) {
		(0, _inherits3.default)(FeedTitleContent, _Component);

		function FeedTitleContent(props) {
			(0, _classCallCheck3.default)(this, FeedTitleContent);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedTitleContent.__proto__ || (0, _getPrototypeOf2.default)(FeedTitleContent)).call(this, props));

			_this.getImgContent = _this.getImgContent.bind(_this);
			return _this;
		}

		// 获取首位图片内容


		(0, _createClass3.default)(FeedTitleContent, [{
			key: 'getImgContent',
			value: function getImgContent() {
				var _props = this.props,
				    imgType = _props.imgType,
				    avatarInfo = _props.avatarInfo,
				    logoSrc = _props.logoSrc;

				switch (imgType) {
					case 'logo':
						return React.createElement('img', { className: 'feed-title-logo', src: logoSrc });
					case 'avatar':
						return React.createElement(_chaosUi.Avatar, (0, _extends3.default)({}, avatarInfo, { scale: 'medium' }));
					default:
						return null;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    textData = _props2.textData,
				    createDate = _props2.createDate,
				    isPrivate = _props2.isPrivate;

				return React.createElement(
					'div',
					{ className: 'feed-title-content' },
					this.getImgContent(),
					React.createElement(_FeedTitleText2.default, { textData: textData }),
					React.createElement(
						_FeedTitleDate2.default,
						{ dateData: createDate },
						React.createElement(_FeedTitleJur2.default, { isPrivate: isPrivate })
					)
				);
			}
		}]);
		return FeedTitleContent;
	}(_react.Component);

	exports.default = FeedTitleContent;
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: Feed类型公共页
	 * Desc: 标准容器页
	 * Author: lilei@beisen.com
	 */
	var FeedMain = function (_Component) {
		(0, _inherits3.default)(FeedMain, _Component);

		function FeedMain(props) {
			(0, _classCallCheck3.default)(this, FeedMain);
			return (0, _possibleConstructorReturn3.default)(this, (FeedMain.__proto__ || (0, _getPrototypeOf2.default)(FeedMain)).call(this, props));
		}

		(0, _createClass3.default)(FeedMain, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    contentTouchTap = _props.contentTouchTap,
				    children = _props.children;

				return React.createElement(
					'div',
					{ className: 'feed-main', onTouchTap: contentTouchTap },
					children
				);
			}
		}]);
		return FeedMain;
	}(_react.Component);

	exports.default = FeedMain;
	module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(20);
	var IE8_DOM_DEFINE = __webpack_require__(83);
	var toPrimitive = __webpack_require__(61);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(16) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	exports.default = function (obj, keys) {
	  var target = {};

	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }

	  return target;
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(21);
	var createDesc = __webpack_require__(40);
	module.exports = __webpack_require__(16) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(84);
	var defined = __webpack_require__(51);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(226);

	/*
	 * Name: Feed主体字段描述
	 * Desc: Feed主体字段描述，根据固定的格式渲染字段
	 * Author: lilei@beisen.com
	 */

	var FeedContentDesc = function (_Component) {
		(0, _inherits3.default)(FeedContentDesc, _Component);

		function FeedContentDesc(props) {
			(0, _classCallCheck3.default)(this, FeedContentDesc);
			return (0, _possibleConstructorReturn3.default)(this, (FeedContentDesc.__proto__ || (0, _getPrototypeOf2.default)(FeedContentDesc)).call(this, props));
		}

		(0, _createClass3.default)(FeedContentDesc, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    descWidth = _props.descWidth,
				    children = _props.children,
				    hasEva = _props.hasEva;

				return React.createElement(
					'div',
					{ className: (0, _classnames2.default)('feed-content-desc', { 'ex-eva': hasEva }),
						style: { width: descWidth } },
					children
				);
			}
		}]);
		return FeedContentDesc;
	}(_react.Component);

	exports.default = FeedContentDesc;
	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedTitleText = __webpack_require__(73);

	var _FeedTitleText2 = _interopRequireDefault(_FeedTitleText);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(229);

	/*
	 * Name: Feed主体标题组件
	 * Desc: Feed主体标题组件
	 * Author: lilei@beisen.com
	 */

	var FeedContentTitle = function (_Component) {
		(0, _inherits3.default)(FeedContentTitle, _Component);

		function FeedContentTitle(props) {
			(0, _classCallCheck3.default)(this, FeedContentTitle);
			return (0, _possibleConstructorReturn3.default)(this, (FeedContentTitle.__proto__ || (0, _getPrototypeOf2.default)(FeedContentTitle)).call(this, props));
		}

		(0, _createClass3.default)(FeedContentTitle, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    isDetail = _props.isDetail,
				    textData = _props.textData,
				    contentTitle = _props.contentTitle,
				    preWidth = _props.preWidth,
				    logoSrc = _props.logoSrc;

				var width = preWidth || (isDetail ? 175 : 200);
				return React.createElement(
					'div',
					null,
					logoSrc ? React.createElement('img', { className: 'content-logo', src: logoSrc }) : null,
					React.createElement(
						'span',
						{ className: 'content-title' },
						contentTitle
					),
					React.createElement(_FeedTitleText2.default, { textData: textData, preWidth: width, isContentTitle: true })
				);
			}
		}]);
		return FeedContentTitle;
	}(_react.Component);

	exports.default = FeedContentTitle;
	module.exports = exports['default'];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedTimeLineBar = __webpack_require__(71);

	var _FeedTimeLineBar2 = _interopRequireDefault(_FeedTimeLineBar);

	var _FeedTimeLineItem = __webpack_require__(72);

	var _FeedTimeLineItem2 = _interopRequireDefault(_FeedTimeLineItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(102);

	/*
	 * Name: 任务项目等使用的操作记录时间线
	 * Desc: 数据来源自父组件，产生变化时直接对调用父组件更新，
	 * 组件内不独立更新记录，防止记录与其他部分信息错乱
	 * author: lilei@beisen.com
	 */

	var FeedTimeLineList = function (_Component) {
		(0, _inherits3.default)(FeedTimeLineList, _Component);

		function FeedTimeLineList(props) {
			(0, _classCallCheck3.default)(this, FeedTimeLineList);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedTimeLineList.__proto__ || (0, _getPrototypeOf2.default)(FeedTimeLineList)).call(this, props));

			_this.expandRecord = _this.expandRecord.bind(_this);
			_this.comments = _this.reverseComments();
			_this.state = {
				isExpand: false
			};
			return _this;
		}

		(0, _createClass3.default)(FeedTimeLineList, [{
			key: 'reverseComments',
			value: function reverseComments() {
				if (this.props.feedOperations.total !== 0) {
					this.comments = (0, _extends3.default)([], this.props.feedOperations.comments);
					return this.comments.reverse();
				}
			}

			//展开操作记录信息

		}, {
			key: 'expandRecord',
			value: function expandRecord(e) {
				e.preventDefault();
				this.setState({
					isExpand: !this.state.isExpand
				});
			}

			// 获取渲染内容

		}, {
			key: 'getRenderOpts',
			value: function getRenderOpts() {
				// 处理数据
				var _props = this.props,
				    feedOperations = _props.feedOperations,
				    showBar = _props.showBar,
				    feedId = _props.feedId;
				var isExpand = this.state.isExpand;

				var renderFeedOpts = [];
				var comments = (0, _extends3.default)([], this.comments);
				// 收缩
				if (!isExpand) {
					// 列表页展示最新一条、详情页为最新6条
					comments = comments.slice(0, showBar ? 6 : 1);
				}
				comments[0].active = true;
				comments.map(function (item, index) {
					renderFeedOpts.push(React.createElement(_FeedTimeLineItem2.default, (0, _extends3.default)({ key: feedId + "record" + index }, item)));
				});
				return React.createElement(
					'div',
					null,
					renderFeedOpts
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    showBar = _props2.showBar,
				    feedOperations = _props2.feedOperations,
				    isConcat = _props2.isConcat,
				    translation = _props2.translation;
				var isExpand = this.state.isExpand;

				if (feedOperations.total == 0) {
					return React.createElement(
						'div',
						{ className: 'empty-con' },
						React.createElement('div', { className: 'empty-bgimage' }),
						React.createElement(
							'span',
							{ className: 'empty-text' },
							this.props.emptyTxt || translation.MobileUpaasUI.NoData
						)
					);
				}
				return React.createElement(
					'div',
					{ className: (0, _classnames2.default)('record-list', {
							detail: showBar,
							ml0: isConcat
						}) },
					React.createElement(_FeedTimeLineBar2.default, { total: feedOperations.total, show: showBar,
						translation: translation,
						isExpand: isExpand,
						expandRecord: this.expandRecord }),
					React.createElement(
						'ul',
						{ className: (0, _classnames2.default)('record-list-content', {
								'only-one': !showBar || feedOperations.total == 1
							}) },
						this.getRenderOpts(),
						showBar && feedOperations.total > 6 ? React.createElement(
							'span',
							{ className: (0, _classnames2.default)('show-more', {
									'expand': isExpand
								}), onTouchTap: this.expandRecord },
							isExpand ? translation.MobileUpaasUI.Collapse : translation.MobileUpaasUI.Expand
						) : null
					)
				);
			}
		}]);
		return FeedTimeLineList;
	}(_react.Component);

	exports.default = FeedTimeLineList;
	module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(46);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(92);
	var enumBugKeys = __webpack_require__(53);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(51);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(22);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(232);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ActionButton = function (_Component) {
	  (0, _inherits3.default)(ActionButton, _Component);

	  function ActionButton(props) {
	    (0, _classCallCheck3.default)(this, ActionButton);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionButton.__proto__ || (0, _getPrototypeOf2.default)(ActionButton)).call(this, props));

	    _this.triggerClick = function () {
	      _this.props.onClick();
	    };

	    _this.touchStartX = 0;
	    _this.touchStartY = 0;
	    _this.firstTouch = null;
	    _this.lastTouch = null;
	    _this.touchStartTime = 0;
	    return _this;
	  }

	  (0, _createClass3.default)(ActionButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;

	      this.refs.elRef.addEventListener('touchstart', function (evt) {
	        if (_this2.props.noMove) {
	          evt.preventDefault();
	        }
	        if (_this2.props.disabled) {
	          return;
	        }
	        _this2.touchStartX = evt.touches[0].clientX;
	        _this2.touchStartY = evt.touches[0].clientY;
	        _this2.touchStartTime = Date.now();
	        _this2.firstTouch = _this2.lastTouch = evt.touches[0];
	      });
	      this.refs.elRef.addEventListener('touchmove', function (evt) {
	        if (_this2.props.noMove) {
	          evt.preventDefault();
	        }
	        if (_this2.props.disabled) {
	          return;
	        }
	        _this2.lastTouch = evt.touches[0];
	      });
	      this.refs.elRef.addEventListener('touchend', function (evt) {
	        evt.preventDefault();
	        if (_this2.props.disabled) {
	          return;
	        }
	        var dt = Date.now() - _this2.touchStartTime;
	        if (dt < 1000) {
	          if (_this2.firstTouch === _this2.lastTouch || Math.abs(_this2.lastTouch.clientX - _this2.touchStartX) < 20 && Math.abs(_this2.lastTouch.clientY - _this2.touchStartY) < 20) {
	            _this2.triggerClick();
	          }
	        }
	      });
	      this.refs.elRef.addEventListener('touchcancel', function (evt) {
	        evt.preventDefault();
	      });
	      this.refs.elRef.addEventListener('click', function (evt) {
	        evt.preventDefault();
	        evt.stopImmediatePropagation();
	        evt.stopPropagation();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          children = _props.children,
	          noMove = _props.noMove,
	          onClick = _props.onClick,
	          disabled = _props.disabled,
	          restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'noMove', 'onClick', 'disabled']);

	      var mergedCls = className + ' mobile-replay-action-button';
	      return _react2.default.createElement(
	        'button',
	        (0, _extends3.default)({ className: mergedCls, ref: 'elRef', disabled: disabled }, restProps),
	        children
	      );
	    }
	  }]);
	  return ActionButton;
	}(_react.Component);

	exports.default = ActionButton;
	module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	if (process.env.NODE_ENV !== 'production') {
	  var ReactIs = __webpack_require__(103);

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(281)(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(280)();
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _chaosUi = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(224);

	/*
	 * Name: Feed主体人像部分
	 * Desc: Feed主体人像，任务，项目行都需要
	 * Author: lilei@beisen.com
	 */

	var FeedContentAvatar = function (_Component) {
		(0, _inherits3.default)(FeedContentAvatar, _Component);

		function FeedContentAvatar(props) {
			(0, _classCallCheck3.default)(this, FeedContentAvatar);
			return (0, _possibleConstructorReturn3.default)(this, (FeedContentAvatar.__proto__ || (0, _getPrototypeOf2.default)(FeedContentAvatar)).call(this, props));
		}

		(0, _createClass3.default)(FeedContentAvatar, [{
			key: 'render',
			value: function render() {
				var avatarInfo = this.props.avatarInfo;

				return React.createElement(
					'div',
					{ className: 'feed-content-avatar' },
					React.createElement(_chaosUi.Avatar, (0, _extends3.default)({}, avatarInfo, { scale: 'medium' })),
					React.createElement(
						'span',
						{ className: 'feed-content-name' },
						avatarInfo.Name.slice(0, 3)
					)
				);
			}
		}]);
		return FeedContentAvatar;
	}(_react.Component);

	exports.default = FeedContentAvatar;
	module.exports = exports['default'];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(227);

	/*
	 * Name: Feed主体字段详情
	 * Desc: Feed主体字段详情，根据固定的格式渲染字段
	 * Author: lilei@beisen.com
	 */

	var FeedContentDetail = function (_Component) {
		(0, _inherits3.default)(FeedContentDetail, _Component);

		function FeedContentDetail(props) {
			(0, _classCallCheck3.default)(this, FeedContentDetail);
			return (0, _possibleConstructorReturn3.default)(this, (FeedContentDetail.__proto__ || (0, _getPrototypeOf2.default)(FeedContentDetail)).call(this, props));
		}

		(0, _createClass3.default)(FeedContentDetail, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    detailData = _props.detailData,
				    children = _props.children;

				if (!detailData) {
					return null;
				}
				return React.createElement(
					'ul',
					{ className: 'feed-content-detail' },
					detailData.map(function (item, index) {
						return React.createElement(
							'li',
							{ key: index },
							React.createElement(
								'label',
								null,
								item.name + '：'
							),
							React.createElement(
								'span',
								null,
								item.value
							)
						);
					}),
					children
				);
			}
		}]);
		return FeedContentDetail;
	}(_react.Component);

	exports.default = FeedContentDetail;
	module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _chaosUi = __webpack_require__(8);

	var _index = __webpack_require__(11);

	var _ImagePreviewer = __webpack_require__(67);

	var _ImagePreviewer2 = _interopRequireDefault(_ImagePreviewer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(231);


	var ImageFileRegExp = /(gif|jpg|jpeg|png)$/i;

	/** must match with FeedFileList.scss */
	var availableFileExts = 'doc, docx, pdf, txt, xls, xlsx, ppt, pptx, wma, wmv, rar, zip, exe, flv, mp4, mp3';
	var availableFileTypes = availableFileExts.split(/[,\s]+/g).filter(function (_) {
		return _;
	});

	function getFileTypeClassName(tp) {
		var ext = String(tp).toLocaleLowerCase();
		if (!tp || availableFileTypes.indexOf(ext) === -1) {
			return 'file-type-unknown'; // must match with FeedFileList.scss
		}
		return 'file-type-' + ext; // must match with FeedFileList.scss
	}

	/*
	 * Name: Feed类型1-分享类
	 * Desc: Feed附件预览，主要用于回复和Feed主体中的附件
	 * Author: liuqichao@beisen.com
	 */

	var FeedFileList = function (_Component) {
		(0, _inherits3.default)(FeedFileList, _Component);

		function FeedFileList(props) {
			(0, _classCallCheck3.default)(this, FeedFileList);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedFileList.__proto__ || (0, _getPrototypeOf2.default)(FeedFileList)).call(this, props));

			_this.defaultProps = {
				attachments: [],
				feedId: ''
			};

			_this.showPrewView = _this.showPrewView.bind(_this);
			_this.state = {};
			return _this;
		}

		(0, _createClass3.default)(FeedFileList, [{
			key: 'filePreview',
			value: function filePreview(file) {
				// requestSource=1 在请求DocumentRoute的时候 追加此参数 后端在跳转到doc-cloud时 会在url上追加model=0&viewport 表示附件中不显示导航标题
				var url = (0, _index.urlComplete)(file.previewUrl, null, null, 'requestSource=1');
				// MoleJs import from '@molejs/mole-jssdk'; app提供的sdk
				// 平台已将MoleJs挂到window.env上 如想使用MoleJs中的方法 直接调用window.env即可;
				// 文档：https://wiki.beisen.co/display/paasdev/MoleJS-SDK
				window.env.platform.select({
					beisenApp: function beisenApp() {
						window.env.openNewPage({
							url: url,
							features: {
								screenOrientation: '',
								scaleEnabled: false
							},
							header: {
								show: true
							},
							navBar: {
								options: {
									leftItem: [{
										type: 'back',
										icon: 'm-sys-backward',
										init: true,
										callback: 'handleBack'
									}],
									titleItem: {
										text: file.fileName
									}
								}
							}
						});
					},
					mobile: function mobile() {
						if (window.env.platform.isDingTalk) {
							window.dd.ready(function () {
								window.dd.biz.util.openLink({
									url: url,
									onSuccess: function onSuccess(result) {},
									onFail: function onFail() {}
								});
							});
						} else {
							window.open(url);
						}
					}
				});
			}
		}, {
			key: 'showPrewView',
			value: function showPrewView(evt) {
				evt.stopPropagation();
				evt.preventDefault();

				var attachments = this.props.attachments;


				var index = parseInt(evt.currentTarget.getAttribute('data-index'));
				var file = this.props.attachments[index];
				if (ImageFileRegExp.test(file.fileType)) {
					var urls = attachments.filter(function (atch) {
						return ImageFileRegExp.test(atch.fileType);
					}).map(function (atch) {
						return atch.previewUrl;
					});
					(0, _ImagePreviewer2.default)(urls, null, { start: index });
				} else {
					file.previewUrl && this.filePreview(file);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;

				var attachments = this.props.attachments;

				if (!attachments) {
					return null;
				}
				return React.createElement(
					'div',
					{ className: 'feed-file-list' },
					attachments.map(function (item, index) {
						return React.createElement(
							'div',
							{ className: 'feed-file-item', key: item.documentId, 'data-index': index, onTouchTap: _this2.showPrewView },
							ImageFileRegExp.test(item.fileType) ? React.createElement('img', { className: 'file-type-image', src: item.previewUrl }) : React.createElement('div', { className: getFileTypeClassName(item.fileType) }),
							React.createElement(
								'div',
								{ className: 'feed-file-info' },
								React.createElement(
									'div',
									{ className: 'file-info-name' },
									React.createElement(
										'div',
										{ className: 'file-name' },
										item.fileName.split('.')[0] + '.'
									),
									React.createElement(
										'div',
										{ className: 'extend-name' },
										item.fileType
									)
								),
								React.createElement(
									'div',
									{ className: 'file-size' },
									'(',
									item.size + 'kb',
									')'
								)
							)
						);
					})
				);
			}
		}]);
		return FeedFileList;
	}(_react.Component);

	exports.default = FeedFileList;
	module.exports = exports['default'];

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(180), __esModule: true };

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(21).f;
	var has = __webpack_require__(25);
	var TAG = __webpack_require__(13)('toStringTag');

	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (props) {
	  if (isLocalDebug || isAppVersion460Above()) {
	    return React.createElement(_MobileReply2.default, props);
	  } else {
	    return React.createElement(_ReplyInputFooter_old2.default, props);
	  }
	};

	var _MobileReply = __webpack_require__(126);

	var _MobileReply2 = _interopRequireDefault(_MobileReply);

	var _ReplyInputFooter_old = __webpack_require__(129);

	var _ReplyInputFooter_old2 = _interopRequireDefault(_ReplyInputFooter_old);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var isLocalDebug = false;

	// 取消下面的注释以启用本地调试 ----------------------------------------------------------------------- //
	// import MoleJS from '@molejs/mole-jssdk';
	// window.env = MoleJS;
	// isLocalDebug = true;
	// ----------------------------------------------------------------------- 注释上面的代码以禁用本地调试 //

	window.titaFeedVersion = '0.0.34';

	window.getMoleJS = function () {
	  // Ref: FeedFileList.js
	  // 平台已将MoleJs挂到window.env上 如想使用MoleJs中的方法 直接调用window.env即可;
	  // 文档：https://wiki.beisen.co/display/paasdev/MoleJS-SDK
	  return window.env;
	};

	/**
	 * Check the app is v4.6.0 or above
	 * 4.6.0及以上的版本才有语音输入、选照片这些原生接口，
	 * 所以在4.6.0及以上才启用，否则回退回以前的版本。
	 */
	function isAppVersion460Above() {
	  try {
	    var appVer = window.getMoleJS().version();
	    var cmps = appVer.split(/\D/g).filter(function (_) {
	      return _;
	    }).map(function (d) {
	      return parseInt(d);
	    });
	    if (cmps[0] < 4) {
	      return false;
	    }
	    if (cmps[1] < 6) {
	      return false;
	    }
	    if (cmps[2] < 0) {
	      return false;
	    }
	    return true;
	  } catch (ex) {
	    return false;
	  }
	}

	;
	module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _index = __webpack_require__(11);

	var _chaosUi = __webpack_require__(8);

	var _FeedReplyBar = __webpack_require__(136);

	var _FeedReplyBar2 = _interopRequireDefault(_FeedReplyBar);

	var _FeedReplyItem = __webpack_require__(137);

	var _FeedReplyItem2 = _interopRequireDefault(_FeedReplyItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(256);

	/*
	 * Name: Feed评价列表容器
	 * Desc: 评价容器，按照传入的配置渲染规定数量的回复，
	 * 在列表和详情中评论模式显示分别为3条和6条，在此用固定的常量判定。
	 * author: liuqichao@beisen.com lilei@beisen.com
	 */
	var FeedReplyList = function (_Component) {
		(0, _inherits3.default)(FeedReplyList, _Component);

		function FeedReplyList(props) {
			(0, _classCallCheck3.default)(this, FeedReplyList);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedReplyList.__proto__ || (0, _getPrototypeOf2.default)(FeedReplyList)).call(this, props));

			_this.state = {
				isExpand: false,
				showBottomBtns: false,
				showDeleteTip: false
			};
			_this.expandReply = _this.expandReply.bind(_this);
			_this.getRenderComments = _this.getRenderComments.bind(_this);
			_this.touchCommentItem = _this.touchCommentItem.bind(_this);
			_this.deleteReplyItem = _this.deleteReplyItem.bind(_this);
			_this.touchReply = _this.touchReply.bind(_this);
			_this.getDeleteTipBtns = _this.getDeleteTipBtns.bind(_this);
			_this.cancelDeleteReply = _this.cancelDeleteReply.bind(_this);
			_this.confirmDeleteReply = _this.confirmDeleteReply.bind(_this);
			_this.closeReplyPop = _this.closeReplyPop.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(FeedReplyList, [{
			key: 'closeReplyPop',
			value: function closeReplyPop() {
				this.setState({ showBottomBtns: false });
			}

			// 展开/收起评论

		}, {
			key: 'expandReply',
			value: function expandReply(e) {
				e.preventDefault();
				this.setState({
					isExpand: !this.state.isExpand
				});
			}

			// 获取渲染使用的评论数据

		}, {
			key: 'getRenderComments',
			value: function getRenderComments() {
				var _this2 = this;

				var _props = this.props,
				    comments = _props.comments,
				    isDetail = _props.isDetail,
				    feedId = _props.feedId,
				    translation = _props.translation;
				var isExpand = this.state.isExpand;

				var renderComments = [];
				// 若不展开分割评论数据
				if (!isExpand) {
					comments = comments.slice(0, isDetail ? 6 : 3);
				}
				comments.map(function (item, index) {
					renderComments.push(React.createElement(_FeedReplyItem2.default, (0, _extends3.default)({ key: feedId + "-reply-" + index,
						translation: translation,
						isDetail: isDetail,
						feedId: feedId, touchCommentItem: _this2.touchCommentItem
					}, item)));
				});
				return React.createElement(
					'div',
					null,
					renderComments,
					isDetail && this.props.comments.length > 6 ? React.createElement(
						'span',
						{ className: (0, _classnames2.default)('show-more', {
								'expand': isExpand
							}), onTouchTap: this.expandReply },
						isExpand ? translation.MobileUpaasUI.Collapse : translation.MobileUpaasUI.Expand
					) : null
				);
			}

			// 点击回复内容

		}, {
			key: 'touchCommentItem',
			value: function touchCommentItem(isEdit, replyItem) {
				var _props2 = this.props,
				    isDetail = _props2.isDetail,
				    replyItemFn = _props2.replyItemFn;
				// 若不为详情--跳转至详情页

				if (!isDetail) {
					return;
				}
				// 可编辑--弹出Btn层
				if (isEdit) {
					this.setState({
						showBottomBtns: true,
						replyItem: replyItem
					}, function () {
						try {
							var delBtn = document.querySelector('.feedreplylist-delete-btn');
							var mskEl = delBtn.parentElement.parentElement.parentElement.parentElement.parentElement;
							if (mskEl.getAttribute('data-touchstart-handled') !== '1') {
								mskEl.addEventListener('touchstart', function (evt) {
									if (evt.target === mskEl) {
										evt.preventDefault();
									}
								});
								mskEl.setAttribute('data-touchstart-handled', '1');
							}
						} catch (ex) {}
					});
				} else {
					// 回复此条内容
					replyItemFn(replyItem);
				}
			}

			//点击删除

		}, {
			key: 'deleteReplyItem',
			value: function deleteReplyItem(evt) {
				evt.preventDefault();
				this.setState({
					showDeleteTip: true,
					showBottomBtns: false
				}, function () {
					try {
						var confirmText = document.querySelector('.feedreplylist-confirm-delete-text');
						var delBtn = confirmText.parentElement.parentElement.parentElement.querySelector('.ui-modal-button');
						delBtn.setAttribute('tabindex', '1');
						var mskEl = confirmText.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
						if (mskEl.getAttribute('data-touchstart-handled') !== '1') {
							mskEl.addEventListener('touchstart', function (evt) {
								if (evt.target === mskEl) {
									evt.preventDefault();
								}
							});
							mskEl.setAttribute('data-touchstart-handled', '1');
						}
						delBtn.focus();
					} catch (ex) {}
				});
			}

			/**
	   * 滚动 detail-scroll-content 到底以显示协作组件
	   * detail-scroll-content 是一个滚动的容器，容纳了cloud上所有可滚动的页面
	   */

		}, {
			key: 'tryToScrollDetailScrollContent',
			value: function tryToScrollDetailScrollContent() {
				try {
					var detailScrollContent = document.querySelector('.detail-scroll-content');
					if (!detailScrollContent) {
						return;
					}
					var feedCommentsContainer = document.querySelector('.feed-comments-container');
					if (!feedCommentsContainer) {
						return;
					}
					// dcodsc_and_aofcc = DirectChildOfDetailScrollContentAndAncestorOfFeedCommentsContainer
					var dcodsc_and_aofcc = null;
					var currentEl = feedCommentsContainer;
					while (true) {
						if (!currentEl.parentElement) {
							break;
						}
						if (currentEl.parentElement === detailScrollContent) {
							dcodsc_and_aofcc = currentEl;
							break;
						}
						currentEl = currentEl.parentElement;
					}
					var scrollLastChild = detailScrollContent.childNodes[detailScrollContent.childNodes.length - 1];
					var isLastChild = dcodsc_and_aofcc === scrollLastChild;
					if (isLastChild) {
						detailScrollContent.scrollTop = 100000;
					}
				} catch (ex) {
					console.log('tryToScrollDetailScrollContent: ' + ex);
				}
			}

			//点击回复按钮

		}, {
			key: 'touchReply',
			value: function touchReply(evt, data) {
				var _this3 = this;

				evt.preventDefault && evt.preventDefault();
				// 确定回复的对象（主体或被点击的评论）
				this.setState({
					showBottomBtns: false
				});
				//传入弹出时留存的replyItem
				this.props.replyItemFn(this.state.replyItem);
				setTimeout(function () {
					_this3.tryToScrollDetailScrollContent();
				});
			}

			// 获取删除Tip按钮

		}, {
			key: 'getDeleteTipBtns',
			value: function getDeleteTipBtns() {
				return [{
					text: this.props.translation.DynamicStates.Cancel,
					onTouchTap: this.cancelDeleteReply
				}, {
					text: this.props.translation.DynamicStates.Confirm,
					onTouchTap: this.confirmDeleteReply
				}];
			}

			// 取消删除回复提示

		}, {
			key: 'cancelDeleteReply',
			value: function cancelDeleteReply(e) {
				e.preventDefault && e.preventDefault();
				this.setState({
					showDeleteTip: false,
					showBottomBtns: false
				});
			}

			// 确认删除回复

		}, {
			key: 'confirmDeleteReply',
			value: function confirmDeleteReply() {
				var _this4 = this;

				var afterDeleteComments = this.props.afterDeleteComments;

				var url = (0, _index.urlComplete)('/api/v2/{tenant_id}/{user_id}/comment/Delete');
				// 使用弹出tips前记录的被点击replyItem
				var params = {
					'feed_id': this.props.feedId,
					'comment_id': this.state.replyItem.commentId
				};
				var urlParams = 'feed_id=' + params.feed_id + '&comment_id=' + params.comment_id;
				(0, _index.callFetch)(url + '?' + urlParams, 'DELETE', params).then(function (respData) {
					if (respData.Code == 1) {
						afterDeleteComments();
						_this4.setState({
							isExpand: false,
							showBottomBtns: false,
							showDeleteTip: false
						});
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				// 不使用传入的total，因为刚刚更新回复内容后此数据并不准确，
				// 第二次刷新后才准确，所以直接通过comments判定
				var _props3 = this.props,
				    isDetail = _props3.isDetail,
				    comments = _props3.comments,
				    contentTouchTap = _props3.contentTouchTap,
				    translation = _props3.translation;
				var _state = this.state,
				    isExpand = _state.isExpand,
				    showBottomBtns = _state.showBottomBtns,
				    showDeleteTip = _state.showDeleteTip;

				// 评论统计栏 评论 评论操作按钮遮罩

				return React.createElement(
					'div',
					{ className: 'reply-list', onTouchTap: contentTouchTap },
					React.createElement(_FeedReplyBar2.default, { translation: translation, total: comments.length, isShowMore: isDetail, isExpand: isExpand,
						expandReply: this.expandReply }),
					this.getRenderComments(),
					React.createElement(
						_chaosUi.PopUp,
						{ visible: showBottomBtns, onClose: this.closeReplyPop, style: { bottom: 0 }, animation: 'bottom-slide-fade' },
						React.createElement(
							'div',
							{ className: 'replybtn-list' },
							React.createElement(
								'button',
								{ className: 'reply-button border-1px border-b feedreplylist-delete-btn', onTouchTap: this.deleteReplyItem },
								translation.DynamicStates.Delete
							),
							React.createElement(
								'button',
								{ className: 'reply-button border-1px border-b', onTouchTap: this.touchReply },
								translation.DynamicStates.Reply
							),
							React.createElement(
								_chaosUi.SafeAreaWrap,
								{ safeAreaStyle: { background: '#ffffff' } },
								React.createElement(
									'button',
									{ className: 'reply-button', onTouchTap: this.cancelDeleteReply },
									translation.DynamicStates.Cancel
								)
							)
						)
					),
					React.createElement(_chaosUi.BasicModal, { show: showDeleteTip,
						children: React.createElement(
							'div',
							{ className: 'feedreplylist-confirm-delete-text' },
							translation.DynamicStates.DeleteReplyConfirm
						),
						footer: this.getDeleteTipBtns() })
				);
			}
		}]);
		return FeedReplyList;
	}(_react.Component);

	// shouldComponentUpdate(nextProps ,nextState){
	// 	// return nextState.total != this.state.total || nextState.showBtnList != this.state.showBtnList;
	// }

	// componentWillReceiveProps(nextprops){
	// 	// this.setState({
	// 	// 	comments: nextprops.comments
	// 	// 	,total: nextprops.total
	// 	// });
	// }

	// 目前不确定有父组件引用的comment是否是全部的，若是全部的则此处不需要再次
	//进行加载但某些操作后可能需要整体刷新Feed避免造成脏数据残留
	// showMoreInfo(e){
	// 	let { feedId ,defaultShowLength} = this.props;
	// 	let { total ,comments } = this.state;
	// 	if(total == comments.length && total > defaultShowLength){
	// 		this.setState({
	// 			total
	// 			,comments : comments.slice(comments.length - defaultShowLength)
	// 		});
	// 	}else{
	// 		let url = urlComplete('/api/v2/{tenant_id}/{user_id}/comment/Get');
	// 		let params = {
	// 			feed_id : feedId,
	// 			'comment_type' : 0  //0.普通回复  1.操作记录
	// 		}
	// 		callFetch(url, 'GET', params).then(respData=>{
	// 			this.setState({
	// 				total : respData.Data.total
	// 				,comments : respData.Data.comments
	// 			});
	// 		});
	// 	}
	// }


	exports.default = FeedReplyList;
	module.exports = exports['default'];

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	var document = __webpack_require__(12).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(46);

	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}

	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(20);
	var dPs = __webpack_require__(196);
	var enumBugKeys = __webpack_require__(53);
	var IE_PROTO = __webpack_require__(57)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(52)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(82).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(58)('keys');
	var uid = __webpack_require__(48);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(10);
	var global = __webpack_require__(12);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(38) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(59);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(23);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var core = __webpack_require__(10);
	var LIBRARY = __webpack_require__(38);
	var wksExt = __webpack_require__(63);
	var defineProperty = __webpack_require__(21).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(13);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(202)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(87)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	var ALPHA_INDEX = {
	    '&lt': '<',
	    '&gt': '>',
	    '&quot': '"',
	    '&apos': '\'',
	    '&amp': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&apos;': '\'',
	    '&amp;': '&'
	};

	var CHAR_INDEX = {
	    60: 'lt',
	    62: 'gt',
	    34: 'quot',
	    39: 'apos',
	    38: 'amp'
	};

	var CHAR_S_INDEX = {
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    '\'': '&apos;',
	    '&': '&amp;'
	};

	/**
	 * @constructor
	 */
	function XmlEntities() {}

	/**
	 * @param {String} str
	 * @returns {String}
	 */
	XmlEntities.prototype.encode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    return str.replace(/<|>|"|'|&/g, function(s) {
	        return CHAR_S_INDEX[s];
	    });
	};

	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 XmlEntities.encode = function(str) {
	    return new XmlEntities().encode(str);
	 };

	/**
	 * @param {String} str
	 * @returns {String}
	 */
	XmlEntities.prototype.decode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    return str.replace(/&#?[0-9a-zA-Z]+;?/g, function(s) {
	        if (s.charAt(1) === '#') {
	            var code = s.charAt(2).toLowerCase() === 'x' ?
	                parseInt(s.substr(3), 16) :
	                parseInt(s.substr(2));

	            if (isNaN(code) || code < -32768 || code > 65535) {
	                return '';
	            }
	            return String.fromCharCode(code);
	        }
	        return ALPHA_INDEX[s] || s;
	    });
	};

	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 XmlEntities.decode = function(str) {
	    return new XmlEntities().decode(str);
	 };

	/**
	 * @param {String} str
	 * @returns {String}
	 */
	XmlEntities.prototype.encodeNonUTF = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var c = str.charCodeAt(i);
	        var alpha = CHAR_INDEX[c];
	        if (alpha) {
	            result += "&" + alpha + ";";
	            i++;
	            continue;
	        }
	        if (c < 32 || c > 126) {
	            result += '&#' + c + ';';
	        } else {
	            result += str.charAt(i);
	        }
	        i++;
	    }
	    return result;
	};

	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 XmlEntities.encodeNonUTF = function(str) {
	    return new XmlEntities().encodeNonUTF(str);
	 };

	/**
	 * @param {String} str
	 * @returns {String}
	 */
	XmlEntities.prototype.encodeNonASCII = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLenght = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLenght) {
	        var c = str.charCodeAt(i);
	        if (c <= 255) {
	            result += str[i++];
	            continue;
	        }
	        result += '&#' + c + ';';
	        i++;
	    }
	    return result;
	};

	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 XmlEntities.encodeNonASCII = function(str) {
	    return new XmlEntities().encodeNonASCII(str);
	 };

	module.exports = XmlEntities;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	module.exports = ReactPropTypesSecret;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(22);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	exports.default = preview;

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(24);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _reactTransitionGroup = __webpack_require__(107);

	__webpack_require__(239);

	var _PagedView = __webpack_require__(68);

	var _PagedView2 = _interopRequireDefault(_PagedView);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ImagePreviewer = function (_Component) {
	  (0, _inherits3.default)(ImagePreviewer, _Component);

	  function ImagePreviewer(props) {
	    (0, _classCallCheck3.default)(this, ImagePreviewer);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (ImagePreviewer.__proto__ || (0, _getPrototypeOf2.default)(ImagePreviewer)).call(this, props));

	    _this.onTouchStart = function (revt) {
	      var tch = revt.touches[0];
	      _this.touchStartX = tch.clientX;
	      _this.touchStartY = tch.clientY;
	      _this.touchStartTime = Date.now();
	      _this.firstTouch = _this.lastTouch = tch;
	    };

	    _this.onTouchMove = function (revt) {
	      _this.lastTouch = revt.touches[0];
	    };

	    _this.onTouchEnd = function (revt) {
	      var dt = Date.now() - _this.touchStartTime;
	      if (dt < 1000) {
	        if (_this.firstTouch === _this.lastTouch || Math.abs(_this.lastTouch.clientX - _this.touchStartX) < 20 && Math.abs(_this.lastTouch.clientY - _this.touchStartY) < 20) {
	          _this.triggerClick();
	        }
	      }
	    };

	    _this.triggerClick = function () {
	      var onUnmount = _this.props.onUnmount;

	      _this.setState({
	        visible: false
	      }, function () {
	        setTimeout(function () {
	          onUnmount && onUnmount();
	        }, 300);
	      });
	    };

	    _this.state = {
	      visible: true
	    };
	    _this.el = null;
	    _this.wrapper = null;
	    _this.touchStartX = 0;
	    _this.touchStartY = 0;
	    _this.touchStartTime = 0;
	    _this.lastTouch = null;
	    _this.firstTouch = null;
	    return _this;
	  }

	  (0, _createClass3.default)(ImagePreviewer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;

	      setTimeout(function () {
	        _this2.el = _this2.refs.elRef;
	        _this2.wrapper = _this2.refs.wrapper;
	        _this2.el.focus();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          urls = _props.urls,
	          start = _props.start,
	          onUnmount = _props.onUnmount,
	          restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'urls', 'start', 'onUnmount']);
	      var visible = this.state.visible;

	      var mergedCls = className + ' image-previewer';
	      var bdw = document.body.offsetWidth;
	      return _react2.default.createElement(
	        _reactTransitionGroup.CSSTransition,
	        { classNames: 'image-previewer-anim',
	          timeout: 300, appear: true, 'in': visible },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({ ref: 'elRef', tabIndex: '1000', className: mergedCls }, restProps, {
	            onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove, onTouchEnd: this.onTouchEnd }),
	          _react2.default.createElement(
	            _PagedView2.default,
	            { count: urls.length, page: start, style: { width: '100%', height: '100%' } },
	            _react2.default.createElement(
	              'div',
	              { ref: 'wrapper', className: 'image-previewer-wrapper' },
	              urls.map(function (url, idx) {
	                return _react2.default.createElement('img', { key: idx, src: url, style: { width: bdw } });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ImagePreviewer;
	}(_react.Component);

	ImagePreviewer.defaultProps = {
	  start: 0
	};
	function preview(urls, onClose) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	  var onUnmount = function onUnmount() {
	    document.body.removeChild(el);
	    onClose && onClose();
	  };
	  var el = document.createElement('div');
	  document.body.appendChild(el);
	  _reactDom2.default.render(_react2.default.createElement(ImagePreviewer, { urls: urls, start: options.start || 0, onUnmount: onUnmount }), el);
	}
	module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(22);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(241);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var PagedView = function (_Component) {
	  (0, _inherits3.default)(PagedView, _Component);

	  function PagedView(props) {
	    (0, _classCallCheck3.default)(this, PagedView);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (PagedView.__proto__ || (0, _getPrototypeOf2.default)(PagedView)).call(this, props));

	    _this.handleTouchStart = function (evt) {
	      var preventTouch = _this.props.preventTouch;

	      if (preventTouch) {
	        evt.preventDefault();
	      }
	      _this.isTouchDown = true;
	      var tch = evt.touches[0];
	      _this.touchStartX = tch.clientX;
	      _this.touchStartTx = _this.getWrapperTransformX();
	      _this.lastMoveTime = Date.now();
	      _this.lastDx = 0;
	      _this.lastDt = 0;
	    };

	    _this.handleTouchMove = function (evt) {
	      var preventTouch = _this.props.preventTouch;

	      if (preventTouch) {
	        evt.preventDefault();
	      }
	      var tch = evt.touches[0];
	      var dx = tch.clientX - _this.touchStartX;
	      var dt = Date.now() - _this.lastMoveTime;
	      var tx = _this.touchStartTx + Math.round(dx);
	      _this.setWrapperTransformX(tx);
	      _this.lastMoveTime = Date.now();
	      _this.lastDx = dx;
	      _this.lastDt = dt;
	    };

	    _this.handleTouchEnd = function (evt) {
	      var preventTouch = _this.props.preventTouch;

	      if (preventTouch) {
	        evt.preventDefault();
	      }
	      var count = _this.props.count;

	      _this.isTouchDown = false;
	      var hasValidMove = _this.lastDt > 1 && Math.abs(_this.lastDx) > 10;
	      var velocity = hasValidMove ? _this.lastDx / _this.lastDt : 0;
	      var pg = 0;
	      if (Math.abs(velocity) > 2) {
	        pg = _this.currentPage;
	        if (velocity < -2) {
	          pg += 1;
	        } else if (velocity > 2) {
	          pg -= 1;
	        }
	      } else {
	        pg = _this.tx2roundedPage(_this.getWrapperTransformX());
	      }
	      if (pg < 0) {
	        pg = 0;
	      } else if (pg >= count) {
	        pg = count - 1;
	      }
	      _this.setPage(pg, true);
	    };

	    _this.handleTouchCancel = function (evt) {
	      var preventTouch = _this.props.preventTouch;

	      if (preventTouch) {
	        evt.preventDefault();
	      }
	      _this.setPage(_this.currentPage, true);
	    };

	    _this.setPage = function (pg, animated) {
	      var tx = _this.page2tx(pg);
	      var func = function func() {
	        _this.setWrapperTransformX(tx);
	      };
	      if (_this.setPageAnimTm) {
	        clearTimeout(_this.setPageAnimTm);
	        _this.setPageAnimTm = null;
	        _this.wrapper.style.transition = null;
	      }
	      if (animated) {
	        _this.wrapper.style.transition = 'transform 0.3s';
	        func();
	        _this.setPageAnimTm = setTimeout(function () {
	          _this.setPageAnimTm = null;
	          _this.wrapper.style.transition = null;
	        }, 300);
	      } else {
	        func();
	      }
	      if (pg != _this.currentPage) {
	        if (_this.setPageTm) {
	          clearTimeout(_this.setPageTm);
	        }
	        _this.setPageTm = setTimeout(function () {
	          _this.setPageTm = null;
	          _this.props.onPageChange(pg);
	        }, animated ? 300 : 0);
	      }
	      _this.currentPage = pg;
	    };

	    _this.setWrapperTransformX = function (tx) {
	      _this.wrapper.style.transform = 'translateX(' + tx + 'px)';
	      _this.wrapperTransformX = tx;
	    };

	    _this.getWrapperTransformX = function () {
	      return _this.wrapperTransformX;
	    };

	    _this.tx2roundedPage = function (tx) {
	      var count = _this.props.count;

	      var pg = Math.round(-tx / _this.width);
	      if (pg >= count) {
	        pg = count - 1;
	      }
	      if (pg < 0) {
	        pg = 0;
	      }
	      return pg;
	    };

	    _this.page2tx = function (pg) {
	      var tx = -pg * _this.width;
	      return tx;
	    };

	    _this.el = null;
	    _this.wrapper = null;
	    _this.width = 0;
	    _this.isTouchDown = false;
	    _this.touchStartX = 0;
	    _this.touchStartTx = 0;
	    _this.lastDx = 0;
	    _this.lastMoveTime = 0;
	    _this.lastDt = 0;
	    _this.wrapperTransformX = 0;
	    _this.currentPage = 0;
	    _this.setPageTm = null;
	    _this.setPageAnimTm = null;
	    return _this;
	  }

	  (0, _createClass3.default)(PagedView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          count = _props.count,
	          width = _props.width,
	          page = _props.page;

	      this.el = this.refs.elRef;
	      this.wrapper = this.refs.wrapper;
	      this.width = !width || width === 0 ? this.el.offsetWidth : width;
	      this.wrapper.style.width = count * this.width + 'px';

	      this.setPage(page, false);

	      this.el.addEventListener('touchstart', this.handleTouchStart);
	      this.el.addEventListener('touchmove', this.handleTouchMove);
	      this.el.addEventListener('touchend', this.handleTouchEnd);
	      this.el.addEventListener('touchcancel', this.handleTouchCancel);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.page !== this.props.page) {
	        this.setPage(this.props.page, true);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$className = _props2.className,
	          className = _props2$className === undefined ? '' : _props2$className,
	          children = _props2.children,
	          count = _props2.count,
	          width = _props2.width,
	          page = _props2.page,
	          preventTouch = _props2.preventTouch,
	          onPageChange = _props2.onPageChange,
	          restProps = (0, _objectWithoutProperties3.default)(_props2, ['className', 'children', 'count', 'width', 'page', 'preventTouch', 'onPageChange']);

	      var mergedCls = className + ' paged-view';
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ ref: 'elRef', className: mergedCls }, restProps),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', className: 'paged-view-wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return PagedView;
	}(_react.Component);

	PagedView.defaultProps = {
	  count: 0,
	  width: 0,
	  page: 0,
	  preventTouch: true,
	  onPageChange: function onPageChange(pg) {}
	};
	exports.default = PagedView;
	module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _index = __webpack_require__(11);

	var _EomticonContent = __webpack_require__(132);

	var _EomticonContent2 = _interopRequireDefault(_EomticonContent);

	var _EomticonPagingBar = __webpack_require__(133);

	var _EomticonPagingBar2 = _interopRequireDefault(_EomticonPagingBar);

	var _EomticonTypeTab = __webpack_require__(134);

	var _EomticonTypeTab2 = _interopRequireDefault(_EomticonTypeTab);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(248);

	var Eomticon = function (_Component) {
		(0, _inherits3.default)(Eomticon, _Component);

		function Eomticon(props) {
			(0, _classCallCheck3.default)(this, Eomticon);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Eomticon.__proto__ || (0, _getPrototypeOf2.default)(Eomticon)).call(this, props));

			_this.changeEomticonType = _this.changeEomticonType.bind(_this);
			_this.changeEomticonPage = _this.changeEomticonPage.bind(_this);
			_this.state = {
				eomticonData: [],
				currentType: 0,
				currentPage: 0
			};
			return _this;
		}

		(0, _createClass3.default)(Eomticon, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;

				var url = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/tenant/Eomticon');
				(0, _index.callFetch)(url, 'GET', {}).then(function (respData) {
					var dt = respData.Data.packages.filter(function (pkg) {
						return pkg.name === 'iTalent' || pkg.name === 'tita' || pkg.name === 'meep';
					}).map(function (pkg) {
						// rename tita to iTalent:
						if (pkg.name === 'tita') {
							pkg.name = 'iTalent';
						}
						pkg.emticons = pkg.emticons.map(function (e) {
							e.name = e.name.replace('tita:', 'iTalent:');
							return e;
						});
						return pkg;
					});
					_this2.setState({
						eomticonData: dt
					});
				});

				// this.setState({
				//   eomticonData:eomticon.Data.packages
				// })
			}

			// 切换当前Type下Page

		}, {
			key: 'changeEomticonPage',
			value: function changeEomticonPage(newPageNum) {
				this.setState({
					currentPage: parseInt(newPageNum)
				});
			}
		}, {
			key: 'changeEomticonType',
			value: function changeEomticonType(newTabNum) {
				this.setState({
					currentType: parseInt(newTabNum),
					currentPage: 0
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state,
				    eomticonData = _state.eomticonData,
				    currentType = _state.currentType,
				    currentPage = _state.currentPage;

				if (eomticonData.length == 0) return null;

				var currentTypeData = eomticonData[currentType],
				    eomticonTabCount = Math.ceil(currentTypeData.emticons.length / 20),
				    eomticonTypeData = eomticonData.map(function (item, index) {
					return item.name;
				});
				return React.createElement(
					'div',
					{ className: 'eomticon' },
					React.createElement(_EomticonContent2.default, {
						eomticonData: currentTypeData.emticons,
						eomticonTabCount: eomticonTabCount,
						eomticonHost: currentTypeData.host,
						currentPage: currentPage,
						changeEomticonPage: this.changeEomticonPage,
						inputEomticon: this.props.inputEomticon,
						deleteEomticon: this.props.deleteEomticon
					}),
					React.createElement(_EomticonPagingBar2.default, {
						currentPage: currentPage,
						eomticonTabCount: eomticonTabCount,
						changeEomticonPage: this.changeEomticonPage
					}),
					React.createElement(_EomticonTypeTab2.default, {
						currentType: currentType,
						eomticonTypeData: eomticonTypeData,
						changeEomticonType: this.changeEomticonType
					})
				);
			}
		}]);
		return Eomticon;
	}(_react.Component);

	exports.default = Eomticon;
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(253);

	var FeedOptBar = function (_Component) {
		(0, _inherits3.default)(FeedOptBar, _Component);

		function FeedOptBar(props) {
			(0, _classCallCheck3.default)(this, FeedOptBar);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedOptBar.__proto__ || (0, _getPrototypeOf2.default)(FeedOptBar)).call(this, props));

			_this.onTouchTap = _this.onTouchTap.bind(_this);
			_this.focusReplyInput = _this.focusReplyInput.bind(_this);
			_this.state = {
				btnListLeft: '100%',
				isTouchComment: false
			};
			return _this;
		}

		(0, _createClass3.default)(FeedOptBar, [{
			key: 'onTouchTap',
			value: function onTouchTap(e) {
				e.preventDefault();
				this.setState({
					btnListLeft: this.state.btnListLeft === '80%' ? '100%' : '80%'
				});
			}
		}, {
			key: 'focusReplyInput',
			value: function focusReplyInput(e) {
				e.preventDefault();
				var feedId = this.props.feedId;

				this.props.focusReplyInput(feedId);
				this.setState({
					btnListLeft: '100%'
				});
			}
		}, {
			key: 'render',
			value: function render() {
				/*<li className='bar-btn-reward'>打赏</li>
	   	<li className='bar-btn-to-reward'>讨赏</li>
	   	<li className='bar-btn-collect'>收藏</li>*/
				var _state = this.state,
				    btnListLeft = _state.btnListLeft,
				    isTouchComment = _state.isTouchComment;
				var hideComments = this.props.hideComments;

				if (hideComments == true) {
					return null;
				}
				return React.createElement(
					'div',
					{ className: 'feed-opt-bar' },
					React.createElement(
						'div',
						{ className: 'feed-opt-bar-content' },
						React.createElement(
							'ul',
							{ className: 'bar-btn-list', style: { left: btnListLeft } },
							React.createElement(
								'li',
								{ className: 'bar-btn-comment', onTouchTap: this.focusReplyInput },
								'\u8BC4\u8BBA'
							)
						)
					),
					React.createElement('div', { className: 'feed-bar-btn', onTouchTap: this.onTouchTap })
				);
			}
		}]);
		return FeedOptBar;
	}(_react.Component);

	exports.default = FeedOptBar;
	module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(257);
	/*
	 * Name: 时间线顶层统计栏
	 * Desc: 时间线顶层统计栏
	 * author: lilei@beisen.com
	 */

	var FeedTimeLineBar = function (_Component) {
		(0, _inherits3.default)(FeedTimeLineBar, _Component);

		function FeedTimeLineBar(props) {
			(0, _classCallCheck3.default)(this, FeedTimeLineBar);
			return (0, _possibleConstructorReturn3.default)(this, (FeedTimeLineBar.__proto__ || (0, _getPrototypeOf2.default)(FeedTimeLineBar)).call(this, props));
		}

		(0, _createClass3.default)(FeedTimeLineBar, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    show = _props.show,
				    total = _props.total,
				    isExpand = _props.isExpand,
				    expandRecord = _props.expandRecord,
				    translation = _props.translation;

				if (!show) {
					return null;
				}
				return React.createElement(
					'div',
					{ className: 'record-total' },
					React.createElement(
						'span',
						{ className: 'record-total-text' },
						translation.MobileUpaasUI.SimpleFeedTabOperation,
						' ',
						total
					)
				);
			}
		}]);
		return FeedTimeLineBar;
	}(_react.Component);

	exports.default = FeedTimeLineBar;
	module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _xmlEntities = __webpack_require__(65);

	var _xmlEntities2 = _interopRequireDefault(_xmlEntities);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(258);

	/*
	 * Name: 时间线子组件
	 * Desc: 时间线子组件
	 * author: liuqichao@beisen.com
	 */
	var FeedTimeLineItem = function (_Component) {
		(0, _inherits3.default)(FeedTimeLineItem, _Component);

		function FeedTimeLineItem(props) {
			(0, _classCallCheck3.default)(this, FeedTimeLineItem);
			return (0, _possibleConstructorReturn3.default)(this, (FeedTimeLineItem.__proto__ || (0, _getPrototypeOf2.default)(FeedTimeLineItem)).call(this, props));
		}

		(0, _createClass3.default)(FeedTimeLineItem, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    active = _props.active,
				    content = _props.content,
				    publishUser = _props.publishUser,
				    createTime = _props.createTime;

				var date = createTime.split(' ');
				date = date[0].split('/').slice(-2).join('/') + ' ' + date[1];
				return React.createElement(
					'li',
					{ className: (0, _classnames2.default)('record-item', { 'active-state': active }) },
					React.createElement('span', { className: 'record-state' }),
					React.createElement(
						'div',
						{ className: 'record-right' },
						React.createElement(
							'span',
							{ className: 'record-time' },
							date
						),
						React.createElement(
							'span',
							{ className: 'record-content' },
							publishUser.name + "：" + _xmlEntities2.default.decode(content)
						)
					)
				);
			}
		}]);
		return FeedTimeLineItem;
	}(_react.Component);

	exports.default = FeedTimeLineItem;
	module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(262);

	/*
	 * Name: Feed标题文本
	 * Desc: 根据传入的数组行textData拼接标题文本，保证各文本宽度自适
	 * 应，首位文本超长时不影响其余文本且自动缩略，偶数为灰色文本等。
	 * Author: lilei@beisen.com
	 */

	var FeedTitleText = function (_Component) {
		(0, _inherits3.default)(FeedTitleText, _Component);

		function FeedTitleText(props) {
			(0, _classCallCheck3.default)(this, FeedTitleText);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedTitleText.__proto__ || (0, _getPrototypeOf2.default)(FeedTitleText)).call(this, props));

			_this.getTitleTxt = _this.getTitleTxt.bind(_this);
			return _this;
		}

		// 根据传入的数据拼接Title文本


		(0, _createClass3.default)(FeedTitleText, [{
			key: 'getTitleTxt',
			value: function getTitleTxt(textData) {
				var titles = [];
				textData.map(function (item, index) {
					titles.push(React.createElement(
						'li',
						{ key: index, className: 'feed-title-text' },
						item
					));
				});
				return titles;
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    textData = _props.textData,
				    preWidth = _props.preWidth,
				    isContentTitle = _props.isContentTitle;

				var contentWidth = window.innerWidth - (preWidth || 80);
				return React.createElement(
					'div',
					{ className: (0, _classnames2.default)('feed-title-text-content', {
							'content-title': isContentTitle
						}), style: { width: contentWidth + 'px' } },
					React.createElement(
						'ul',
						null,
						this.getTitleTxt(textData)
					)
				);
			}
		}]);
		return FeedTitleText;
	}(_react.Component);

	exports.default = FeedTitleText;
	module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _from = __webpack_require__(78);

	var _from2 = _interopRequireDefault(_from);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(264);

	/*
	 * Name: 任务、日报 评价组件
	 * Desc: 默认显示展示状态的组件
	 * Author: liuqichao@beisen.com lilei@beisen.com
	 */

	var FeedEvaluation = function (_Component) {
		(0, _inherits3.default)(FeedEvaluation, _Component);

		function FeedEvaluation(props) {
			(0, _classCallCheck3.default)(this, FeedEvaluation);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedEvaluation.__proto__ || (0, _getPrototypeOf2.default)(FeedEvaluation)).call(this, props));

			_this.defaultProps = {
				lvl: 5
			};
			return _this;
		}

		(0, _createClass3.default)(FeedEvaluation, [{
			key: 'getStarEval',
			value: function getStarEval() {
				var _props = this.props,
				    goal = _props.goal,
				    value = _props.value,
				    _props$lvl = _props.lvl,
				    lvl = _props$lvl === undefined ? 5 : _props$lvl;

				var data = new Array(lvl);

				return (0, _from2.default)(data).map(function (item, index) {

					if (Number(value) >= goal * (index + 1)) {
						return React.createElement('span', { className: 'eval-star-active', key: index });
					} else {
						return React.createElement('span', { className: 'eval-star-normal', key: index });
					}
				});
			}
		}, {
			key: 'getMedalEval',
			value: function getMedalEval() {
				var _props2 = this.props,
				    value = _props2.value,
				    name = _props2.name;

				return React.createElement(
					'span',
					{ className: 'medal-grade-' + value },
					React.createElement('i', { className: 'medal-grade-' + value }),
					name
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props3 = this.props,
				    type = _props3.type,
				    value = _props3.value;

				var evalView = '',
				    evaltext = '';
				if (type == 1) {
					evalView = this.getStarEval();
					evaltext = React.createElement(
						'span',
						{ className: 'eval-text' },
						value + "分"
					);
				} else if (type == 2) {
					evalView = this.getMedalEval();
				}
				return React.createElement(
					'div',
					{ className: 'eval-container' },
					evalView,
					evaltext
				);
			}
		}]);
		return FeedEvaluation;
	}(_react.Component);

	exports.default = FeedEvaluation;
	module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _index = __webpack_require__(11);

	var _index2 = __webpack_require__(77);

	var _index3 = _interopRequireDefault(_index2);

	var _index4 = __webpack_require__(70);

	var _index5 = _interopRequireDefault(_index4);

	var _FeedReplyList = __webpack_require__(50);

	var _FeedReplyList2 = _interopRequireDefault(_FeedReplyList);

	var _ReplyInputFooter = __webpack_require__(49);

	var _ReplyInputFooter2 = _interopRequireDefault(_ReplyInputFooter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(267);

	/*
	 * Name: SimpleFeedDetail
	 * Desc: 详情主体，拆分出来主要用于单纯需要使用Feed部分的页，不需要包含头部
	 * author: lilei@beisen.com
	 */

	var SimpleFeedDetail = function (_Component) {
		(0, _inherits3.default)(SimpleFeedDetail, _Component);

		function SimpleFeedDetail(props) {
			(0, _classCallCheck3.default)(this, SimpleFeedDetail);

			var _this = (0, _possibleConstructorReturn3.default)(this, (SimpleFeedDetail.__proto__ || (0, _getPrototypeOf2.default)(SimpleFeedDetail)).call(this, props));

			_this.state = {
				feedType: null,
				isFocusInput: false,
				replyItem: null,
				feedComments: {
					comments: [],
					total: 0
				}
			};
			_this.setFeedDetailData = _this.setFeedDetailData.bind(_this);
			_this.focusReplyInput = _this.focusReplyInput.bind(_this);
			_this.replyItemFn = _this.replyItemFn.bind(_this);
			_this.afterDeleteComments = _this.afterDeleteComments.bind(_this);
			_this.afterSaveComments = _this.afterSaveComments.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(SimpleFeedDetail, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setFeedDetailData();
			}

			// 注入Feed详情数据

		}, {
			key: 'setFeedDetailData',
			value: function setFeedDetailData() {
				var _this2 = this;

				var url = (0, _index.urlComplete)('/api/v2/{tenant_id}/{user_id}/user/feed/GetById');
				var params = {
					feed_id: this.props.feedId,
					'comment_count': 99
				};
				(0, _index.callFetch)(url, 'GET', params).then(function (respData) {
					_this2.props.getEdit(respData.Data.isEdit); // 是否可以删除 
					_this2.setState(respData.Data);
				});
			}

			// 聚焦输入栏数据框，弹出键盘

		}, {
			key: 'focusReplyInput',
			value: function focusReplyInput() {
				this.setState({
					isFocusInput: true
				});
			}

			// 回复

		}, {
			key: 'replyItemFn',
			value: function replyItemFn(replyItem) {
				this.setState({
					replyItem: replyItem
				});
			}

			// 删除回复后 重新渲染FeedDetail

		}, {
			key: 'afterDeleteComments',
			value: function afterDeleteComments() {
				this.setFeedDetailData();
			}

			// 重新渲染

		}, {
			key: 'afterSaveComments',
			value: function afterSaveComments() {
				this.setFeedDetailData();
			}
		}, {
			key: 'render',
			value: function render() {
				// 获取数据
				var _state = this.state,
				    feedType = _state.feedType,
				    feedComments = _state.feedComments,
				    replyItem = _state.replyItem,
				    isFocusInput = _state.isFocusInput;
				var hideComments = this.props.hideComments;
				// 判定FeedType，确定渲染的内容主页

				if (!feedType) {
					return null;
				}
				var FeedMain = _index3.default[feedType];
				// 获取除底部回复工具栏（高47）外内容高度，设定滚动使用
				var detailHeight = window.innerHeight - 47;
				// 主体 工具栏 回复/评价列表 回复工具栏
				return React.createElement(
					'div',
					{ className: 'feed-detail', style: { height: detailHeight } },
					React.createElement(FeedMain, (0, _extends3.default)({}, this.state, { isDetail: true })),
					React.createElement(_index5.default, { focusReplyInput: this.focusReplyInput, hideComments: hideComments }),
					feedComments.comments && hideComments != true ? React.createElement(
						'div',
						{ className: 'reply-container detail' },
						React.createElement(_FeedReplyList2.default, (0, _extends3.default)({}, feedComments, {
							isDetail: true,
							replyItemFn: this.replyItemFn,
							afterDeleteComments: this.afterDeleteComments }))
					) : null,
					hideComments != true ? React.createElement(_ReplyInputFooter2.default, {
						isFocusInput: isFocusInput,
						feedId: this.props.feedId,
						replyPerson: replyItem,
						isDetail: true,
						afterSave: this.afterSaveComments
					}) : null
				);
			}
		}]);
		return SimpleFeedDetail;
	}(_react.Component);

	exports.default = SimpleFeedDetail;
	module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _index = __webpack_require__(11);

	var _chaosUi = __webpack_require__(8);

	var _FeedListItem = __webpack_require__(145);

	var _FeedListItem2 = _interopRequireDefault(_FeedListItem);

	var _ReplyInputFooter = __webpack_require__(49);

	var _ReplyInputFooter2 = _interopRequireDefault(_ReplyInputFooter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(269);

	/*
	 * Name: SimpleFeedList
	 * Desc: 单一FeedList，仅有列表部分，传入Type等参数即可查询
	 * author: lilei@beisen.com
	 */

	var SimpleFeedList = function (_Component) {
		(0, _inherits3.default)(SimpleFeedList, _Component);

		function SimpleFeedList(props) {
			(0, _classCallCheck3.default)(this, SimpleFeedList);

			var _this = (0, _possibleConstructorReturn3.default)(this, (SimpleFeedList.__proto__ || (0, _getPrototypeOf2.default)(SimpleFeedList)).call(this, props));

			_this.setFeedListData = _this.setFeedListData.bind(_this);
			_this.focusReplyInput = _this.focusReplyInput.bind(_this);
			_this.afterSaveComments = _this.afterSaveComments.bind(_this);
			_this.hideInputFooter = _this.hideInputFooter.bind(_this);
			_this.onListScroll = _this.onListScroll.bind(_this);
			_this.state = {
				feeds: null,
				isFocusInput: false,
				feedId: null
			};
			_this.loadFeed = true;
			_this.feedCount = 20;
			return _this;
		}

		(0, _createClass3.default)(SimpleFeedList, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setFeedListData();
			}

			// 注入列表数据

		}, {
			key: 'setFeedListData',
			value: function setFeedListData() {
				var _this2 = this;

				var type = this.props.type;

				var url = (0, _index.urlComplete)('/api/v2/{tenant_id}/{user_id}/user/feed/Get');
				var params = {
					'type': type,
					'start': 0,
					'feed_count': this.feedCount,
					'comment_count': 99,
					'to_user_id': BSGlobal.loginUserInfo.Id
				};
				(0, _index.callFetch)(url, 'GET', params).then(function (respData) {
					_this2.loadFeed = true;
					respData.Data.isFocusInput = false;
					_this2.setState(respData.Data);
				});
			}

			// 聚焦输入栏数据框，弹出键盘

		}, {
			key: 'focusReplyInput',
			value: function focusReplyInput(feedId) {
				this.setState({
					isFocusInput: true,
					feedId: feedId
				});
			}

			// 组装Feed列表

		}, {
			key: 'getFeedList',
			value: function getFeedList() {
				var _this3 = this;

				var feeds = this.state.feeds;
				var hideComments = this.props.hideComments;

				var feedList = [];
				feeds.map(function (item, index) {
					item.hideComments = hideComments;
					feedList.push(React.createElement(_FeedListItem2.default, (0, _extends3.default)({}, item, { key: index,
						focusReplyInput: _this3.focusReplyInput,
						hideInputFooter: _this3.hideInputFooter })));
				});
				return feedList;
			}

			// 重新渲染

		}, {
			key: 'afterSaveComments',
			value: function afterSaveComments() {
				this.setFeedListData();
			}

			// 触发关闭回复栏

		}, {
			key: 'hideInputFooter',
			value: function hideInputFooter(feedId) {
				// 判定是否跳转至详情页
				if (this.state.isFocusInput === false) {
					window.location.hash = this.props.detailHash + feedId;
				}
				this.setState({
					isFocusInput: false
				});
			}

			// 滚动加载

		}, {
			key: 'onListScroll',
			value: function onListScroll(e) {
				e.preventDefault();
				// 滚动到底条件
				var feedList = e.target;
				if (feedList.scrollTop + feedList.clientHeight == feedList.scrollHeight) {
					if (this.loadFeed == true) {
						//加载
						this.feedCount += 20;
						this.setFeedListData();
					}
					this.loadFeed = false;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state,
				    feeds = _state.feeds,
				    isFocusInput = _state.isFocusInput,
				    feedId = _state.feedId;
				var hideComments = this.props.hideComments;

				if (!feeds) return null;
				// 获取除底部回复工具栏（高47）外内容高度，设定滚动使用
				var listHeight = window.innerHeight - (isFocusInput ? 47 : 0);

				return React.createElement(
					_chaosUi.Content,
					null,
					React.createElement(
						'ul',
						{ className: 'feed-list', style: { height: listHeight },
							onScroll: this.onListScroll },
						this.getFeedList()
					),
					isFocusInput && hideComments != true ? React.createElement(_ReplyInputFooter2.default, {
						isFocusInput: true, replyInfo: { feedId: feedId },
						afterSave: this.afterSaveComments }) : null
				);
			}
		}]);
		return SimpleFeedList;
	}(_react.Component);

	exports.default = SimpleFeedList;
	module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _FeedType = __webpack_require__(147);

	var _FeedType2 = _interopRequireDefault(_FeedType);

	var _FeedType3 = __webpack_require__(149);

	var _FeedType4 = _interopRequireDefault(_FeedType3);

	var _FeedType5 = __webpack_require__(151);

	var _FeedType6 = _interopRequireDefault(_FeedType5);

	var _FeedType7 = __webpack_require__(152);

	var _FeedType8 = _interopRequireDefault(_FeedType7);

	var _FeedType9 = __webpack_require__(153);

	var _FeedType10 = _interopRequireDefault(_FeedType9);

	var _FeedType11 = __webpack_require__(155);

	var _FeedType12 = _interopRequireDefault(_FeedType11);

	var _FeedType13 = __webpack_require__(148);

	var _FeedType14 = _interopRequireDefault(_FeedType13);

	var _FeedType15 = __webpack_require__(150);

	var _FeedType16 = _interopRequireDefault(_FeedType15);

	var _FeedType17 = __webpack_require__(154);

	var _FeedType18 = _interopRequireDefault(_FeedType17);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// 公共样式

	// 任务 

	// 快速审批

	// 标准考核

	// 绩效管理--新增目标
	__webpack_require__(275);
	// 签到 

	// 项目新建

	// 应用类

	// 标准考核
	/**
	 * Name: FeedTypeMap
	 * Desc: 根据feedType判断显示主要内容
	 * Author: liuqichao@beisen.com
	 */

	// 分享的Feed


	var FeedTypeMap = {
		1: _FeedType2.default,
		2: _FeedType4.default,
		5: _FeedType6.default,
		7: _FeedType8.default,
		8: _FeedType10.default,
		9: _FeedType12.default,
		10: _FeedType14.default,
		20: _FeedType16.default,
		80: _FeedType18.default
	};
	exports.default = FeedTypeMap;
	module.exports = exports['default'];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(171), __esModule: true };

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(177), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _iterator = __webpack_require__(169);

	var _iterator2 = _interopRequireDefault(_iterator);

	var _symbol = __webpack_require__(168);

	var _symbol2 = _interopRequireDefault(_symbol);

	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(36);
	var TAG = __webpack_require__(13)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(12).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(16) && !__webpack_require__(32)(function () {
	  return Object.defineProperty(__webpack_require__(52)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(36);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(37);
	var ITERATOR = __webpack_require__(13)('iterator');
	var ArrayProto = Array.prototype;

	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(20);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(38);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(96);
	var hide = __webpack_require__(26);
	var Iterators = __webpack_require__(37);
	var $iterCreate = __webpack_require__(191);
	var setToStringTag = __webpack_require__(47);
	var getPrototypeOf = __webpack_require__(91);
	var ITERATOR = __webpack_require__(13)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(13)('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(39);
	var createDesc = __webpack_require__(40);
	var toIObject = __webpack_require__(27);
	var toPrimitive = __webpack_require__(61);
	var has = __webpack_require__(25);
	var IE8_DOM_DEFINE = __webpack_require__(83);
	var gOPD = Object.getOwnPropertyDescriptor;

	exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(92);
	var hiddenKeys = __webpack_require__(53).concat('length', 'prototype');

	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(25);
	var toObject = __webpack_require__(34);
	var IE_PROTO = __webpack_require__(57)('IE_PROTO');
	var ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(25);
	var toIObject = __webpack_require__(27);
	var arrayIndexOf = __webpack_require__(185)(false);
	var IE_PROTO = __webpack_require__(57)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(14);
	var core = __webpack_require__(10);
	var fails = __webpack_require__(32);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(23);
	var newPromiseCapability = __webpack_require__(54);

	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(26);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(20);
	var aFunction = __webpack_require__(46);
	var SPECIES = __webpack_require__(13)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(31);
	var invoke = __webpack_require__(189);
	var html = __webpack_require__(82);
	var cel = __webpack_require__(52);
	var global = __webpack_require__(12);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(36)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(81);
	var ITERATOR = __webpack_require__(13)('iterator');
	var Iterators = __webpack_require__(37);
	module.exports = __webpack_require__(10).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(206);
	var global = __webpack_require__(12);
	var hide = __webpack_require__(26);
	var Iterators = __webpack_require__(37);
	var TO_STRING_TAG = __webpack_require__(13)('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';

	if (process.env.NODE_ENV === 'production') {
	  module.exports = __webpack_require__(283);
	} else {
	  module.exports = __webpack_require__(282);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', { value: true });

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}

	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}

	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}

	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;

	function polyfill(Component) {
	  var prototype = Component.prototype;

	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }

	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }

	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';

	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }

	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }

	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }

	    prototype.componentWillUpdate = componentWillUpdate;

	    var componentDidUpdate = prototype.componentDidUpdate;

	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;

	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }

	  return Component;
	}

	exports.polyfill = polyfill;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";

	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

	var PropTypes = _interopRequireWildcard(__webpack_require__(41));

	var _react = _interopRequireDefault(__webpack_require__(1));

	var _reactDom = _interopRequireDefault(__webpack_require__(24));

	var _reactLifecyclesCompat = __webpack_require__(104);

	var _PropTypes = __webpack_require__(108);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */

	exports.EXITING = EXITING;

	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);

	  function Transition(props, context) {
	    var _this;

	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;

	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }

	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }

	  var _proto = Transition.prototype;

	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions

	    };
	  };

	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;

	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }

	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }


	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };

	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;

	    if (prevProps !== this.props) {
	      var status = this.state.status;

	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }

	    this.updateStatus(false, nextStatus);
	  };

	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };

	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;

	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major

	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }

	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };

	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }

	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();

	      var node = _reactDom.default.findDOMNode(this);

	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };

	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;

	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set

	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }

	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);

	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };

	  _proto.performExit = function performExit(node) {
	    var _this3 = this;

	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }

	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);

	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };

	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };

	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };

	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;

	    var active = true;

	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };

	    this.nextCallback.cancel = function () {
	      active = false;
	    };

	    return this.nextCallback;
	  };

	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }

	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }

	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };

	  _proto.render = function render() {
	    var status = this.state.status;

	    if (status === UNMOUNTED) {
	      return null;
	    }

	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;

	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }

	    var child = _react.default.Children.only(children);

	    return _react.default.cloneElement(child, childProps);
	  };

	  return Transition;
	}(_react.default.Component);

	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes = process.env.NODE_ENV !== "production" ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,

	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,

	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,

	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,

	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,

	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,

	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;

	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    return pt.apply(void 0, [props].concat(args));
	  },

	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,

	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,

	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,

	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,

	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,

	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,

	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation

	} : {};

	function noop() {}

	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;

	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

	exports.default = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";

	exports.__esModule = true;
	exports.default = void 0;

	var _propTypes = _interopRequireDefault(__webpack_require__(41));

	var _react = _interopRequireDefault(__webpack_require__(1));

	var _reactLifecyclesCompat = __webpack_require__(104);

	var _ChildMapping = __webpack_require__(286);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};

	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */

	};

	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);

	  function TransitionGroup(props, context) {
	    var _this;

	    _this = _React$Component.call(this, props, context) || this;

	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }

	  var _proto = TransitionGroup.prototype;

	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };

	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };

	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };

	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };

	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;

	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }

	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);

	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };

	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;

	    if (Component === null) {
	      return children;
	    }

	    return _react.default.createElement(Component, props, children);
	  };

	  return TransitionGroup;
	}(_react.default.Component);

	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,

	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,

	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,

	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,

	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,

	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;

	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

	exports.default = _default;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var _CSSTransition = _interopRequireDefault(__webpack_require__(284));

	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(285));

	var _TransitionGroup = _interopRequireDefault(__webpack_require__(106));

	var _Transition = _interopRequireDefault(__webpack_require__(105));

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";

	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;

	var _propTypes = _interopRequireDefault(__webpack_require__(41));

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var timeoutsShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}

	module.exports = _interopRequireDefault;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.index = factory());
	}(this, (function () { 'use strict';

	  var hostAlias = {
	      tm: 'tm',
	      italent: 'www',
	      cloud: 'cloud',
	      setting: 'setting',
	      ocean: 'ocean',
	      account: 'account',
	      biset: 'biset',
	      appcenter: 'appcenter',
	      robot: 'robot',
	      operationCloud: 'operation-cloud',
	      appstore: 'appstore',
	      approval: 'approval',
	      tms: 'tms',
	      devCloud: 'dev-cloud',
	      settingCloud: 'setting-cloud',
	      docCloud: 'doc-cloud',
	      landingsite: 'landingsite',
	      service: 'service',
	  };

	  function warining(msg) {
	      if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
	          throw TypeError("\u3010@beisen/helper\u3011:" + msg);
	      }
	      return window.console && window.console.warn("\u3010@beisen/helper\u3011:" + msg);
	  }

	  var Utils = {
	      // 私有 拼接host
	      generateHost: function (host, domain) {
	          return "//" + host + "." + domain;
	      },
	      getBSGlobal: function (key, defaultValue) {
	          return BSGlobal[key] || defaultValue;
	      },
	      getEnv: function () {
	          return this.getBSGlobal('env', 'production');
	      },
	      getBSGlobalDomain: function () {
	          var domain = this.getBSGlobal('domain');
	          if (!domain || typeof domain !== 'string') {
	              return warining('请检查BSGlobal.domain是否存在或者是否为string类型!');
	          }
	          return domain;
	      },
	      getBSGlobalEnv: function () {
	          var env = this.getBSGlobal('env', 'production');
	          if (!env || typeof env !== 'string') {
	              return warining('请检查BSGlobal.env是否存在或者是否为string类型!');
	          }
	          return env;
	      },
	  };

	  var index = {
	      // 登录人信息
	      getUserInfo: function () {
	          return Utils.getBSGlobal('loginUserInfo');
	      },
	      // 租户信息
	      getTenantInfo: function () {
	          return Utils.getBSGlobal('tenantInfo');
	      },
	      // 用户id
	      getUserId: function () {
	          var userInfo = this.getUserInfo();
	          return userInfo.Id || userInfo.id || userInfo.UserId;
	      },
	      // 租户id
	      getTenantId: function () {
	          var tenant = this.getTenantInfo();
	          return tenant.Id || tenant.tenant_id || tenant.tenantId;
	      },
	      // 生成域名
	      generateHost: function (host) {
	          var domain = Utils.getBSGlobalDomain();
	          if (!domain) {
	              return;
	          }
	          return Utils.generateHost(host, domain);
	      },
	      // 获取平台域名
	      getHostByType: function (type) {
	          if (type === void 0) { type = 'cloud'; }
	          var domain = Utils.getBSGlobalDomain();
	          if (!domain) {
	              return;
	          }
	          var host = hostAlias[type];
	          if (!host) {
	              return warining("\u8BF7\u786E\u8BA4type\u4E3A" + type + "\u662F\u5426\u5408\u6CD5");
	          }
	          return Utils.generateHost(host, domain);
	      },
	      env: {
	          isDevelopment: function () {
	              var env = Utils.getBSGlobalEnv();
	              return /development/ig.test(env) || /develop/ig.test(env);
	          },
	          isTesting: function () {
	              var env = Utils.getBSGlobalEnv();
	              return /testing/ig.test(env) || /test/ig.test(env);
	          },
	          isProduction: function () {
	              return /production/ig.test(Utils.getBSGlobalEnv());
	          }
	      },
	  };

	  return index;

	})));
	//# sourceMappingURL=helper.umd.js.map

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	!function(){"use strict";var e=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t};var o={type:"logger",log:function(t){this.output("log",t)},warn:function(t){this.output("warn",t)},error:function(t){this.output("error",t)},output:function(t,e){var n;console&&console[t]&&(n=console)[t].apply(n,function(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}(e))}},s=new(function(){function n(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,n),this.init(t,e)}return n.prototype.init=function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};this.prefix=e.prefix||"i18next:",this.logger=t||o,this.options=e,this.debug=e.debug},n.prototype.setDebug=function(t){this.debug=t},n.prototype.log=function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];return this.forward(e,"log","",!0)},n.prototype.warn=function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];return this.forward(e,"warn","",!0)},n.prototype.error=function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];return this.forward(e,"error","")},n.prototype.deprecate=function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];return this.forward(e,"warn","WARNING DEPRECATED: ",!0)},n.prototype.forward=function(t,e,n,o){return o&&!this.debug?null:("string"==typeof t[0]&&(t[0]=""+n+this.prefix+" "+t[0]),this.logger[e](t))},n.prototype.create=function(t){return new n(this.logger,e({prefix:this.prefix+":"+t+":"},this.options))},n}());var t=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.observers={}}return t.prototype.on=function(t,e){var n=this;return t.split(" ").forEach(function(t){n.observers[t]=n.observers[t]||[],n.observers[t].push(e)}),this},t.prototype.off=function(e,n){var o=this;this.observers[e]&&this.observers[e].forEach(function(){if(n){var t=o.observers[e].indexOf(n);-1<t&&o.observers[e].splice(t,1)}else delete o.observers[e]})},t.prototype.emit=function(e){for(var t=arguments.length,n=Array(1<t?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];this.observers[e]&&[].concat(this.observers[e]).forEach(function(t){t.apply(void 0,n)});this.observers["*"]&&[].concat(this.observers["*"]).forEach(function(t){t.apply(t,[e].concat(n))})},t}();function f(t){return null==t?"":""+t}function p(t,e,n){function o(t){return t&&-1<t.indexOf("###")?t.replace(/###/g,"."):t}function i(){return!t||"string"==typeof t}for(var r="string"!=typeof e?[].concat(e):e.split(".");1<r.length;){if(i())return{};var a=o(r.shift());!t[a]&&n&&(t[a]=new n),t=t[a]}return i()?{}:{obj:t,k:o(r.shift())}}function l(t,e,n){var o=p(t,e,Object);o.obj[o.k]=n}function h(t,e){var n=p(t,e),o=n.obj;if(o)return o[n.k]}function n(t){return t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")}var i={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;"};function r(t){return"string"==typeof t?t.replace(/[&<>"'\/]/g,function(t){return i[t]}):t}var u=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t};function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):function(t,e){for(var n=Object.getOwnPropertyNames(e),o=0;o<n.length;o++){var i=n[o],r=Object.getOwnPropertyDescriptor(e,i);r&&r.configurable&&void 0===t[i]&&Object.defineProperty(t,i,r)}}(t,e))}var c=function(o){function i(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{ns:["translation"],defaultNS:"translation"};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);var n=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,o.call(this));return n.data=t||{},n.options=e,void 0===n.options.keySeparator&&(n.options.keySeparator="."),n}return a(i,o),i.prototype.addNamespaces=function(t){this.options.ns.indexOf(t)<0&&this.options.ns.push(t)},i.prototype.removeNamespaces=function(t){var e=this.options.ns.indexOf(t);-1<e&&this.options.ns.splice(e,1)},i.prototype.getResource=function(t,e,n){var o=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},i=void 0!==o.keySeparator?o.keySeparator:this.options.keySeparator,r=[t,e];return n&&"string"!=typeof n&&(r=r.concat(n)),n&&"string"==typeof n&&(r=r.concat(i?n.split(i):n)),-1<t.indexOf(".")&&(r=t.split(".")),h(this.data,r)},i.prototype.addResource=function(t,e,n,o){var i=4<arguments.length&&void 0!==arguments[4]?arguments[4]:{silent:!1},r=this.options.keySeparator;void 0===r&&(r=".");var a=[t,e];n&&(a=a.concat(r?n.split(r):n)),-1<t.indexOf(".")&&(o=e,e=(a=t.split("."))[1]),this.addNamespaces(e),l(this.data,a,o),i.silent||this.emit("added",t,e,n,o)},i.prototype.addResources=function(t,e,n){var o=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{silent:!1};for(var i in n)"string"==typeof n[i]&&this.addResource(t,e,i,n[i],{silent:!0});o.silent||this.emit("added",t,e,n)},i.prototype.addResourceBundle=function(t,e,n,o,i){var r=5<arguments.length&&void 0!==arguments[5]?arguments[5]:{silent:!1},a=[t,e];-1<t.indexOf(".")&&(o=n,n=e,e=(a=t.split("."))[1]),this.addNamespaces(e);var s=h(this.data,a)||{};o?function t(e,n,o){for(var i in n)i in e?"string"==typeof e[i]||e[i]instanceof String||"string"==typeof n[i]||n[i]instanceof String?o&&(e[i]=n[i]):t(e[i],n[i],o):e[i]=n[i];return e}(s,n,i):s=u({},s,n),l(this.data,a,s),r.silent||this.emit("added",t,e,n)},i.prototype.removeResourceBundle=function(t,e){this.hasResourceBundle(t,e)&&delete this.data[t][e],this.removeNamespaces(e),this.emit("removed",t,e)},i.prototype.hasResourceBundle=function(t,e){return void 0!==this.getResource(t,e)},i.prototype.getResourceBundle=function(t,e){return e||(e=this.options.defaultNS),"v1"===this.options.compatibilityAPI?u({},this.getResource(t,e)):this.getResource(t,e)},i.prototype.getDataByLanguage=function(t){return this.data[t]},i.prototype.toJSON=function(){return this.data},i}(t),d={processors:{},addPostProcessor:function(t){this.processors[t.name]=t},handle:function(t,e,n,o,i){var r=this;return t.forEach(function(t){r.processors[t]&&(e=r.processors[t].process(e,n,o,i))}),e}},P=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},R="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};function g(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):function(t,e){for(var n=Object.getOwnPropertyNames(e),o=0;o<n.length;o++){var i=n[o],r=Object.getOwnPropertyDescriptor(e,i);r&&r.configurable&&void 0===t[i]&&Object.defineProperty(t,i,r)}}(t,e))}var v=function(r){function a(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,a);var n,o,i=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,r.call(this));return n=t,o=i,["resourceStore","languageUtils","pluralResolver","interpolator","backendConnector","i18nFormat"].forEach(function(t){n[t]&&(o[t]=n[t])}),i.options=e,void 0===i.options.keySeparator&&(i.options.keySeparator="."),i.logger=s.create("translator"),i}return g(a,r),a.prototype.changeLanguage=function(t){t&&(this.language=t)},a.prototype.exists=function(t){var e=this.resolve(t,1<arguments.length&&void 0!==arguments[1]?arguments[1]:{interpolation:{}});return e&&void 0!==e.res},a.prototype.extractFromKey=function(t,e){var n=e.nsSeparator||this.options.nsSeparator;void 0===n&&(n=":");var o=void 0!==e.keySeparator?e.keySeparator:this.options.keySeparator,i=e.ns||this.options.defaultNS;if(n&&-1<t.indexOf(n)){var r=t.split(n);(n!==o||n===o&&-1<this.options.ns.indexOf(r[0]))&&(i=r.shift()),t=r.join(o)}return"string"==typeof i&&(i=[i]),{key:t,namespaces:i}},a.prototype.translate=function(t,n){var o=this;if("object"!==(void 0===n?"undefined":R(n))&&this.options.overloadTranslationOptionHandler&&(n=this.options.overloadTranslationOptionHandler(arguments)),n||(n={}),null==t||""===t)return"";"number"==typeof t&&(t+=""),"string"==typeof t&&(t=[t]);var e=void 0!==n.keySeparator?n.keySeparator:this.options.keySeparator,i=this.extractFromKey(t[t.length-1],n),r=i.key,a=i.namespaces,s=a[a.length-1],l=n.lng||this.language,u=n.appendNamespaceToCIMode||this.options.appendNamespaceToCIMode;if(l&&"cimode"===l.toLowerCase())return u?s+(n.nsSeparator||this.options.nsSeparator)+r:r;var c=this.resolve(t,n),p=c&&c.res,f=c&&c.usedKey||r,h=Object.prototype.toString.apply(p),d=void 0!==n.joinArrays?n.joinArrays:this.options.joinArrays,g=!this.i18nFormat||this.i18nFormat.handleAsObject;if(g&&p&&("string"!=typeof p&&"boolean"!=typeof p&&"number"!=typeof p)&&["[object Number]","[object Function]","[object RegExp]"].indexOf(h)<0&&(!d||"[object Array]"!==h)){if(!n.returnObjects&&!this.options.returnObjects)return this.logger.warn("accessing an object - but returnObjects options is not enabled!"),this.options.returnedObjectHandler?this.options.returnedObjectHandler(f,p,n):"key '"+r+" ("+this.language+")' returned an object instead of string.";if(e){var v="[object Array]"===h?[]:{};for(var y in p)if(Object.prototype.hasOwnProperty.call(p,y)){var b=""+f+e+y;v[y]=this.translate(b,P({},n,{joinArrays:!1,ns:a})),v[y]===b&&(v[y]=p[y])}p=v}}else if(g&&d&&"[object Array]"===h)(p=p.join(d))&&(p=this.extendTranslation(p,t,n));else{var m=!1,w=!1;if(!this.isValidLookup(p)&&void 0!==n.defaultValue){if(m=!0,void 0!==n.count){var x=this.pluralResolver.getSuffix(l,n.count);p=n["defaultValue"+x]}p||(p=n.defaultValue)}this.isValidLookup(p)||(w=!0,p=r);var O=n.defaultValue&&n.defaultValue!==p&&this.options.updateMissing;if(w||m||O){this.logger.log(O?"updateKey":"missingKey",l,s,r,O?n.defaultValue:p);var S=[],k=this.languageUtils.getFallbackCodes(this.options.fallbackLng,n.lng||this.language);if("fallback"===this.options.saveMissingTo&&k&&k[0])for(var j=0;j<k.length;j++)S.push(k[j]);else"all"===this.options.saveMissingTo?S=this.languageUtils.toResolveHierarchy(n.lng||this.language):S.push(n.lng||this.language);var C=function(t,e){o.options.missingKeyHandler?o.options.missingKeyHandler(t,s,e,O?n.defaultValue:p,O,n):o.backendConnector&&o.backendConnector.saveMissing&&o.backendConnector.saveMissing(t,s,e,O?n.defaultValue:p,O,n),o.emit("missingKey",t,s,e,p)};if(this.options.saveMissing)this.options.saveMissingPlurals&&(void 0!==n.count&&"string"!=typeof n.count)?S.forEach(function(e){o.pluralResolver.getPluralFormsOfKey(e,r).forEach(function(t){return C([e],t)})}):C(S,r)}p=this.extendTranslation(p,t,n,c),w&&p===r&&this.options.appendNamespaceToMissingKey&&(p=s+":"+r),w&&this.options.parseMissingKeyHandler&&(p=this.options.parseMissingKeyHandler(p))}return p},a.prototype.extendTranslation=function(t,e,n,o){var i=this;if(this.i18nFormat&&this.i18nFormat.parse)t=this.i18nFormat.parse(t,n,o.usedLng,o.usedNS,o.usedKey,{resolved:o});else if(!n.skipInterpolation){n.interpolation&&this.interpolator.init(P({},n,{interpolation:P({},this.options.interpolation,n.interpolation)}));var r=n.replace&&"string"!=typeof n.replace?n.replace:n;this.options.interpolation.defaultVariables&&(r=P({},this.options.interpolation.defaultVariables,r)),t=this.interpolator.interpolate(t,r,n.lng||this.language,n),!1!==n.nest&&(t=this.interpolator.nest(t,function(){return i.translate.apply(i,arguments)},n)),n.interpolation&&this.interpolator.reset()}var a=n.postProcess||this.options.postProcess,s="string"==typeof a?[a]:a;return null!=t&&s&&s.length&&!1!==n.applyPostProcessor&&(t=d.handle(s,t,e,n,this)),t},a.prototype.resolve=function(t){var u=this,c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},p=void 0,i=void 0,f=void 0,h=void 0;return"string"==typeof t&&(t=[t]),t.forEach(function(t){if(!u.isValidLookup(p)){var e=u.extractFromKey(t,c),a=e.key;i=a;var n=e.namespaces;u.options.fallbackNS&&(n=n.concat(u.options.fallbackNS));var s=void 0!==c.count&&"string"!=typeof c.count,l=void 0!==c.context&&"string"==typeof c.context&&""!==c.context,o=c.lngs?c.lngs:u.languageUtils.toResolveHierarchy(c.lng||u.language,c.fallbackLng);n.forEach(function(r){u.isValidLookup(p)||(h=r,o.forEach(function(t){if(!u.isValidLookup(p)){f=t;var e=a,n=[e];if(u.i18nFormat&&u.i18nFormat.addLookupKeys)u.i18nFormat.addLookupKeys(n,a,t,r,c);else{var o=void 0;s&&(o=u.pluralResolver.getSuffix(t,c.count)),s&&l&&n.push(e+o),l&&n.push(e+=""+u.options.contextSeparator+c.context),s&&n.push(e+=o)}for(var i=void 0;i=n.pop();)u.isValidLookup(p)||(p=u.getResource(t,r,i,c))}}))})}}),{res:p,usedKey:i,usedLng:f,usedNS:h}},a.prototype.isValidLookup=function(t){return!(void 0===t||!this.options.returnNull&&null===t||!this.options.returnEmptyString&&""===t)},a.prototype.getResource=function(t,e,n){var o=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{};return this.i18nFormat&&this.i18nFormat.getResource?this.i18nFormat.getResource(t,e,n,o):this.resourceStore.getResource(t,e,n,o)},a}(t);function y(t){return t.charAt(0).toUpperCase()+t.slice(1)}var b=function(){function e(t){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),this.options=t,this.whitelist=this.options.whitelist||!1,this.logger=s.create("languageUtils")}return e.prototype.getScriptPartFromCode=function(t){if(!t||t.indexOf("-")<0)return null;var e=t.split("-");return 2===e.length?null:(e.pop(),this.formatLanguageCode(e.join("-")))},e.prototype.getLanguagePartFromCode=function(t){if(!t||t.indexOf("-")<0)return t;var e=t.split("-");return this.formatLanguageCode(e[0])},e.prototype.formatLanguageCode=function(t){if("string"==typeof t&&-1<t.indexOf("-")){var e=["hans","hant","latn","cyrl","cans","mong","arab"],n=t.split("-");return this.options.lowerCaseLng?n=n.map(function(t){return t.toLowerCase()}):2===n.length?(n[0]=n[0].toLowerCase(),n[1]=n[1].toUpperCase(),-1<e.indexOf(n[1].toLowerCase())&&(n[1]=y(n[1].toLowerCase()))):3===n.length&&(n[0]=n[0].toLowerCase(),2===n[1].length&&(n[1]=n[1].toUpperCase()),"sgn"!==n[0]&&2===n[2].length&&(n[2]=n[2].toUpperCase()),-1<e.indexOf(n[1].toLowerCase())&&(n[1]=y(n[1].toLowerCase())),-1<e.indexOf(n[2].toLowerCase())&&(n[2]=y(n[2].toLowerCase()))),n.join("-")}return this.options.cleanCode||this.options.lowerCaseLng?t.toLowerCase():t},e.prototype.isWhitelisted=function(t){return("languageOnly"===this.options.load||this.options.nonExplicitWhitelist)&&(t=this.getLanguagePartFromCode(t)),!this.whitelist||!this.whitelist.length||-1<this.whitelist.indexOf(t)},e.prototype.getFallbackCodes=function(t,e){if(!t)return[];if("string"==typeof t&&(t=[t]),"[object Array]"===Object.prototype.toString.apply(t))return t;if(!e)return t.default||[];var n=t[e];return n||(n=t[this.getScriptPartFromCode(e)]),n||(n=t[this.formatLanguageCode(e)]),n||(n=t.default),n||[]},e.prototype.toResolveHierarchy=function(t,e){var n=this,o=this.getFallbackCodes(e||this.options.fallbackLng||[],t),i=[],r=function(t){t&&(n.isWhitelisted(t)?i.push(t):n.logger.warn("rejecting non-whitelisted language code: "+t))};return"string"==typeof t&&-1<t.indexOf("-")?("languageOnly"!==this.options.load&&r(this.formatLanguageCode(t)),"languageOnly"!==this.options.load&&"currentOnly"!==this.options.load&&r(this.getScriptPartFromCode(t)),"currentOnly"!==this.options.load&&r(this.getLanguagePartFromCode(t))):"string"==typeof t&&r(this.formatLanguageCode(t)),o.forEach(function(t){i.indexOf(t)<0&&r(n.formatLanguageCode(t))}),i},e}();var m=[{lngs:["ach","ak","am","arn","br","fil","gun","ln","mfe","mg","mi","oc","pt","pt-BR","tg","ti","tr","uz","wa"],nr:[1,2],fc:1},{lngs:["af","an","ast","az","bg","bn","ca","da","de","dev","el","en","eo","es","et","eu","fi","fo","fur","fy","gl","gu","ha","he","hi","hu","hy","ia","it","kn","ku","lb","mai","ml","mn","mr","nah","nap","nb","ne","nl","nn","no","nso","pa","pap","pms","ps","pt-PT","rm","sco","se","si","so","son","sq","sv","sw","ta","te","tk","ur","yo"],nr:[1,2],fc:2},{lngs:["ay","bo","cgg","fa","id","ja","jbo","ka","kk","km","ko","ky","lo","ms","sah","su","th","tt","ug","vi","wo","zh"],nr:[1],fc:3},{lngs:["be","bs","dz","hr","ru","sr","uk"],nr:[1,2,5],fc:4},{lngs:["ar"],nr:[0,1,2,3,11,100],fc:5},{lngs:["cs","sk"],nr:[1,2,5],fc:6},{lngs:["csb","pl"],nr:[1,2,5],fc:7},{lngs:["cy"],nr:[1,2,3,8],fc:8},{lngs:["fr"],nr:[1,2],fc:9},{lngs:["ga"],nr:[1,2,3,7,11],fc:10},{lngs:["gd"],nr:[1,2,3,20],fc:11},{lngs:["is"],nr:[1,2],fc:12},{lngs:["jv"],nr:[0,1],fc:13},{lngs:["kw"],nr:[1,2,3,4],fc:14},{lngs:["lt"],nr:[1,2,10],fc:15},{lngs:["lv"],nr:[1,2,0],fc:16},{lngs:["mk"],nr:[1,2],fc:17},{lngs:["mnk"],nr:[0,1,2],fc:18},{lngs:["mt"],nr:[1,2,11,20],fc:19},{lngs:["or"],nr:[2,1],fc:2},{lngs:["ro"],nr:[1,2,20],fc:20},{lngs:["sl"],nr:[5,1,2,3],fc:21}],w={1:function(t){return+(1<t)},2:function(t){return+(1!=t)},3:function(t){return 0},4:function(t){return+(t%10==1&&t%100!=11?0:t%10<2||4<t%10||10<=t%100&&t%100<20?2:1)},5:function(t){return+(0===t?0:1==t?1:2==t?2:t%100<3||10<t%100?t%100<11?5:4:3)},6:function(t){return+(1==t?0:t<2||4<t?2:1)},7:function(t){return+(1==t?0:t%10<2||4<t%10||10<=t%100&&t%100<20?2:1)},8:function(t){return+(1==t?0:2==t?1:8!=t&&11!=t?2:3)},9:function(t){return+(2<=t)},10:function(t){return+(1==t?0:2==t?1:t<7?2:t<11?3:4)},11:function(t){return+(1==t||11==t?0:2==t||12==t?1:2<t&&t<20?2:3)},12:function(t){return+(t%10!=1||t%100==11)},13:function(t){return+(0!==t)},14:function(t){return+(1==t?0:2==t?1:3==t?2:3)},15:function(t){return+(t%10==1&&t%100!=11?0:t%10<2||10<=t%100&&t%100<20?2:1)},16:function(t){return+(t%10==1&&t%100!=11?0:0!==t?1:2)},17:function(t){return+(1==t||t%10==1?0:1)},18:function(t){return+(0==t?0:1==t?1:2)},19:function(t){return+(1==t?0:0===t||1<t%100&&t%100<11?1:10<t%100&&t%100<20?2:3)},20:function(t){return+(1==t?0:0===t||0<t%100&&t%100<20?1:2)},21:function(t){return+(t%100==1?1:t%100==2?2:t%100==3||t%100==4?3:0)}};var x=function(){function o(t){var n,e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,o),this.languageUtils=t,this.options=e,this.logger=s.create("pluralResolver"),this.rules=(n={},m.forEach(function(e){e.lngs.forEach(function(t){n[t]={numbers:e.nr,plurals:w[e.fc]}})}),n)}return o.prototype.addRule=function(t,e){this.rules[t]=e},o.prototype.getRule=function(t){return this.rules[t]||this.rules[this.languageUtils.getLanguagePartFromCode(t)]},o.prototype.needsPlural=function(t){var e=this.getRule(t);return e&&1<e.numbers.length},o.prototype.getPluralFormsOfKey=function(n,o){var i=this,r=[],t=this.getRule(n);return t&&t.numbers.forEach(function(t){var e=i.getSuffix(n,t);r.push(""+o+e)}),r},o.prototype.getSuffix=function(t,e){var n=this,o=this.getRule(t);if(o){var i=o.plurals(o.noAbs?e:Math.abs(e)),r=o.numbers[i];this.options.simplifyPluralSuffix&&2===o.numbers.length&&1===o.numbers[0]&&(2===r?r="plural":1===r&&(r=""));var a=function(){return n.options.prepend&&""+r?n.options.prepend+""+r:""+r};return"v1"===this.options.compatibilityJSON?1===r?"":"number"==typeof r?"_plural_"+r:a():"v2"===this.options.compatibilityJSON&&2===o.numbers.length&&1===o.numbers[0]?a():this.options.simplifyPluralSuffix&&2===o.numbers.length&&1===o.numbers[0]?a():this.options.prepend&&""+i?this.options.prepend+""+i:""+i}return this.logger.warn("no plural rule found for: "+t),""},o}(),O=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t};var S=function(){function e(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),this.logger=s.create("interpolator"),this.init(t,!0)}return e.prototype.init=function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};arguments[1]&&(this.options=t,this.format=t.interpolation&&t.interpolation.format||function(t){return t}),t.interpolation||(t.interpolation={escapeValue:!0});var e=t.interpolation;this.escape=void 0!==e.escape?e.escape:r,this.escapeValue=void 0===e.escapeValue||e.escapeValue,this.useRawValueToEscape=void 0!==e.useRawValueToEscape&&e.useRawValueToEscape,this.prefix=e.prefix?n(e.prefix):e.prefixEscaped||"{{",this.suffix=e.suffix?n(e.suffix):e.suffixEscaped||"}}",this.formatSeparator=e.formatSeparator?e.formatSeparator:e.formatSeparator||",",this.unescapePrefix=e.unescapeSuffix?"":e.unescapePrefix||"-",this.unescapeSuffix=this.unescapePrefix?"":e.unescapeSuffix||"",this.nestingPrefix=e.nestingPrefix?n(e.nestingPrefix):e.nestingPrefixEscaped||n("$t("),this.nestingSuffix=e.nestingSuffix?n(e.nestingSuffix):e.nestingSuffixEscaped||n(")"),this.maxReplaces=e.maxReplaces?e.maxReplaces:1e3,this.resetRegExp()},e.prototype.reset=function(){this.options&&this.init(this.options)},e.prototype.resetRegExp=function(){this.regexp=RegExp(this.prefix+"(.+?)"+this.suffix,"g"),this.regexpUnescape=RegExp(""+this.prefix+this.unescapePrefix+"(.+?)"+this.unescapeSuffix+this.suffix,"g"),this.nestingRegexp=RegExp(this.nestingPrefix+"(.+?)"+this.nestingSuffix,"g")},e.prototype.interpolate=function(t,i,r,e){var a=this,n=void 0,o=void 0,s=void 0;function l(t){return t.replace(/\$/g,"$$$$")}var u=function(t){if(t.indexOf(a.formatSeparator)<0)return h(i,t);var e=t.split(a.formatSeparator),n=e.shift().trim(),o=e.join(a.formatSeparator).trim();return a.format(h(i,n),o,r)};this.resetRegExp();var c=e&&e.missingInterpolationHandler||this.options.missingInterpolationHandler;for(s=0;(n=this.regexpUnescape.exec(t))&&(o=u(n[1].trim()),t=t.replace(n[0],o),this.regexpUnescape.lastIndex=0,this.maxReplaces>++s););for(s=0;n=this.regexp.exec(t);){if(void 0===(o=u(n[1].trim())))if("function"==typeof c){var p=c(t,n);o="string"==typeof p?p:""}else this.logger.warn("missed to pass in variable "+n[1]+" for interpolating "+t),o="";else"string"==typeof o||this.useRawValueToEscape||(o=f(o));if(o=l(this.escapeValue?this.escape(o):o),t=t.replace(n[0],o),this.regexp.lastIndex=0,this.maxReplaces<=++s)break}return t},e.prototype.nest=function(t,e){var n=void 0,o=void 0,i=O({},2<arguments.length&&void 0!==arguments[2]?arguments[2]:{});function r(e,t){if(e.indexOf(",")<0)return e;var n=e.split(",");e=n.shift();var o=n.join(",");o=(o=this.interpolate(o,i)).replace(/'/g,'"');try{i=JSON.parse(o),t&&(i=O({},t,i))}catch(t){this.logger.error("failed parsing options string in nesting for key "+e,t)}return e}for(i.applyPostProcessor=!1;n=this.nestingRegexp.exec(t);){if((o=e(r.call(this,n[1].trim(),i),i))&&n[0]===t&&"string"!=typeof o)return o;"string"!=typeof o&&(o=f(o)),o||(this.logger.warn("missed to resolve "+n[1]+" for nesting "+t),o=""),t=t.replace(n[0],o),this.regexp.lastIndex=0}return t},e}(),k=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},j=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],o=!0,i=!1,r=void 0;try{for(var a,s=t[Symbol.iterator]();!(o=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);o=!0);}catch(t){i=!0,r=t}finally{try{!o&&s.return&&s.return()}finally{if(i)throw r}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")};function C(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):function(t,e){for(var n=Object.getOwnPropertyNames(e),o=0;o<n.length;o++){var i=n[o],r=Object.getOwnPropertyDescriptor(e,i);r&&r.configurable&&void 0===t[i]&&Object.defineProperty(t,i,r)}}(t,e))}var E=function(r){function a(t,e,n){var o=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,a);var i=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,r.call(this));return i.backend=t,i.store=e,i.languageUtils=n.languageUtils,i.options=o,i.logger=s.create("backendConnector"),i.state={},i.queue=[],i.backend&&i.backend.init&&i.backend.init(n,o.backend,o),i}return C(a,r),a.prototype.queueLoad=function(t,e,i,n){var r=this,a=[],s=[],l=[],u=[];return t.forEach(function(n){var o=!0;e.forEach(function(t){var e=n+"|"+t;!i.reload&&r.store.hasResourceBundle(n,t)?r.state[e]=2:r.state[e]<0||(1===r.state[e]?s.indexOf(e)<0&&s.push(e):(o=!(r.state[e]=1),s.indexOf(e)<0&&s.push(e),a.indexOf(e)<0&&a.push(e),u.indexOf(t)<0&&u.push(t)))}),o||l.push(n)}),(a.length||s.length)&&this.queue.push({pending:s,loaded:{},errors:[],callback:n}),{toLoad:a,pending:s,toLoadLanguages:l,toLoadNamespaces:u}},a.prototype.loaded=function(a,s,t){var e=a.split("|"),n=j(e,2),l=n[0],u=n[1];s&&this.emit("failedLoading",l,u,s),t&&this.store.addResourceBundle(l,u,t),this.state[a]=s?-1:2;var c={};this.queue.forEach(function(t){var e,n,o,i,r;e=u,o=p(t.loaded,[l],Object),(i=o.obj)[r=o.k]=i[r]||[],n&&(i[r]=i[r].concat(e)),n||i[r].push(e),function(t,e){for(var n=t.indexOf(e);-1!==n;)t.splice(n,1),n=t.indexOf(e)}(t.pending,a),s&&t.errors.push(s),0!==t.pending.length||t.done||(Object.keys(t.loaded).forEach(function(e){c[e]||(c[e]=[]),t.loaded[e].length&&t.loaded[e].forEach(function(t){c[e].indexOf(t)<0&&c[e].push(t)})}),t.done=!0,t.errors.length?t.callback(t.errors):t.callback())}),this.emit("loaded",c),this.queue=this.queue.filter(function(t){return!t.done})},a.prototype.read=function(n,o,i){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:0,a=this,s=4<arguments.length&&void 0!==arguments[4]?arguments[4]:250,l=arguments[5];return n.length?this.backend[i](n,o,function(t,e){t&&e&&r<5?setTimeout(function(){a.read.call(a,n,o,i,r+1,2*s,l)},s):l(t,e)}):l(null,{})},a.prototype.prepareLoading=function(t,e){var n=this,o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=arguments[3];if(!this.backend)return this.logger.warn("No backend was added via i18next.use. Will not load resources."),i&&i();"string"==typeof t&&(t=this.languageUtils.toResolveHierarchy(t)),"string"==typeof e&&(e=[e]);var r=this.queueLoad(t,e,o,i);if(!r.toLoad.length)return r.pending.length||i(),null;r.toLoad.forEach(function(t){n.loadOne(t)})},a.prototype.load=function(t,e,n){this.prepareLoading(t,e,{},n)},a.prototype.reload=function(t,e,n){this.prepareLoading(t,e,{reload:!0},n)},a.prototype.loadOne=function(n){var o=this,i=1<arguments.length&&void 0!==arguments[1]?arguments[1]:"",t=n.split("|"),e=j(t,2),r=e[0],a=e[1];this.read(r,a,"read",null,null,function(t,e){t&&o.logger.warn(i+"loading namespace "+a+" for language "+r+" failed",t),!t&&e&&o.logger.log(i+"loaded namespace "+a+" for language "+r,e),o.loaded(n,t,e)})},a.prototype.saveMissing=function(t,e,n,o,i){this.backend&&this.backend.create&&this.backend.create(t,e,n,o,null,k({},5<arguments.length&&void 0!==arguments[5]?arguments[5]:{},{isUpdate:i})),t&&t[0]&&this.store.addResource(t[0],e,n,o)},a}(t);function L(t){return"string"==typeof t.ns&&(t.ns=[t.ns]),"string"==typeof t.fallbackLng&&(t.fallbackLng=[t.fallbackLng]),"string"==typeof t.fallbackNS&&(t.fallbackNS=[t.fallbackNS]),t.whitelist&&t.whitelist.indexOf("cimode")<0&&(t.whitelist=t.whitelist.concat(["cimode"])),t}var T="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},N=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t};function A(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function M(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):function(t,e){for(var n=Object.getOwnPropertyNames(e),o=0;o<n.length;o++){var i=n[o],r=Object.getOwnPropertyDescriptor(e,i);r&&r.configurable&&void 0===t[i]&&Object.defineProperty(t,i,r)}}(t,e))}function F(){}var H=new(function(i){function r(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},e=arguments[1];!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);var n=A(this,i.call(this));if(n.options=L(t),n.services={},n.logger=s,n.modules={external:[]},e&&!n.isInitialized&&!t.isClone){var o;if(!n.options.initImmediate)return o=n.init(t,e),A(n,o);setTimeout(function(){n.init(t,e)},0)}return n}return M(r,i),r.prototype.init=function(){var i=this,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},n=arguments[1];function e(t){return t?"function"==typeof t?new t:t:null}if("function"==typeof t&&(n=t,t={}),this.options=N({},{debug:!1,initImmediate:!0,ns:["translation"],defaultNS:["translation"],fallbackLng:["dev"],fallbackNS:!1,whitelist:!1,nonExplicitWhitelist:!1,load:"all",preload:!1,simplifyPluralSuffix:!0,keySeparator:".",nsSeparator:":",pluralSeparator:"_",contextSeparator:"_",saveMissing:!1,updateMissing:!1,saveMissingTo:"fallback",saveMissingPlurals:!0,missingKeyHandler:!1,missingInterpolationHandler:!1,postProcess:!1,returnNull:!0,returnEmptyString:!0,returnObjects:!1,joinArrays:!1,returnedObjectHandler:function(){},parseMissingKeyHandler:!1,appendNamespaceToMissingKey:!1,appendNamespaceToCIMode:!1,overloadTranslationOptionHandler:function(t){var e={};return t[1]&&(e.defaultValue=t[1]),t[2]&&(e.tDescription=t[2]),e},interpolation:{escapeValue:!0,format:function(t,e,n){return t},prefix:"{{",suffix:"}}",formatSeparator:",",unescapePrefix:"-",nestingPrefix:"$t(",nestingSuffix:")",maxReplaces:1e3}},this.options,L(t)),this.format=this.options.interpolation.format,n||(n=F),!this.options.isClone){s.init(this.modules.logger?e(this.modules.logger):null,this.options);var o=new b(this.options);this.store=new c(this.options.resources,this.options);var r=this.services;r.logger=s,r.resourceStore=this.store,r.languageUtils=o,r.pluralResolver=new x(o,{prepend:this.options.pluralSeparator,compatibilityJSON:this.options.compatibilityJSON,simplifyPluralSuffix:this.options.simplifyPluralSuffix}),r.interpolator=new S(this.options),r.backendConnector=new E(e(this.modules.backend),r.resourceStore,r,this.options),r.backendConnector.on("*",function(t){for(var e=arguments.length,n=Array(1<e?e-1:0),o=1;o<e;o++)n[o-1]=arguments[o];i.emit.apply(i,[t].concat(n))}),this.modules.languageDetector&&(r.languageDetector=e(this.modules.languageDetector),r.languageDetector.init(r,this.options.detection,this.options)),this.modules.i18nFormat&&(r.i18nFormat=e(this.modules.i18nFormat),r.i18nFormat.init&&r.i18nFormat.init(this)),this.translator=new v(this.services,this.options),this.translator.on("*",function(t){for(var e=arguments.length,n=Array(1<e?e-1:0),o=1;o<e;o++)n[o-1]=arguments[o];i.emit.apply(i,[t].concat(n))}),this.modules.external.forEach(function(t){t.init&&t.init(i)})}["getResource","addResource","addResources","addResourceBundle","removeResourceBundle","hasResourceBundle","getResourceBundle","getDataByLanguage"].forEach(function(e){i[e]=function(){var t;return(t=i.store)[e].apply(t,arguments)}});var a=function(){i.changeLanguage(i.options.lng,function(t,e){i.isInitialized=!0,i.logger.log("initialized",i.options),i.emit("initialized",i.options),n(t,e)})};return this.options.resources||!this.options.initImmediate?a():setTimeout(a,0),this},r.prototype.loadResources=function(){var e=this,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:F;if(this.options.resources)t(null);else{if(this.language&&"cimode"===this.language.toLowerCase())return t();var n=[],o=function(t){t&&e.services.languageUtils.toResolveHierarchy(t).forEach(function(t){n.indexOf(t)<0&&n.push(t)})};if(this.language)o(this.language);else this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach(function(t){return o(t)});this.options.preload&&this.options.preload.forEach(function(t){return o(t)}),this.services.backendConnector.load(n,this.options.ns,t)}},r.prototype.reloadResources=function(t,e,n){t||(t=this.languages),e||(e=this.options.ns),n||(n=function(){}),this.services.backendConnector.reload(t,e,n)},r.prototype.use=function(t){return"backend"===t.type&&(this.modules.backend=t),("logger"===t.type||t.log&&t.warn&&t.error)&&(this.modules.logger=t),"languageDetector"===t.type&&(this.modules.languageDetector=t),"i18nFormat"===t.type&&(this.modules.i18nFormat=t),"postProcessor"===t.type&&d.addPostProcessor(t),"3rdParty"===t.type&&this.modules.external.push(t),this},r.prototype.changeLanguage=function(t,i){var r=this,e=function(o){o&&(r.language=o,r.languages=r.services.languageUtils.toResolveHierarchy(o),r.translator.language||r.translator.changeLanguage(o),r.services.languageDetector&&r.services.languageDetector.cacheUserLanguage(o)),r.loadResources(function(t){var e,n;e=t,r.translator.changeLanguage(n=o),n&&(r.emit("languageChanged",n),r.logger.log("languageChanged",n)),i&&i(e,function(){return r.t.apply(r,arguments)})})};t||!this.services.languageDetector||this.services.languageDetector.async?!t&&this.services.languageDetector&&this.services.languageDetector.async?this.services.languageDetector.detect(e):e(t):e(this.services.languageDetector.detect())},r.prototype.getFixedT=function(t,e){var s=this,n=function t(e,n){for(var o=arguments.length,i=Array(2<o?o-2:0),r=2;r<o;r++)i[r-2]=arguments[r];var a=N({},n);return"object"!==(void 0===n?"undefined":T(n))&&(a=s.options.overloadTranslationOptionHandler([e,n].concat(i))),a.lng=a.lng||t.lng,a.lngs=a.lngs||t.lngs,a.ns=a.ns||t.ns,s.t(e,a)};return"string"==typeof t?n.lng=t:n.lngs=t,n.ns=e,n},r.prototype.t=function(){var t;return this.translator&&(t=this.translator).translate.apply(t,arguments)},r.prototype.exists=function(){var t;return this.translator&&(t=this.translator).exists.apply(t,arguments)},r.prototype.setDefaultNamespace=function(t){this.options.defaultNS=t},r.prototype.loadNamespaces=function(t,e){var n=this;if(!this.options.ns)return e&&e();"string"==typeof t&&(t=[t]),t.forEach(function(t){n.options.ns.indexOf(t)<0&&n.options.ns.push(t)}),this.loadResources(e)},r.prototype.loadLanguages=function(t,e){"string"==typeof t&&(t=[t]);var n=this.options.preload||[],o=t.filter(function(t){return n.indexOf(t)<0});if(!o.length)return e();this.options.preload=n.concat(o),this.loadResources(e)},r.prototype.dir=function(t){if(t||(t=this.languages&&0<this.languages.length?this.languages[0]:this.language),!t)return"rtl";return["ar","shu","sqr","ssh","xaa","yhd","yud","aao","abh","abv","acm","acq","acw","acx","acy","adf","ads","aeb","aec","afb","ajp","apc","apd","arb","arq","ars","ary","arz","auz","avl","ayh","ayl","ayn","ayp","bbz","pga","he","iw","ps","pbt","pbu","pst","prp","prd","ur","ydd","yds","yih","ji","yi","hbo","men","xmn","fa","jpr","peo","pes","prs","dv","sam"].indexOf(this.services.languageUtils.getLanguagePartFromCode(t))<0?"ltr":"rtl"},r.prototype.createInstance=function(){return new r(0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},arguments[1])},r.prototype.cloneInstance=function(){var e=this,t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:F,n=N({},this.options,0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},{isClone:!0}),i=new r(n);return["store","services","language"].forEach(function(t){i[t]=e[t]}),i.translator=new v(i.services,i.options),i.translator.on("*",function(t){for(var e=arguments.length,n=Array(1<e?e-1:0),o=1;o<e;o++)n[o-1]=arguments[o];i.emit.apply(i,[t].concat(n))}),i.init(n,t),i.translator.options=i.options,i},r}(t)),I=(H.changeLanguage.bind(H),H.cloneInstance.bind(H),H.createInstance.bind(H),H.dir.bind(H),H.exists.bind(H),H.getFixedT.bind(H),H.init.bind(H),H.loadLanguages.bind(H),H.loadNamespaces.bind(H),H.loadResources.bind(H),H.off.bind(H),H.on.bind(H),H.setDefaultNamespace.bind(H),H.t.bind(H),H.use.bind(H),[]),D=I.forEach,V=I.slice;var q=function(){function o(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(t,e,n){return e&&o(t.prototype,e),n&&o(t,n),t}}();var U=function(){function n(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,n),this.backends=[],this.type="backend",this.init(t,e)}return q(n,[{key:"init",value:function(o){var i=this,t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},r=arguments[2];this.services=o,this.options=function(n){return D.call(V.call(arguments,1),function(t){if(t)for(var e in t)void 0===n[e]&&(n[e]=t[e])}),n}(t,this.options||{},{}),this.options.backends&&this.options.backends.forEach(function(t,e){var n;i.backends[e]=i.backends[e]||((n=t)?"function"==typeof n?new n:n:null),i.backends[e].init(o,i.options.backendOptions[e],r)})}},{key:"read",value:function(i,r,a){var s=this,e=this.backends.length,l=function t(e,n){if(0<=e){var o=s.backends[e];o.save&&o.save(i,r,n),t(e-1,n)}};!function n(o){if(e<=o)return a(Error("non of the backend loaded data;",!0));var t=s.backends[o];t.read?t.read(i,r,function(t,e){e&&-1<Object.keys(e).length?(a(null,e,o),l(o-1,e)):n(o+1)}):n(o+1)}(0)}},{key:"create",value:function(e,n,o,i){this.backends.forEach(function(t){t.create&&t.create(e,n,o,i)})}}]),n}();U.type="backend";var _=[],K=_.forEach,B=_.slice;var z=function(){function o(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(t,e,n){return e&&o(t.prototype,e),n&&o(t,n),t}}();var X=function(t,e){if(window.localStorage)try{window.localStorage.setItem(t,e)}catch(t){}},$=function(t,e){if(window.localStorage)try{return window.localStorage.getItem(t,e)}catch(t){}};var Q=function(){function n(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,n),this.init(t,e),this.type="backend"}return z(n,[{key:"init",value:function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};this.services=t,this.options=function(n){return K.call(B.call(arguments,1),function(t){if(t)for(var e in t)void 0===n[e]&&(n[e]=t[e])}),n}(e,this.options||{},{prefix:"i18next_res_",expirationTime:6048e5,versions:{}})}},{key:"read",value:function(t,e,n){var o=(new Date).getTime();if(!window.localStorage)return n(null,null);var i=$(""+this.options.prefix+t+"-"+e);if(i&&(i=JSON.parse(i)).i18nStamp&&o<i.i18nStamp+this.options.expirationTime&&this.options.versions[t]===i.i18nVersion)return delete i.i18nVersion,delete i.i18nStamp,n(null,i);n(null,null)}},{key:"save",value:function(t,e,n){window.localStorage&&(n.i18nStamp=(new Date).getTime(),this.options.versions[t]&&(n.i18nVersion=this.options.versions[t]),X(""+this.options.prefix+t+"-"+e,JSON.stringify(n)))}}]),n}();Q.type="backend";var J=[],W=J.forEach,G=J.slice;var Y="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};function Z(t,e){if(e&&"object"===(void 0===e?"undefined":Y(e))){var n="",o=encodeURIComponent;for(var i in e)n+="&"+o(i)+"="+o(e[i]);if(!n)return t;t=t+(-1!=t.indexOf("?")?"&":"?")+n.slice(1)}return t}function tt(t,e,n,o,i){o&&"object"===(void 0===o?"undefined":Y(o))&&(i||(o._t=new Date),o=Z("",o).slice(1)),e.queryStringParams&&(t=Z(t,e.queryStringParams));try{var r;(r=XMLHttpRequest?new XMLHttpRequest:new ActiveXObject("MSXML2.XMLHTTP.3.0")).open(o?"POST":"GET",t,1),e.crossDomain||r.setRequestHeader("X-Requested-With","XMLHttpRequest"),r.withCredentials=!!e.withCredentials,o&&r.setRequestHeader("Content-type","application/x-www-form-urlencoded"),r.overrideMimeType&&r.overrideMimeType("application/json");var a=e.customHeaders;if(a)for(var s in a)r.setRequestHeader(s,a[s]);r.onreadystatechange=function(){3<r.readyState&&n&&n(r.responseText,r)},r.send(o)}catch(t){console&&console.log(t)}}var et=function(){function o(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(t,e,n){return e&&o(t.prototype,e),n&&o(t,n),t}}();var nt=function(){function n(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,n),this.init(t,e),this.type="backend"}return et(n,[{key:"init",value:function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};this.services=t,this.options=function(n){return W.call(G.call(arguments,1),function(t){if(t)for(var e in t)void 0===n[e]&&(n[e]=t[e])}),n}(e,this.options||{},{loadPath:"/locales/{{lng}}/{{ns}}.json",addPath:"/locales/add/{{lng}}/{{ns}}",allowMultiLoading:!1,parse:JSON.parse,crossDomain:!1,ajax:tt})}},{key:"readMulti",value:function(t,e,n){var o=this.options.loadPath;"function"==typeof this.options.loadPath&&(o=this.options.loadPath(t,e));var i=this.services.interpolator.interpolate(o,{lng:t.join("+"),ns:e.join("+")});this.loadUrl(i,n)}},{key:"read",value:function(t,e,n){var o=this.options.loadPath;"function"==typeof this.options.loadPath&&(o=this.options.loadPath([t],[e]));var i=this.services.interpolator.interpolate(o,{lng:t,ns:e});this.loadUrl(i,n)}},{key:"loadUrl",value:function(i,r){var a=this;this.options.ajax(i,this.options,function(t,e){if(500<=e.status&&e.status<600)return r("failed loading "+i,!0);if(400<=e.status&&e.status<500)return r("failed loading "+i,!1);var n=void 0,o=void 0;try{n=a.options.parse(t,i)}catch(t){o="failed parsing "+i+" to json"}if(o)return r(o,!1);r(null,n)})}},{key:"create",value:function(t,n,e,o){var i=this;"string"==typeof t&&(t=[t]);var r={};r[e]=o||"",t.forEach(function(t){var e=i.services.interpolator.interpolate(i.options.addPath,{lng:t,ns:n});i.options.ajax(e,i.options,function(t,e){},r)})}}]),n}();nt.type="backend";var ot=3e4;function it(t,e){if(e&&"object"==typeof e){var n="",o=encodeURIComponent;for(var i in e)n+="&"+o(i)+"="+o(e[i]);if(!n)return t;t=t+(-1!=t.indexOf("?")?"&":"?")+n.slice(1)}return t}function rt(t){var e=arguments;e[1]&&e[1].ajaxMethod?e[1].ajaxMethod(e[0],e[1],e[2],e[3],e[4]):(window.i18nAjaxQueue||(window.i18nAjaxQueue=[]),window.i18nAjaxQueue.push(arguments),window.i18nAjaxQueueCount||(window.i18nAjaxQueueCount=0,window.i18nAjaxGo=setInterval(function(){if(window.i18nAjaxQueueCount<=1)if(0<window.i18nAjaxQueue.length){window.i18nAjaxQueueCount+=1;var t=window.i18nAjaxQueue.shift();!function(t,e,n,o,i){o&&"object"==typeof o&&(i||(o._t=new Date),o=it("",o).slice(1));e.queryStringParams&&(t=it(t,e.queryStringParams));try{var r;(r=XMLHttpRequest?new XMLHttpRequest:new ActiveXObject("MSXML2.XMLHTTP.3.0")).open(o?"POST":"GET",t,1),r.timeout=ot,e.crossDomain||r.setRequestHeader("X-Requested-With","XMLHttpRequest"),r.withCredentials=!!e.withCredentials,o&&r.setRequestHeader("Content-type","application/x-www-form-urlencoded"),r.overrideMimeType&&r.overrideMimeType("application/json");var a=e.customHeaders;if(a)for(var s in a)r.setRequestHeader(s,a[s]);r.onreadystatechange=function(){3<r.readyState&&(window.i18nAjaxQueueCount-=1,n&&n(r.responseText,r))},r.send(o)}catch(t){console&&console.log("Get I18N data failed!The app will render with defalut language."),console&&console.log(t)}}(t[0],t[1],t[2],t[3],t[4])}else clearInterval(window.i18nAjaxGo),delete window.i18nAjaxGo,delete window.i18nAjaxQueue,delete window.i18nAjaxQueueCount},100)))}var at=H,st={"BeisenCloud-PC":"BeisenCloud$PCFrontCommonSource","BeisenCloud-Mobile":"BeisenCloud$MobileFrontCommonSource","Ocean-PC":"Ocean$PC_front","Ocean-Mobile":"Ocean$mobile_front","iTalent-H5":"Mobile$ItalentMobileH5"},lt=function(t){var e={lng:t.lng,debug:t.debug||!1,whitelist:t.whitelist||["en_US","zh_CN","zh_TW"],backend:{backends:[Q,nt],backendOptions:[{prefix:"".concat(st[t.platform]||t.namespaces&&""+t.namespaces||app,"_").concat(t.application,"_i18n_resources_"),expirationTime:t.debug?1:6048e5,versions:t.versions},{withCredentials:!0,crossDomain:!0,ajaxMethod:t.ajaxMethod,ajax:rt}]}},n=[];return st[t.platform]&&n.push("System"),t.namespaces?n=n.concat(t.namespaces):t.platform&&0==t.platform.indexOf("BeisenCloud")&&n.push("Application"),e.ns=n,e.defaultNS=n[0],e};function ut(t){this.i18next=t,this.ready=!1}var ct=ut.prototype;ct.getTrans=function(t,e){if(this.ready){var n=this.i18next;return n.exists(t)?n.t(t,e):void 0}},ct.getTransList=function(t){if(!this.ready)return{};var e=this.i18next,n={};if("zh_CN"==this.config.lng)return n;for(var o=0;o<t.length;o++){var i=t[o];if("string"==typeof i){var r=e.t(i);r!=i&&(n[i]=r)}else{var a=e.t(i[0],i[1]);a!=i&&(n[i[0]]=a)}}return n},ct.getDataByGroup=function(t,e){if(!this.ready)return{};var n=this.i18next;return"zh_CN"!=this.config.lng&&n.store.data[this.config.lng]&&n.store.data[this.config.lng][t]?e?n.store.data[this.config.lng][t][e]||{}:n.store.data[this.config.lng][t]:{}},ct.isExist=function(t){return!!this.ready&&this.i18next.exists(t)},ct.i18nextInit=function(n,t){if(n){this.config=n;var o=this;this.i18next.use(U).init(t,function(t,e){t||(o.ready=!0),n.callback(t)})}else this.config={lng:"zh_CN"},console.log("配置错误，请检查多语言参数")},ct.appInit=function(o){var t=lt(o),i=o.i18nSite||"//i18n.italent.cn";"zh_CN"!=o.lng?(t.backend.backendOptions[1].loadPath=function(t,e){var n=o.versions&&o.versions[t]||"";return"System"==e?"".concat(i,"/api/resources?appName=SysMartions&lang={{lng}}&NameSpaces=").concat(st[o.platform],"&version=").concat(n):"Application"==e?"".concat(i,"/api/AppResources?appName=").concat(o.application,"&lang={{lng}}&TagCode=").concat(o.platform):"isSysRes"==o.platform?"".concat(i,"/api/resources?appName=SysMartions&lang={{lng}}&NameSpaces={{ns}}&version=").concat(n):"".concat(i,"/api/AppResources?appName=").concat(o.application,"&lang={{lng}}&NameSpaces={{ns}}&version=").concat(n)},this.i18nextInit(o,t)):o.callback()},ct.moduleInit=function(o){var t=lt(o),i=o.i18nSite||"i18n.italent.cn";"zh_CN"!=o.lng?(t.backend.backendOptions[0].prefix="".concat(o.tmplName,"_i18n_resources_module_"),t.backend.backendOptions[1].loadPath=function(t,e){var n=o.versions&&o.versions[t]||"";return"isSysRes"==o.platform?"".concat(i,"/api/resources?appName=SysMartions&lang={{lng}}&NameSpaces={{ns}}"):"".concat(i,"/api/AppResources?appName=").concat(o.application,"&lang={{lng}}&version=").concat(n,"&NameSpaces={{ns}}")},this.i18nextInit(o,t)):o.callback()},ct.create=function(){return new ut(at.createInstance())};var pt=new ut(H); true?("undefined"!=typeof module&&module.exports&&(exports=module.exports=pt),exports.I18NTools=pt):window.I18NTools=window.I18NTools||pt}();
	//# sourceMappingURL=i18n-tools.min.js.map


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	if (exports.__esModule === undefined) {
	  Object.defineProperty(exports, '__esModule', {
	    value: true
	  });
	}

	Object.defineProperty(exports, 'FeedDetail', {
	  enumerable: true,
	  get: function get() {
	    var m = __webpack_require__(141);

	    if (!m || !m.__esModule) {
	      m = {
	        default: m
	      };
	    }

	    return m.default;
	  }
	});
	Object.defineProperty(exports, 'SimpleFeedDetail', {
	  enumerable: true,
	  get: function get() {
	    var m = __webpack_require__(75);

	    if (!m || !m.__esModule) {
	      m = {
	        default: m
	      };
	    }

	    return m.default;
	  }
	});
	Object.defineProperty(exports, 'FeedList', {
	  enumerable: true,
	  get: function get() {
	    var m = __webpack_require__(144);

	    if (!m || !m.__esModule) {
	      m = {
	        default: m
	      };
	    }

	    return m.default;
	  }
	});
	Object.defineProperty(exports, 'SimpleFeedList', {
	  enumerable: true,
	  get: function get() {
	    var m = __webpack_require__(76);

	    if (!m || !m.__esModule) {
	      m = {
	        default: m
	      };
	    }

	    return m.default;
	  }
	});
	Object.defineProperty(exports, 'PublishNews', {
	  enumerable: true,
	  get: function get() {
	    var m = __webpack_require__(156);

	    if (!m || !m.__esModule) {
	      m = {
	        default: m
	      };
	    }

	    return m.default;
	  }
	});
	Object.defineProperty(exports, 'SimpleFeed', {
	  enumerable: true,
	  get: function get() {
	    var m = __webpack_require__(113);

	    if (!m || !m.__esModule) {
	      m = {
	        default: m
	      };
	    }

	    return m.default;
	  }
	});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _reactDom = __webpack_require__(24);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _index = __webpack_require__(11);

	var _FeedReplyList = __webpack_require__(50);

	var _FeedReplyList2 = _interopRequireDefault(_FeedReplyList);

	var _ReplyInputFooter = __webpack_require__(49);

	var _ReplyInputFooter2 = _interopRequireDefault(_ReplyInputFooter);

	var _FeedTimeLineList = __webpack_require__(30);

	var _FeedTimeLineList2 = _interopRequireDefault(_FeedTimeLineList);

	var _chaosUi = __webpack_require__(8);

	var _i18nTools = __webpack_require__(111);

	var _i18nTools2 = _interopRequireDefault(_i18nTools);

	var _ConcatFeedDefaultTranslation = __webpack_require__(114);

	var _ConcatFeedDefaultTranslation2 = _interopRequireDefault(_ConcatFeedDefaultTranslation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(223);

	/**
	 * feed 被插件接入 只显示沟通和操作记录
	 */

	var ConcatFeed = function (_Component) {
		(0, _inherits3.default)(ConcatFeed, _Component);

		function ConcatFeed(props) {
			(0, _classCallCheck3.default)(this, ConcatFeed);

			var _this = (0, _possibleConstructorReturn3.default)(this, (ConcatFeed.__proto__ || (0, _getPrototypeOf2.default)(ConcatFeed)).call(this, props));

			_this.onReplyInputFooterHeightChange = function (h) {
				_this.setState({
					replyInputFooterHeight: h
				});
			};

			_this.switchTab = _this.switchTab.bind(_this);
			_this.replyItemFn = _this.replyItemFn.bind(_this);
			_this.addComments = _this.addComments.bind(_this);
			_this.setConcatFeedData = _this.setConcatFeedData.bind(_this);
			_this.deleteComments = _this.deleteComments.bind(_this);
			// this.handleTouchMove = this.handleTouchMove.bind(this);
			// this.handleTouchStart = this.handleTouchStart.bind(this);

			_this.translation = _ConcatFeedDefaultTranslation2.default;

			_this.state = {
				replyInputFooterHeight: 51, // 51 is the default height for old version reply
				feedOperations: {
					total: 0,
					comments: []
				},
				feedComments: [],
				active: '1', //1、回复列表, 2、操作记录
				loading: true,
				translation: _this.translation
			};
			_this.isTouchSwitch = false;
			return _this;
		}

		// 回复


		(0, _createClass3.default)(ConcatFeed, [{
			key: 'replyItemFn',
			value: function replyItemFn(data) {
				this.setState({
					replyItem: data
				});
			}
		}, {
			key: 'addComments',
			value: function addComments(respData) {
				// let feedComments = this.state.feedComments;
				// if(respData.Code == 1) {
				// 	if(feedComments.total == 0){
				// 		feedComments = {
				// 			total : 1,
				// 			comments : [respData.Data]
				// 		}
				// 	}else{
				// 		feedComments.total = feedComments.total + 1;
				// 		feedComments.comments.push(respData.Data)
				// 	}
				// }
				// this.setState({
				// 	replyItem : null
				// 	,feedComments
				// },()=>{
				// 	setTimeout(()=>{
				// 		let scrollContent = this.refs.container.parentNode;
				// 		scrollContent.scrollTop = scrollContent.scrollHeight - scrollContent.getBoundingClientRect().height;
				// 	},50);
				// });
				this.setState({
					replyItem: null
				});
				this.setConcatFeedData();
			}
		}, {
			key: 'deleteComments',
			value: function deleteComments(data) {
				// let feedComments = this.state.feedComments;
				// feedComments.comments = feedComments.comments.filter(item => {
				// 	return item.commentId != data.commentId;
				// });
				// feedComments.total = feedComments.total -1;
				// this.setState({
				// 	feedComments
				// });
				this.setConcatFeedData();
			}
		}, {
			key: 'switchTab',
			value: function switchTab(event) {
				this.isTouchSwitch = true;
				var activeKey = event.target.getAttribute('data-key');
				if (activeKey && activeKey != this.state.active) {
					this.setState({
						active: activeKey
					});
				}
			}

			// 获取feedData

		}, {
			key: 'setConcatFeedData',
			value: function setConcatFeedData() {
				var _this2 = this;

				// 取消下面的注释以启用Mock ----------------------------------------------------------------------- //
				// const r = require('../../../app/mock');
				// const state = Object.assign({}, r.FeedList.Data, { loading: false });
				// state.translation = this.translation;
				// this.setState(state);
				// return;
				// ----------------------------------------------------------------------- 注释上面的代码以禁用Mock //

				var url = (0, _index.urlComplete)('/api/v2/{tenant_id}/{user_id}/user/feed/GetById');
				var params = {
					feed_id: this.props.feedId,
					'comment_count': 99
				};
				(0, _index.callFetch)(url, 'GET', params).then(function (respData) {
					var state = (0, _extends3.default)({}, respData.Data, { loading: false });
					state.translation = _this2.translation;
					_this2.setState(state);
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.setConcatFeedData();
				this.loadI18N();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.replyFooter = document.createElement('div');
				document.body.appendChild(this.replyFooter);
				this.renderReplyFooter();
				this.refs.container.parentNode.style.backgroundColor = "#f5f6f7";
				// this.refs.container.parentNode.addEventListener('touchstart',this.handleTouchStart,false);
				// this.refs.container.parentNode.addEventListener('touchmove',this.handleTouchMove,false);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.state.active === '1') {
					this.renderReplyFooter();
				} else {
					this.removeReplyFooter();
				}
			}
		}, {
			key: 'loadI18N',
			value: function loadI18N() {
				var _this3 = this;

				var shouldLoad = false;
				try {
					shouldLoad = window.BSGlobal.I18NInfo.I18NUserLang && window.BSGlobal.I18NInfo.I18NFrontEndHost;
				} catch (ex) {
					shouldLoad = false;
				}
				if (!shouldLoad) {
					return;
				}
				_i18nTools2.default.appInit({
					lng: window.BSGlobal.I18NInfo.I18NUserLang,
					i18nSite: window.BSGlobal.I18NInfo.I18NFrontEndHost,
					// debug: true,
					platform: 'iTalent-H5',
					callback: function callback(err) {
						_this3.translation = {
							MobileUpaasUI: _i18nTools2.default.getDataByGroup('System', 'MobileUpaasUI'),
							DynamicStates: _i18nTools2.default.getDataByGroup('System', 'DynamicStates')
						};
						_this3.setState({
							translation: _this3.translation
						});
					}
				});
			}
		}, {
			key: 'renderReplyFooter',
			value: function renderReplyFooter() {
				var _this4 = this;

				var replyFooter = React.createElement(_ReplyInputFooter2.default, {
					translation: this.translation,
					footercls: this.props.footercls,
					isDetail: true,
					isFocusInput: false,
					feedId: this.props.feedId,
					replyPerson: this.state.replyItem,
					afterSave: this.addComments,
					onHeightChange: this.onReplyInputFooterHeightChange
				});
				_reactDom2.default.unstable_renderSubtreeIntoContainer(this, replyFooter, this.replyFooter, function () {
					_this4.isTouchSwitch && _this4.props.feedSwitchTabHandler && _this4.props.feedSwitchTabHandler('1');
					_this4.isTouchSwitch = false;
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.removeReplyFooter();
			}
		}, {
			key: 'removeReplyFooter',
			value: function removeReplyFooter() {
				_reactDom2.default.unmountComponentAtNode(this.replyFooter);
			}

			// handleTouchMove(evt){
			// 	let el = evt.currentTarget;

			// 	let curY = evt.changedTouches ? evt.changedTouches[0].screenY : evt.screenY;
			// 	let height = el.getBoundingClientRect().height;
			// 	let isAtTop = (this.startPageY <= curY && el.scrollTop === 0);

			// 	let isAtBottom = (this.startPageY >= curY && el.scrollHeight - el.scrollTop === height);

			// 	if (isAtTop || isAtBottom) {
			// 		evt.preventDefault();
			// 	}
			// }

			// handleTouchStart(evt){
			// 	this.startPageY = evt.changedTouches ? evt.changedTouches[0].screenY : evt.screenY;
			// }

		}, {
			key: 'render',
			value: function render() {
				var _state = this.state,
				    loading = _state.loading,
				    translation = _state.translation,
				    replyInputFooterHeight = _state.replyInputFooterHeight,
				    feedOperations = _state.feedOperations,
				    feedComments = _state.feedComments,
				    active = _state.active;
				var _props = this.props,
				    feedId = _props.feedId,
				    hideOperation = _props.hideOperation;

				var isEmpty = active === '1' && !feedComments.comments || active === '2' && feedOperations.total == 0;
				var emptyStyle = isEmpty ? { height: this.props.contentHeight + 'px' } : {};
				var feedCommentsContainerStyle = {};
				var feedCommentDataStyle = {
					paddingBottom: isEmpty ? '0' : replyInputFooterHeight + 8 + 'px'
				};
				return React.createElement(
					'div',
					{ ref: 'container',
						className: 'feed-comments-container' + (isEmpty ? ' empty' : ''),
						style: feedCommentsContainerStyle },
					React.createElement(
						'div',
						{ ref: 'content', className: 'feed-comment-data' + (isEmpty ? ' empty' : ''), style: feedCommentDataStyle },
						React.createElement(
							'ul',
							{ className: 'simple-feed-title border-1px border-b', onTouchTap: this.switchTab },
							React.createElement(
								'li',
								{ className: (0, _classnames2.default)({ 'active': active === '1' }), 'data-key': '1' },
								translation.MobileUpaasUI.SimpleFeedTabComm
							),
							hideOperation ? null : React.createElement(
								'li',
								{ className: (0, _classnames2.default)({ 'active': active === '2' }), 'data-key': '2' },
								translation.MobileUpaasUI.SimpleFeedTabOperation
							)
						),
						React.createElement(
							'div',
							{ className: 'simple-feed-content', style: emptyStyle },
							loading ? React.createElement(_chaosUi.Loading, null) : active === '1' ? feedComments.comments ? React.createElement(_FeedReplyList2.default, (0, _extends3.default)({}, feedComments, {
								translation: translation,
								isDetail: true,
								replyItemFn: this.replyItemFn,
								afterDeleteComments: this.deleteComments
							})) : React.createElement(
								'div',
								{ className: 'empty-con' },
								React.createElement('div', { className: 'empty-bgimage' }),
								React.createElement(
									'span',
									{ className: 'empty-text' },
									this.props.emptyTxt || translation.MobileUpaasUI.NoData
								)
							) : React.createElement(_FeedTimeLineList2.default, { showBar: true,
								translation: translation,
								isConcat: true,
								feedOperations: feedOperations,
								feedId: feedId,
								contentHeight: this.props.contentHeight
							})
						)
					)
				);
			}
		}]);
		return ConcatFeed;
	}(_react.Component);

	exports.default = ConcatFeed;
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  MobileUpaasUI: {
	    "SimpleFeedTabComm": "沟通",
	    "SimpleFeedTabOperation": "操作记录",
	    "Comment": "评论",
	    "Collapse": "收起",
	    "Expand": "展开更多",
	    "NoData": "这里什么都没有…",
	    "ChooseAtPerson": "选择同事",
	    "Picture": "照片",
	    "Eomticon": "表情",
	    "SearchPersonPlaceholder": "请搜索你要选择的同事"
	  },
	  DynamicStates: {
	    "Dynamic": "动态",
	    "Confirm": "确定",
	    "Cancel": "取消",
	    "Delete": "删除",
	    "Close": "关闭",
	    "Send": "发送",
	    "Clear": "清空",
	    "ConfirmSend": "确定",
	    "IKnow": "我知道了",
	    "IsTop": "置顶",
	    "CancelTop": "取消置顶",
	    "Expand": "展开",
	    "Collapse": "收起",
	    "Reply": "回复",
	    "ReplyToUser": "回复",
	    "ViewAll": "查看全部",
	    "Comment": "评论",
	    "Search": "搜索",
	    "PullDown": "下拉刷新",
	    "PullUp": "释放更新",
	    "OfflineTip": "网络不给力",
	    "OfflineMessage": "当前网络不可用，请检查网络设置",
	    "ServerErrorMessage": "抱歉，服务器开小差，请稍后重试",
	    "FeedEmpty": "暂时没有动态哦",
	    "LoadingText": "加载中…",
	    "EmptyText": "没有相关的搜索结果…",
	    "NoMoreText": "没有更多了",
	    "OfflineContent": "别紧张，点击页面刷新试试",
	    "TopSuccess": "置顶成功",
	    "UnpinnedSuccessfully": "取消置顶成功",
	    "UpToDynamics": "最多置顶${{count}}条动态",
	    "SuccessfulCopy": "复制成功",
	    "SearchPlaceholder": "搜索",
	    "SearchCancelText": "取消",
	    "FeedDetailTitle": "动态详情",
	    "DeleteFeedMes": "确定删除此动态？",
	    "DeleteReplyConfirm": "确定删除此回复？",
	    "AtNoPersonSelect": "你还没选择同事哦〜",
	    "SendShare": "发分享",
	    "SendSharePlaceholder": "有事需要提醒Ta，请@Ta",
	    "VisiblePublic": "公开",
	    "VisibleToDep": "仅部门可见",
	    "VisibleToMember": "仅相关成员可见",
	    "SendShareTextOverflowTip": "输入内容不能超过${{count}}字",
	    "ReplyPlaceholder": "回复：说点什么吧~",
	    "AtAll": "所有人",
	    "TextOverflowTip": "内容长度已达上限",
	    "PressToTalkTip": "按住说话",
	    "ReleaseTip": "松开结束",
	    "TimeoutTip": "已达语音时长限制",
	    "VoiceUnrecognized": "未有效识别到语音信息",
	    "MaxImageCountTip": "图片最多上传${{count}}张",
	    "FileShareAutoText": "分享了文件",
	    "DownLoadError": "下载失败",
	    "DownLoadSuccess": "下载成功",
	    "ViewBigPic": "查看大图",
	    "Loading": "加载中...",
	    "Topped": "已置顶",
	    "SendShareResultTipSending": "发送中...",
	    "SendShareResultTipSent": "已发送",
	    "ConnectionFailed": "连接失败",
	    "BackToTop": "顶部"
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(225);

	/*
	 * Name: Feed主体任务计数
	 * Desc: Feed主体任务计数
	 * Author: lilei@beisen.com
	 */

	var FeedContentCount = function (_Component) {
		(0, _inherits3.default)(FeedContentCount, _Component);

		function FeedContentCount(props) {
			(0, _classCallCheck3.default)(this, FeedContentCount);
			return (0, _possibleConstructorReturn3.default)(this, (FeedContentCount.__proto__ || (0, _getPrototypeOf2.default)(FeedContentCount)).call(this, props));
		}

		(0, _createClass3.default)(FeedContentCount, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    counter = _props.counter,
				    children = _props.children;

				return React.createElement(
					'ul',
					{ className: 'content-count' },
					React.createElement(
						'li',
						{ className: 'content-comment-count' },
						counter.commentTotal
					),
					React.createElement(
						'li',
						{ className: 'content-attachment-count' },
						counter.attachmentTotal
					),
					React.createElement(
						'li',
						{ className: 'content-task-count' },
						counter.taskTotal
					)
				);
			}
		}]);
		return FeedContentCount;
	}(_react.Component);

	exports.default = FeedContentCount;
	module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(228);

	/*
	 * Name: Feed主体任务状态，审批状态
	 * Desc: Feed主体任务状态，审批状态
	 * Author: lilei@beisen.com
	 */

	var FeedContentState = function (_Component) {
		(0, _inherits3.default)(FeedContentState, _Component);

		function FeedContentState(props) {
			(0, _classCallCheck3.default)(this, FeedContentState);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedContentState.__proto__ || (0, _getPrototypeOf2.default)(FeedContentState)).call(this, props));

			_this.getClassName = _this.getClassName.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(FeedContentState, [{
			key: 'getClassName',
			value: function getClassName() {
				var status = this.props.status;

				return ['feed-content-state ', 'state-', status].join('');
			}
		}, {
			key: 'render',
			value: function render() {
				var avatarInfo = this.props.avatarInfo;

				return React.createElement('div', { className: this.getClassName() });
			}
		}]);
		return FeedContentState;
	}(_react.Component);

	exports.default = FeedContentState;
	module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _promise = __webpack_require__(45);

	var _promise2 = _interopRequireDefault(_promise);

	exports.uploadUserFile = uploadUserFile;

	var _index = __webpack_require__(11);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function uploadUserFile_iOS(filePath, url) {
	  return new _promise2.default(function (resolve, reject) {
	    window.api.ajax({
	      url: url,
	      method: 'post',
	      dataType: 'json',
	      data: {
	        files: {
	          file: filePath
	        }
	      }
	    }, function (ret, err) {
	      if (err) {
	        reject(err);
	        return;
	      }
	      resolve(ret);
	    });
	  });
	}

	function uploadUserFile_Android(filePath, url) {
	  return new _promise2.default(function (resolve, reject) {
	    bsDroidAjax({
	      url: url,
	      method: 'upload',
	      uploadFileName: 'italent-' + Math.random() * 10 + 1,
	      uploadFilePath: filePath
	    }, function (ret, err) {
	      if (err) {
	        reject(err);
	        return;
	      }
	      resolve(ret);
	    });
	  });
	}

	function bsDroidAjax(params, cb) {
	  window.BSJSBridge.callHandler('bs-droid-ajax', params, function (ret, err) {
	    var retData = {};
	    var Code = 0;
	    try {
	      retData = JSON.parse(decodeURIComponent(ret));
	    } catch (e) {
	      retData = null;
	      if (ret.indexOf('404') > -1) {
	        Code = 404;
	      } else if (ret.indexOf('500') > -1) {
	        Code = 500;
	      } else if (ret.indexOf('401') > -1) {
	        Code = 401;
	      } else {
	        Code = 500;
	      }
	      err = {
	        Code: Code,
	        error_description: '抱歉，接口出错啦，请重试~'
	      };
	    }
	    var errData = {};
	    if (retData && (retData.error || retData.Type == 'error')) {
	      // android接口报错情况，除了400和401，都返回retData.Type == 'error'
	      errData.error = retData;
	      cb && cb(retData, errData);
	    } else {
	      cb && cb(retData, err);
	    }
	  });
	}

	function uploadUserFile(atchImg) {
	  var url = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/Upload/PostFiles?format=json&timestamp=' + new Date().getTime());

	  var timeoutProm = new _promise2.default(function (resolve, reject) {
	    setTimeout(function () {
	      reject(new Error('timeout'));
	    }, 30000);
	  });

	  var uploadFunc = window.getMoleJS().platform.ios ? uploadUserFile_iOS : uploadUserFile_Android;
	  var uploadProm = new _promise2.default(function (resolve, reject) {
	    var filePath = atchImg.image.original;
	    if (!filePath) {
	      reject(new Error('empty file path'));
	      return;
	    }
	    uploadFunc(filePath, url).then(resolve, reject);
	  });

	  return _promise2.default.race([timeoutProm, uploadProm]).then(function (ret) {
	    if (ret && Array.isArray(ret.Result) && ret.Result.length === 1) {
	      atchImg.uploaded = ret.Result[0];
	    } else {
	      throw new Error('empty result');
	    }
	    return atchImg;
	  }).catch(function (ex) {
	    var err = ex instanceof Error ? ex : new Error(ex);
	    atchImg.uploadError = err;
	    return _promise2.default.reject(err);
	  });
	}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(22);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(24);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	__webpack_require__(233);

	var _ImagePreviewer = __webpack_require__(67);

	var _ImagePreviewer2 = _interopRequireDefault(_ImagePreviewer);

	var _ActionButton = __webpack_require__(35);

	var _ActionButton2 = _interopRequireDefault(_ActionButton);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var AttachedImages = function (_Component) {
	  (0, _inherits3.default)(AttachedImages, _Component);

	  function AttachedImages(props) {
	    (0, _classCallCheck3.default)(this, AttachedImages);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (AttachedImages.__proto__ || (0, _getPrototypeOf2.default)(AttachedImages)).call(this, props));

	    _this.startFakeProgressTimer = function () {
	      _this.stopFakeProgressTimer();
	      _this.fakeProgressTimer = setInterval(function () {
	        var images = _this.props.images;

	        images.forEach(function (atcImg, idx) {
	          if (atcImg.uploaded || atcImg.uploadError) {
	            return;
	          }
	          var changed = false;
	          if (!atcImg.fakeUploadProgress) {
	            atcImg.fakeUploadProgress = 0;
	            changed = true;
	          }
	          if (atcImg.fakeUploadProgress < 0.91) {
	            atcImg.fakeUploadProgress += Math.random() * 0.1;
	            if (atcImg.fakeUploadProgress > 0.91) {
	              atcImg.fakeUploadProgress = 0.91;
	            }
	            changed = true;
	          }
	          if (changed) {
	            _this.renderFakeProgress(idx);
	          }
	        });
	      }, 170);
	    };

	    _this.stopFakeProgressTimer = function () {
	      if (_this.fakeProgressTimer) {
	        clearInterval(_this.fakeProgressTimer);
	        _this.fakeProgressTimer = null;
	      }
	    };

	    _this.renderFakeProgress = function (idx) {
	      var el = _this.refs.elRef;
	      var images = _this.props.images;

	      var atcImg = images[idx];
	      var progress = atcImg.uploaded ? 1 : atcImg.fakeUploadProgress || 0;
	      var textEl = el.querySelector('.progress-text[data-index="' + idx + '"]');
	      var maskEl = el.querySelector('.uploading-mask[data-index="' + idx + '"]');
	      if (textEl) {
	        textEl.innerHTML = Math.floor((progress || 0) * 100) + '%';
	      }
	      if (maskEl) {
	        maskEl.style.transform = 'translateY(' + Math.floor(progress * 100) + '%)';
	      }
	    };

	    _this.onView = function (atcImg, idx) {
	      var images = _this.props.images;

	      var validImages = images.filter(function (atcImg) {
	        return !!atcImg.uploaded;
	      });
	      var idxInValid = validImages.indexOf(atcImg);
	      var urls = validImages.map(function (atcImg) {
	        return atcImg.uploaded.ClientUrl;
	      });
	      (0, _ImagePreviewer2.default)(urls, function () {
	        _this.onViewerClose(atcImg, idx);
	      }, { start: idxInValid });
	      var onPreviewOpen = _this.props.onPreviewOpen;

	      onPreviewOpen && onPreviewOpen(atcImg, idx);
	    };

	    _this.onViewerClose = function (atcImg, idx) {
	      var onPreviewClose = _this.props.onPreviewClose;

	      onPreviewClose && onPreviewClose(atcImg, idx);
	    };

	    _this.onDelete = function (atcImg, idx) {
	      var onDelete = _this.props.onDelete;

	      onDelete && onDelete(atcImg, idx);
	    };

	    _this.state = {};
	    return _this;
	  }

	  (0, _createClass3.default)(AttachedImages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.startFakeProgressTimer();
	      this.refs.elRef.addEventListener('touchstart', function (evt) {});
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopFakeProgressTimer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;

	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          images = _props.images,
	          onDelete = _props.onDelete,
	          onPreviewOpen = _props.onPreviewOpen,
	          onPreviewClose = _props.onPreviewClose,
	          restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'images', 'onDelete', 'onPreviewOpen', 'onPreviewClose']);

	      var wrapperStyle = {};
	      wrapperStyle.width = 50 + (images.length - 1) * 58 + 12 + 'px';

	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ ref: 'elRef', className: className + ' mobile-replay-attached-images' }, restProps),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile-replay-general-line' },
	          _react2.default.createElement('div', { className: 'down' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper', style: wrapperStyle },
	          images.map(function (atcImg, idx) {
	            var isPNG = /\.png$/i.test(atcImg.image.original);
	            var imgBtnStyle = {
	              backgroundImage: 'url(data:image/' + (isPNG ? 'png' : 'jpeg') + ';base64,' + atcImg.image.thumb + ')'
	            };
	            var errorStyle = {};
	            var progressStyle = {};
	            if (atcImg.uploaded || atcImg.uploadError) {
	              progressStyle.display = 'none';
	            }
	            if (!atcImg.uploadError) {
	              errorStyle.display = 'none';
	            }
	            var disableViewBtn = !atcImg.uploaded || atcImg.uploadError;
	            return _react2.default.createElement(
	              'div',
	              { className: 'mobile-replay-attached-images-cell', key: atcImg.id },
	              _react2.default.createElement(_ActionButton2.default, { className: 'view-btn', style: imgBtnStyle,
	                disabled: disableViewBtn, onClick: function onClick() {
	                  _this2.onView(atcImg, idx);
	                } }),
	              _react2.default.createElement(
	                'div',
	                { className: 'uploading-progress', style: progressStyle },
	                _react2.default.createElement('span', { className: 'progress-text', 'data-index': idx }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'uploading-mask', 'data-index': idx },
	                  '\xA0'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'upload-error', style: errorStyle },
	                '\xA0'
	              ),
	              _react2.default.createElement(_ActionButton2.default, { className: 'delete-btn', onClick: function onClick() {
	                  _this2.onDelete(atcImg, idx);
	                } })
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return AttachedImages;
	}(_react.Component);

	AttachedImages.defaultProps = {
	  images: []
	};
	exports.default = AttachedImages;
	module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(22);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(234);

	var _Eomticon = __webpack_require__(120);

	var _Eomticon2 = _interopRequireDefault(_Eomticon);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// import Eomticon from '../../../../common/Eomticon/Eomticon';

	// export interface EmojiPanelProps {
	//   onInput?: (em: string) => void;
	//   onDelete?: () => void;
	//   [key: string]: any;
	// }

	var EmojiPanel = function (_Component) {
	  (0, _inherits3.default)(EmojiPanel, _Component);

	  function EmojiPanel(props) {
	    (0, _classCallCheck3.default)(this, EmojiPanel);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiPanel.__proto__ || (0, _getPrototypeOf2.default)(EmojiPanel)).call(this, props));

	    _this.state = {};
	    return _this;
	  }

	  (0, _createClass3.default)(EmojiPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.elRef.addEventListener('touchmove', function (evt) {
	        evt.preventDefault();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          onInput = _props.onInput,
	          onDelete = _props.onDelete,
	          translation = _props.translation,
	          restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'onInput', 'onDelete', 'translation']);

	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ ref: 'elRef', className: 'replay-emojipanel ' + className }, restProps),
	        _react2.default.createElement(_Eomticon2.default, { inputEomticon: onInput, deleteEomticon: onDelete })
	      );
	    }
	  }]);
	  return EmojiPanel;
	}(_react.Component);

	EmojiPanel.defaultProps = {
	  onInput: function onInput() {},
	  onDelete: function onDelete() {}
	};
	exports.default = EmojiPanel;
	module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _index = __webpack_require__(11);

	var _EomticonContent = __webpack_require__(121);

	var _EomticonContent2 = _interopRequireDefault(_EomticonContent);

	var _EomticonPagingBar = __webpack_require__(122);

	var _EomticonPagingBar2 = _interopRequireDefault(_EomticonPagingBar);

	var _EomticonTypeTab = __webpack_require__(123);

	var _EomticonTypeTab2 = _interopRequireDefault(_EomticonTypeTab);

	__webpack_require__(235);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Eomticon = function (_Component) {
		(0, _inherits3.default)(Eomticon, _Component);

		function Eomticon(props) {
			(0, _classCallCheck3.default)(this, Eomticon);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Eomticon.__proto__ || (0, _getPrototypeOf2.default)(Eomticon)).call(this, props));

			_this.loadEmoticons = function () {
				var url = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/tenant/Eomticon');
				(0, _index.callFetch)(url, 'GET', {}).then(function (respData) {
					var dt = respData.Data.packages.filter(function (pkg) {
						return pkg.name === 'iTalent' || pkg.name === 'tita' || pkg.name === 'meep';
					}).map(function (pkg) {
						// rename tita to iTalent:
						if (pkg.name === 'tita') {
							pkg.name = 'iTalent';
						}
						pkg.emticons = pkg.emticons.map(function (e) {
							e.name = e.name.replace('tita:', 'iTalent:');
							return e;
						});
						return pkg;
					});
					_this.setState({
						eomticonData: dt
					});
				});
			};

			_this.changeEomticonType = _this.changeEomticonType.bind(_this);
			_this.changeEomticonPage = _this.changeEomticonPage.bind(_this);
			_this.state = {
				eomticonData: [],
				currentType: 0,
				currentPage: 0
			};
			return _this;
		}

		(0, _createClass3.default)(Eomticon, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;

				setTimeout(function () {
					_this2.loadEmoticons();
				}, 1000);
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'changeEomticonPage',


			// 切换当前Type下Page
			value: function changeEomticonPage(newPageNum) {
				this.setState({
					currentPage: parseInt(newPageNum)
				});
			}
		}, {
			key: 'changeEomticonType',
			value: function changeEomticonType(newTabNum) {
				this.setState({
					currentType: parseInt(newTabNum),
					currentPage: 0
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state,
				    eomticonData = _state.eomticonData,
				    currentType = _state.currentType,
				    currentPage = _state.currentPage;

				if (eomticonData.length == 0) {
					return null;
				};
				var currentTypeData = eomticonData[currentType];
				var eomticonTabCount = Math.ceil(currentTypeData.emticons.length / 20);
				var eomticonTypeData = eomticonData.map(function (item, index) {
					return item.name;
				});
				return _react2.default.createElement(
					'div',
					{ className: 'newreply-eomticon' },
					_react2.default.createElement(_EomticonContent2.default, {
						eomticonData: currentTypeData.emticons,
						eomticonTabCount: eomticonTabCount,
						eomticonHost: currentTypeData.host,
						currentPage: currentPage,
						changeEomticonPage: this.changeEomticonPage,
						inputEomticon: this.props.inputEomticon,
						deleteEomticon: this.props.deleteEomticon
					}),
					_react2.default.createElement(_EomticonPagingBar2.default, {
						currentPage: currentPage,
						eomticonTabCount: eomticonTabCount,
						changeEomticonPage: this.changeEomticonPage
					}),
					_react2.default.createElement(_EomticonTypeTab2.default, {
						currentType: currentType,
						eomticonTypeData: eomticonTypeData,
						changeEomticonType: this.changeEomticonType
					})
				);
			}
		}]);
		return Eomticon;
	}(_react.Component);

	exports.default = Eomticon;
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(236);

	var _ActionButton = __webpack_require__(35);

	var _ActionButton2 = _interopRequireDefault(_ActionButton);

	var _PagedView = __webpack_require__(68);

	var _PagedView2 = _interopRequireDefault(_PagedView);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Eomticon = function (_Component) {
		(0, _inherits3.default)(Eomticon, _Component);

		function Eomticon(props) {
			(0, _classCallCheck3.default)(this, Eomticon);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Eomticon.__proto__ || (0, _getPrototypeOf2.default)(Eomticon)).call(this, props));

			_this.onPageChange = function (pg) {
				_this.props.changeEomticonPage(pg);
			};

			return _this;
		}

		(0, _createClass3.default)(Eomticon, [{
			key: 'onClick',
			value: function onClick(name) {
				this.props.inputEomticon(name);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;

				var _props = this.props,
				    eomticonData = _props.eomticonData,
				    eomticonTabCount = _props.eomticonTabCount,
				    eomticonHost = _props.eomticonHost,
				    currentPage = _props.currentPage;


				var eomticonTables = [];

				var _loop = function _loop(i) {
					var currentEomticons = eomticonData.slice(i * 20, i * 20 + 20);
					var currentEomticonsTds = [];
					currentEomticons.forEach(function (item, index) {
						currentEomticonsTds.push(_react2.default.createElement(
							_ActionButton2.default,
							{ className: 'newreply-eomticon-cell', key: index,
								onClick: function onClick() {
									return _this2.onClick(item.name);
								} },
							_react2.default.createElement('img', { src: eomticonHost + item.address })
						));
					});
					// 不足7位的补足7位
					var extralTdCount = 7 - currentEomticonsTds.length % 7 - 1;
					for (var _i = 0; _i < extralTdCount; _i++) {
						currentEomticonsTds.push(_react2.default.createElement('div', { key: currentEomticonsTds.length + 1 + _i, className: 'newreply-eomticon-cell' }));
					}
					// 尾部追加删除按钮
					currentEomticonsTds.push(_react2.default.createElement(
						'div',
						{ className: 'newreply-eomticon-cell', key: currentEomticonsTds.length + 1 },
						_react2.default.createElement(_ActionButton2.default, { className: 'newreply-eomticon-delete-btn',
							onClick: _this2.props.deleteEomticon })
					));

					var tableWidth = document.body.clientWidth;
					//构建整个表情Table
					eomticonTables.push(_react2.default.createElement(
						'div',
						{ className: 'newreply-eomticon-table', style: { width: tableWidth }, key: i },
						_react2.default.createElement(
							'div',
							{ style: { width: tableWidth } },
							_react2.default.createElement(
								'div',
								{ className: 'newreply-eomticon-row', style: { width: tableWidth } },
								currentEomticonsTds.slice(0, 7)
							),
							_react2.default.createElement(
								'div',
								{ className: 'newreply-eomticon-row', style: { width: tableWidth } },
								currentEomticonsTds.slice(7, 14)
							),
							_react2.default.createElement(
								'div',
								{ className: 'newreply-eomticon-row', style: { width: tableWidth } },
								currentEomticonsTds.slice(14, 21)
							)
						)
					));
				};

				for (var i = 0; i < eomticonTabCount; i++) {
					_loop(i);
				}

				return _react2.default.createElement(
					_PagedView2.default,
					{ page: currentPage, count: this.props.eomticonTabCount, onPageChange: this.onPageChange },
					_react2.default.createElement(
						'div',
						{ className: 'newreply-eomticon-content' },
						eomticonTables
					)
				);
			}
		}]);
		return Eomticon;
	}(_react.Component);

	exports.default = Eomticon;
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(237);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Eomticon = function (_Component) {
		(0, _inherits3.default)(Eomticon, _Component);

		function Eomticon(props) {
			(0, _classCallCheck3.default)(this, Eomticon);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Eomticon.__proto__ || (0, _getPrototypeOf2.default)(Eomticon)).call(this, props));

			_this.onTouchTap = _this.onTouchTap.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(Eomticon, [{
			key: 'onTouchTap',
			value: function onTouchTap(e) {
				this.props.changeEomticonPage(e.target.getAttribute('data-eomticonpage'));
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    eomticonTabCount = _props.eomticonTabCount,
				    currentPage = _props.currentPage;
				// 构建分页栏

				var eomticonPagingBar = [];
				for (var i = 0; i < eomticonTabCount; i++) {
					eomticonPagingBar.push(_react2.default.createElement('div', { key: i,
						'data-eomticonpage': i,
						onClick: this.onTouchTap,
						className: currentPage === i ? 'on' : ''
					}));
				}
				return _react2.default.createElement(
					'div',
					{ className: 'newreply-eomticon-page-bar' },
					eomticonPagingBar
				);
			}
		}]);
		return Eomticon;
	}(_react.Component);

	exports.default = Eomticon;
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(238);

	var _ActionButton = __webpack_require__(35);

	var _ActionButton2 = _interopRequireDefault(_ActionButton);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Eomticon = function (_Component) {
		(0, _inherits3.default)(Eomticon, _Component);

		function Eomticon(props) {
			(0, _classCallCheck3.default)(this, Eomticon);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Eomticon.__proto__ || (0, _getPrototypeOf2.default)(Eomticon)).call(this, props));

			_this.onTouchTap = _this.onTouchTap.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(Eomticon, [{
			key: 'onTouchTap',
			value: function onTouchTap(type) {
				this.props.changeEomticonType(type);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;

				var _props = this.props,
				    eomticonTypeData = _props.eomticonTypeData,
				    currentType = _props.currentType;


				return _react2.default.createElement(
					'div',
					{ className: 'newreply-eomticon-type' },
					eomticonTypeData.map(function (item, index) {
						return _react2.default.createElement(
							_ActionButton2.default,
							{ key: index, 'data-eomticontype': index,
								className: currentType === index ? 'on' : '',
								onClick: function onClick() {
									return _this2.onTouchTap(index);
								}
							},
							item
						);
					})
				);
			}
		}]);
		return Eomticon;
	}(_react.Component);

	exports.default = Eomticon;
	module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(22);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(240);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var InitialTextAreaHeight = 38;

	var InputArea = function (_Component) {
	  (0, _inherits3.default)(InputArea, _Component);

	  function InputArea(props) {
	    (0, _classCallCheck3.default)(this, InputArea);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (InputArea.__proto__ || (0, _getPrototypeOf2.default)(InputArea)).call(this, props));

	    _this.onChange = function (evt) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          value = _this$props.value;

	      onChange && onChange(evt.target.value, value);
	    };

	    _this.onFocus = function () {
	      var onFocus = _this.props.onFocus;

	      onFocus && onFocus();
	    };

	    _this.onBlur = function () {
	      var onBlur = _this.props.onBlur;

	      onBlur && onBlur();
	    };

	    _this.state = {};
	    return _this;
	  }

	  (0, _createClass3.default)(InputArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          autoFocus = _props.autoFocus,
	          refCallback = _props.refCallback;

	      refCallback && refCallback(this.textareaRef);
	      if (autoFocus) {
	        this.textareaRef.focus();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.textareaRef.style.height = InitialTextAreaHeight + 'px';
	      var scrollHeight = this.textareaRef.scrollHeight + 'px';
	      this.textareaRef.style.height = scrollHeight;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$className = _props2.className,
	          className = _props2$className === undefined ? '' : _props2$className,
	          refCallback = _props2.refCallback,
	          value = _props2.value,
	          readonly = _props2.readonly,
	          autoFocus = _props2.autoFocus,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          onBlue = _props2.onBlue,
	          placeholder = _props2.placeholder,
	          restProps = (0, _objectWithoutProperties3.default)(_props2, ['className', 'refCallback', 'value', 'readonly', 'autoFocus', 'onChange', 'onFocus', 'onBlue', 'placeholder']);

	      return _react2.default.createElement('textarea', (0, _extends3.default)({ ref: 'textareaRef',
	        className: className + ' mobile-replay-input-area' }, restProps, {
	        value: value, placeholder: placeholder, readOnly: readonly, maxLength: '5000',
	        onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur }));
	    }
	  }, {
	    key: 'textareaRef',
	    get: function get() {
	      return this.refs.textareaRef;
	    }
	  }]);
	  return InputArea;
	}(_react.Component);

	InputArea.defaultProps = {
	  value: '',
	  readonly: false,
	  autoFocus: false,
	  placeholder: ''
	};
	exports.default = InputArea;
	module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(22);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _promise = __webpack_require__(45);

	var _promise2 = _interopRequireDefault(_promise);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(242);

	var _ActionButton = __webpack_require__(35);

	var _ActionButton2 = _interopRequireDefault(_ActionButton);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var PressEndReason = {
	  UserInteractive: 1,
	  Timeout: 2,
	  Offline: 3
	};

	var VoicePanel = function (_Component) {
	  (0, _inherits3.default)(VoicePanel, _Component);

	  function VoicePanel(props) {
	    (0, _classCallCheck3.default)(this, VoicePanel);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (VoicePanel.__proto__ || (0, _getPrototypeOf2.default)(VoicePanel)).call(this, props));

	    _this.timer = null;
	    _this.pressStartTime = 0;
	    _this.isFingerPressing = false;
	    _this.setTipTimeout = null;
	    _this.closePromRejectFunc = null;
	    _this.offlinePromRejectFunc = null;
	    _this.pressDelayTimer = null;
	    _this.pressReallyStarted = false;

	    _this.addEventListeners = function () {
	      _this.refs.pressBtn.addEventListener('touchstart', _this.onPressBegin);
	      _this.refs.pressBtn.addEventListener('touchend', _this.onPressEnd);
	      _this.refs.pressBtn.addEventListener('touchcancel', _this.onPressEnd);
	    };

	    _this.setTmpTip = function (str) {
	      if (_this.setTipTimeout) {
	        clearTimeout(_this.setTipTimeout);
	        _this.setTipTimeout = null;
	      }
	      _this.setState({
	        tmpTip: str || ''
	      });
	      if (str) {
	        _this.setTipTimeout = setTimeout(function () {
	          _this.setState({
	            tmpTip: ''
	          });
	        }, 2000);
	      }
	    };

	    _this.startTimer = function () {
	      _this.stopTimer();
	      _this.timer = setInterval(_this.onTimer, 1000);
	    };

	    _this.stopTimer = function () {
	      if (_this.timer) {
	        clearInterval(_this.timer);
	        _this.timer = null;
	      }
	    };

	    _this.onTimer = function () {
	      var t = Date.now();
	      if (_this.state.onLine !== navigator.onLine) {
	        _this.setState({
	          onLine: navigator.onLine
	        });
	      }
	      if (_this.state.listening) {
	        var pressDt = t - _this.pressStartTime;
	        if (pressDt >= 60 * 1000) {
	          _this.forcePressEnd(PressEndReason.Timeout);
	        } else if (!navigator.onLine) {
	          _this.forcePressEnd(PressEndReason.Offline);
	        }
	      } else if (_this.state.interpreting) {
	        if (!navigator.onLine) {
	          _this.offlinePromRejectFunc && _this.offlinePromRejectFunc();
	        }
	      }
	    };

	    _this.onPressBegin = function (e) {
	      e.preventDefault();
	      _this.isFingerPressing = true;
	      _this.handlePressBegin();
	    };

	    _this.onPressEnd = function (e) {
	      e.preventDefault();
	      _this.isFingerPressing = false;
	      _this.handlePressEnd(PressEndReason.UserInteractive);
	    };

	    _this.forcePressEnd = function (reason) {
	      _this.handlePressEnd(reason);
	    };

	    _this.handlePressBegin = function () {
	      if (!navigator.onLine) {
	        _this.setTmpTip(_this.props.translation.DynamicStates.OfflineMessage);
	        return;
	      }
	      window.getMoleJS().requestPermission(window.getMoleJS().DevicePermissions.Microphone).then(function (r) {
	        if (!r.granted) {
	          return _promise2.default.reject('nopermission');
	        }
	      }).then(function () {
	        if (!_this.isFingerPressing) {
	          // if the user not pressing the button (because of request permission dialog)
	          return;
	        }
	        _this.setState({
	          listening: true
	        });
	        _this.setTmpTip(null);
	        _this.pressStartTime = Date.now();
	        _this.pressReallyStarted = false;
	        _this.pressDelayTimer = setTimeout(function () {
	          window.getMoleJS().speakStart();
	          _this.pressReallyStarted = true;
	        }, 100);
	      }).catch(function (ex) {});
	    };

	    _this.handlePressEnd = function (reason) {
	      var translation = _this.props.translation;

	      if (!_this.state.listening) {
	        return;
	      }
	      if (!_this.pressReallyStarted) {
	        clearTimeout(_this.pressDelayTimer);
	        _this.setState({
	          listening: false
	        });
	        return;
	      }
	      var _this$props = _this.props,
	          onResult = _this$props.onResult,
	          onInterpretingStateChange = _this$props.onInterpretingStateChange;

	      _this.setState({
	        listening: false,
	        interpreting: true
	      });
	      onInterpretingStateChange && onInterpretingStateChange(true);
	      if (reason === PressEndReason.Timeout) {
	        _this.setTmpTip(translation.DynamicStates.TimeoutTip);
	      } else if (reason === PressEndReason.Offline) {
	        _this.setTmpTip(translation.DynamicStates.OfflineMessage);
	      }
	      var promClose = new _promise2.default(function (resolve, reject) {
	        _this.closePromRejectFunc = function () {
	          reject('cancelled-because-of-close');
	        };
	      });
	      var promInterpretingTimeout = new _promise2.default(function (resolve, reject) {
	        setTimeout(function () {
	          reject('cancelled-because-of-timeout');
	        }, 15000);
	      });
	      var promOffline = new _promise2.default(function (resolve, reject) {
	        _this.offlinePromRejectFunc = function () {
	          reject('cancelled-because-of-offline');
	        };
	      });
	      var promSpeak = window.getMoleJS().speakStop();
	      _promise2.default.race([promClose, promInterpretingTimeout, promOffline, promSpeak]).then(function (result) {
	        if (result) {
	          onResult && onResult(result);
	        } else {
	          _this.setTmpTip(translation.DynamicStates.VoiceUnrecognized);
	        }
	      }).catch(function (err) {
	        if (err === 'cancelled-because-of-close') {} else if (err === 'cancelled-because-of-timeout') {
	          _this.setTmpTip(translation.DynamicStates.VoiceUnrecognized);
	        } else if (err === 'forceend-because-of-offline' || err === 'cancelled-because-of-offline') {
	          _this.setTmpTip(translation.DynamicStates.OfflineMessage);
	        } else if (err && err.xunfeiErrorCode) {
	          var xfc = err.xunfeiErrorCode;
	          if (xfc === 20001 || xfc === 20001 || xfc === 20001) {
	            _this.setTmpTip(translation.DynamicStates.OfflineMessage);
	          } else {
	            _this.setTmpTip(translation.DynamicStates.VoiceUnrecognized);
	          }
	        } else {
	          _this.setTmpTip(translation.DynamicStates.VoiceUnrecognized);
	        }
	      }).then(function () {
	        // finally
	        _this.setState({
	          interpreting: false
	        });
	        onInterpretingStateChange && onInterpretingStateChange(false);
	        _this.closePromRejectFunc = null;
	        _this.offlinePromRejectFunc = null;
	      });
	    };

	    _this.buildTip = function () {
	      var translation = _this.props.translation;
	      var _this$state = _this.state,
	          listening = _this$state.listening,
	          interpreting = _this$state.interpreting,
	          onLine = _this$state.onLine,
	          tmpTip = _this$state.tmpTip;

	      if (tmpTip) {
	        return tmpTip;
	      }
	      if (!onLine) {
	        return translation.DynamicStates.OfflineMessage;
	      }
	      if (interpreting) {
	        return '';
	      }
	      return listening ? translation.DynamicStates.ReleaseTip : translation.DynamicStates.PressToTalkTip;
	    };

	    _this.onClose = function () {
	      var onClose = _this.props.onClose;

	      _this.closePromRejectFunc && _this.closePromRejectFunc();
	      setTimeout(function () {
	        // wait for onInterpretingStateChange
	        onClose && onClose();
	      });
	    };

	    _this.state = {
	      listening: false,
	      interpreting: false,
	      onLine: navigator.onLine,
	      tmpTip: ''
	    };
	    return _this;
	  }

	  (0, _createClass3.default)(VoicePanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var refCallback = this.props.refCallback;

	      this.startTimer();
	      this.addEventListeners();
	      this.refs.elRef.addEventListener('touchmove', function (evt) {
	        evt.preventDefault();
	      });
	      refCallback && refCallback(this.refs.elRef);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopTimer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          onResult = _props.onResult,
	          refCallback = _props.refCallback,
	          onInterpretingStateChange = _props.onInterpretingStateChange,
	          onClose = _props.onClose,
	          translation = _props.translation,
	          restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'onResult', 'refCallback', 'onInterpretingStateChange', 'onClose', 'translation']);
	      var _state = this.state,
	          listening = _state.listening,
	          interpreting = _state.interpreting,
	          onLine = _state.onLine,
	          tmpTip = _state.tmpTip;

	      var tip = this.buildTip();
	      var haloStyle = {};
	      if (!listening) {
	        haloStyle.display = 'none';
	      }
	      var btnStyle = {};
	      var interpretingStyle = {};
	      if (interpreting) {
	        btnStyle.display = 'none';
	      } else {
	        interpretingStyle.display = 'none';
	      }
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ ref: 'elRef', className: 'replay-voicepanel ' + className }, restProps),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile-replay-general-line',
	            style: { position: 'absolute', top: 0, left: 0, width: '100%' } },
	          _react2.default.createElement('div', null)
	        ),
	        _react2.default.createElement(_ActionButton2.default, { noMove: true, className: 'closebtn', onClick: this.onClose }),
	        _react2.default.createElement(
	          'div',
	          { className: 'replay-voicepanel-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'replay-voicepanel-tip' },
	            '\xA0',
	            tip,
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'replay-voicepanel-btnwrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'replay-voicepanel-placeholder' },
	              '\xA0'
	            ),
	            _react2.default.createElement('div', { className: 'replay-voicepanel-btnhalo ' + (listening ? 'animating' : ''), style: haloStyle }),
	            _react2.default.createElement('button', { ref: 'pressBtn', className: 'replay-voicepanel-btn', style: btnStyle }),
	            _react2.default.createElement(
	              'div',
	              { className: 'replay-voicepanel-interpreting', style: interpretingStyle },
	              _react2.default.createElement(
	                'div',
	                { className: 'interpreting-anim' },
	                _react2.default.createElement('div', { className: 'dot dot0' }),
	                _react2.default.createElement('div', { className: 'dot dot1' }),
	                _react2.default.createElement('div', { className: 'dot dot2' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return VoicePanel;
	}(_react.Component);

	VoicePanel.defaultProps = {
	  onResult: function onResult() {},
	  onClose: function onClose() {},
	  onInterpretingStateChange: function onInterpretingStateChange(st) {}
	};
	exports.default = VoicePanel;
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(22);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _toConsumableArray2 = __webpack_require__(170);

	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

	var _keys = __webpack_require__(79);

	var _keys2 = _interopRequireDefault(_keys);

	var _promise = __webpack_require__(45);

	var _promise2 = _interopRequireDefault(_promise);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(24);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _reactTransitionGroup = __webpack_require__(107);

	var _chaosUi = __webpack_require__(8);

	var _utils = __webpack_require__(127);

	__webpack_require__(243);

	var _AttachedImages = __webpack_require__(118);

	var _AttachedImages2 = _interopRequireDefault(_AttachedImages);

	var _InputArea = __webpack_require__(124);

	var _InputArea2 = _interopRequireDefault(_InputArea);

	var _VoicePanel = __webpack_require__(125);

	var _VoicePanel2 = _interopRequireDefault(_VoicePanel);

	var _EmojiPanel = __webpack_require__(119);

	var _EmojiPanel2 = _interopRequireDefault(_EmojiPanel);

	var _ActionButton = __webpack_require__(35);

	var _ActionButton2 = _interopRequireDefault(_ActionButton);

	var _Uploader = __webpack_require__(117);

	var _xmlEntities = __webpack_require__(65);

	var _xmlEntities2 = _interopRequireDefault(_xmlEntities);

	var _index = __webpack_require__(11);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var PanelType = {
	  None: 0,
	  Voice: 1,
	  Emoji: 2
	};

	var MobileReply = function (_Component) {
	  (0, _inherits3.default)(MobileReply, _Component);

	  function MobileReply(props) {
	    (0, _classCallCheck3.default)(this, MobileReply);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (MobileReply.__proto__ || (0, _getPrototypeOf2.default)(MobileReply)).call(this, props));

	    _this.onDocTouchStart = function (e) {};

	    _this.loadUserInfo = function () {
	      var defaultUrl = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/UserPermissions/IsUserFrameWorkOrUPaaSDemo');
	      (0, _index.callFetch)(defaultUrl, 'GET').then(function (resp) {
	        try {
	          _this.setState({
	            isCurrentUserAdmin: resp.Data.isUpassDemo || resp.Data.isUserFramework
	          });
	        } catch (ex) {}
	      });
	    };

	    _this.loadi18n = function () {};

	    _this.checkHeight = function () {
	      var onHeightChange = _this.props.onHeightChange;

	      var h = _this.refs.elRef.offsetHeight;
	      if (h !== _this.lastHeight) {
	        _this.lastHeight = h;
	        onHeightChange && onHeightChange(h);
	      }
	    };

	    _this.scrollInputAreaToBottom = function () {
	      _this.inputAreaRef.scrollTop = 100000;
	    };

	    _this.inputAreaCursorPosition = function () {
	      var cursorPos = _this.inputAreaRef.selectionStart;
	      if (!cursorPos || cursorPos < 0) {
	        cursorPos = 0;
	      }
	      return cursorPos;
	    };

	    _this.insertInputAreaValue = function (str) {
	      var inputAreaValue = _this.state.inputAreaValue;

	      var isEnd = true;
	      var newVal = '';
	      var cursorPos = 0;
	      if (inputAreaValue.length > 0) {
	        cursorPos = _this.inputAreaCursorPosition();
	        isEnd = cursorPos >= inputAreaValue.length;
	      }
	      if (isEnd) {
	        newVal = inputAreaValue + str;
	      } else {
	        try {
	          newVal = inputAreaValue.substring(0, cursorPos) + str + inputAreaValue.substring(cursorPos);
	        } catch (ex) {
	          newVal = inputAreaValue + str;
	        }
	      }
	      _this.setState({
	        inputAreaValue: newVal
	      }, function () {
	        var newCurPos = 0;
	        if (isEnd) {
	          newCurPos = newVal.length;
	          _this.scrollInputAreaToBottom();
	        } else {
	          newCurPos = cursorPos + str.length;
	        }
	        setTimeout(function () {
	          _this.inputAreaSetSelectionRange(newCurPos, newCurPos);
	        });
	      });
	    };

	    _this.deleteCharsFromInputArea = function (indexStart, indexEnd) {
	      var inputAreaValue = _this.state.inputAreaValue;

	      var newVal = inputAreaValue.slice(0, indexStart) + inputAreaValue.slice(indexEnd);
	      _this.setState({
	        inputAreaValue: newVal
	      }, function () {
	        setTimeout(function () {
	          _this.inputAreaSetSelectionRange(indexStart, indexStart);
	        });
	      });
	    };

	    _this.inputAreaSetSelectionRange = function (idxFrom, idxTo) {
	      var shouldHandleGostFocus = window.getMoleJS().platform.ios;
	      var orgReadonly = false;
	      if (shouldHandleGostFocus) {
	        orgReadonly = _this.inputAreaRef.hasAttribute('readonly');
	        _this.inputAreaRef.setAttribute('readonly', 'readonly');
	      }
	      _this.inputAreaRef.setSelectionRange(idxFrom, idxTo);
	      if (shouldHandleGostFocus) {
	        if (!orgReadonly) {
	          _this.inputAreaRef.removeAttribute('readonly');
	        }
	      }
	    };

	    _this.appendToInputArea = function (str) {
	      var inputAreaValue = _this.state.inputAreaValue;

	      _this.setState({
	        inputAreaValue: inputAreaValue + str
	      });
	    };

	    _this.setPanelRowAnimationEnabled = function (b) {
	      if (b) {
	        _this.refs.panelRow.style.removeProperty('transition');
	      } else {
	        _this.refs.panelRow.style.setProperty('transition', 'none', 'important');
	      }
	    };

	    _this.setPanelsAnimationEnabled = function (b) {
	      if (!_this.panelsCache) {
	        _this.panelsCache = [];
	        var nodes = _this.refs.panelRow.getElementsByClassName('mobile-reply-panel');
	        for (var i = 0; i < nodes.length; i++) {
	          _this.panelsCache.push(nodes[i]);
	        }
	      }
	      _this.panelsCache.forEach(function (panel) {
	        if (b) {
	          panel.style.removeProperty('transition');
	        } else {
	          panel.style.setProperty('transition', 'none', 'important');
	        }
	      });
	    };

	    _this.blurThenOpenPanel = function (panel) {
	      var inputAreaHasFocus = _this.state.inputAreaHasFocus;

	      var func = function func(cb) {
	        _this.setState({
	          displayingPanel: panel
	        }, cb);
	      };
	      if (inputAreaHasFocus) {
	        _this.inputAreaRef.blur();
	        setTimeout(function () {
	          _this.setPanelsAnimationEnabled(false);
	          func();
	          setTimeout(function () {
	            _this.setPanelsAnimationEnabled(true);
	          }, 300);
	        }, 300);
	      } else {
	        _this.inputAreaRef.blur();
	        setTimeout(func);
	      }
	    };

	    _this.closePanelThenFocus = function () {
	      if (_this.state.displayingPanel === PanelType.None) {
	        _this.inputAreaRef.focus();
	        return;
	      }
	      _this.setPanelsAnimationEnabled(false);
	      _this.setPanelRowAnimationEnabled(false);
	      _this.setState({
	        displayingPanel: PanelType.None
	      }, function () {
	        _this.setPanelsAnimationEnabled(true);
	        _this.setPanelRowAnimationEnabled(true);
	        _this.inputAreaRef.focus();
	      });
	    };

	    _this.checkCanHaveMorePictureCount = function () {
	      var showAlert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var attachedImgs = _this.state.attachedImgs;

	      var effective = attachedImgs.filter(function (atcImg) {
	        return !atcImg.uploadError;
	      });
	      var MAX_PICTURE_COUNT = 8;
	      var r = MAX_PICTURE_COUNT - effective.length;
	      if (r <= 0 && showAlert) {
	        window.getMoleJS().ui.alert({
	          title: '',
	          msg: _this.props.translation.DynamicStates.MaxImageCountTip.replace('${{count}}', MAX_PICTURE_COUNT),
	          buttons: [_this.props.translation.DynamicStates.IKnow]
	        });
	      }
	      return r;
	    };

	    _this.onInputAreaChange = function (str, oldVal) {
	      var enableAt = _this.props.enableAt;

	      var isAt = enableAt && str === oldVal + '@';
	      if (isAt) {
	        _this.inputAreaRef.blur();
	      }
	      _this.setState({
	        isShowUserPicker: isAt,
	        inputAreaValue: str
	      });
	    };

	    _this.onInputAreaFocus = function () {
	      _this.setPanelsAnimationEnabled(false);
	      _this.setPanelRowAnimationEnabled(false);
	      _this.setState({
	        inputAreaHasFocus: true,
	        displayingPanel: PanelType.None
	      }, function () {
	        setTimeout(function () {
	          _this.setPanelsAnimationEnabled(true);
	          _this.setPanelRowAnimationEnabled(true);
	        }, 300);
	      });
	    };

	    _this.onInputAreaBlur = function () {
	      setTimeout(function () {
	        _this.setState({
	          inputAreaHasFocus: false
	        });
	      });
	    };

	    _this.onClickToolVoice = function () {
	      if (!navigator.onLine) {
	        window.getMoleJS().ui.alert({
	          title: '',
	          msg: _this.props.translation.DynamicStates.OfflineMessage,
	          buttons: [_this.props.translation.DynamicStates.IKnow]
	        });
	        _this.inputAreaRef.focus();
	        return;
	      }
	      var displayingPanel = _this.state.displayingPanel;

	      if (displayingPanel === PanelType.Voice) {
	        return;
	      }
	      _this.blurThenOpenPanel(PanelType.Voice);
	    };

	    _this.onVoicePanelResult = function (str) {
	      _this.insertInputAreaValue(str);
	    };

	    _this.onVoicePanelClose = function () {
	      _this.closePanelThenFocus();
	    };

	    _this.onVoicePanelInterpretingStateChange = function (b) {
	      _this.setState({
	        voicePanelInterpreting: b
	      });
	    };

	    _this.onClickToolImage = function () {
	      var leftCount = _this.checkCanHaveMorePictureCount();
	      if (leftCount <= 0) {
	        return;
	      }
	      _this.panelBeforeFullScreenAction = _this.state.displayingPanel;
	      _this.hasFocusBeforeFullScreenAction = _this.state.inputAreaHasFocus;
	      _this.inputAreaRef.blur();
	      var isPermissionGranted = false;
	      window.getMoleJS().requestPermission(window.getMoleJS().DevicePermissions.Album).then(function (r) {
	        isPermissionGranted = r.granted;
	        if (!r.granted) {
	          return _promise2.default.reject('nopermission');
	        }
	        return new _promise2.default(function (resolve) {
	          return setTimeout(resolve);
	        }); // wait for the focus
	      }).then(function () {
	        return window.getMoleJS().chooseImage({
	          singleSelection: false,
	          maximum: Math.min(leftCount, 4),
	          quality: 80,
	          thumbWidth: 80,
	          type: 'both'
	        });
	      }).then(function (r) {
	        var rmedRN = r.map(function (e) {
	          return {
	            original: e.original,
	            thumb: e.thumb.replace(/[\r\n]+/g, '')
	          };
	        });
	        _this.handleUploadImage(rmedRN);
	      }).catch(function (ex) {}).then(function () {
	        // finally
	        setTimeout(function () {
	          // wait for the focus
	          if (_this.panelBeforeFullScreenAction === PanelType.None && _this.hasFocusBeforeFullScreenAction && isPermissionGranted) {
	            _this.closePanelThenFocus();
	          }
	        }, 300);
	      });
	    };

	    _this.onClickToolCamera = function () {
	      // window.bsapi.requestPermission({list: ['camera']}, (ret, err) => {
	      //   window.alert('ret = ' + JSON.stringify(ret) + ', err = ' + JSON.stringify(err));
	      // });
	      // return;
	      // try {
	      //   const api = window.api.require('BSApi');
	      //   // api.startSpeak();
	      //   // setTimeout(() => {
	      //   //   api.stopSpeak((ret, err) => {
	      //   //     window.alert('ret: ' + JSON.stringify(ret) + '\n\n' + 'err: ' + JSON.stringify(err));
	      //   //   });
	      //   // }, 12000);
	      //   // api.takePicture({
	      //   //   // singleSelection: false,
	      //   //   // maximum: 4,
	      //   //   allowEdit: false,
	      //   //   quality: 80,
	      //   // }, (ret, err) => {
	      //   //   alert('ret: ' + JSON.stringify(ret) + '\n\n' + 'err: ' + JSON.stringify(err));
	      //   // });
	      // } catch (ex2) {
	      //   alert('exception: ' + ex2);
	      // }
	      // return;
	      var leftCount = _this.checkCanHaveMorePictureCount();
	      if (leftCount <= 0) {
	        return;
	      }
	      _this.panelBeforeFullScreenAction = _this.state.displayingPanel;
	      _this.hasFocusBeforeFullScreenAction = _this.state.inputAreaHasFocus;
	      _this.inputAreaRef.blur();
	      var isPermissionGranted = false;
	      window.getMoleJS().requestPermission(window.getMoleJS().DevicePermissions.Camera).then(function (r) {
	        isPermissionGranted = r.granted;
	        if (!r.granted) {
	          return _promise2.default.reject('nopermission');
	        }
	        return new _promise2.default(function (resolve) {
	          return setTimeout(resolve);
	        }); // wait for the focus
	      }).then(function () {
	        return window.getMoleJS().photograph({
	          allowEdit: false,
	          quality: 80,
	          thumbWidth: 80,
	          type: 'both'
	        });
	      }).then(function (r) {
	        var rmedRN = {
	          original: r.original,
	          thumb: r.thumb.replace(/[\r\n]+/g, '')
	        };
	        _this.handleUploadImage([rmedRN]);
	      }).catch(function (ex) {}).then(function () {
	        // finally
	        setTimeout(function () {
	          // wait for the focus
	          if (_this.panelBeforeFullScreenAction === PanelType.None && _this.hasFocusBeforeFullScreenAction && isPermissionGranted) {
	            _this.closePanelThenFocus();
	          }
	        }, 300);
	      });
	    };

	    _this.handleUploadImage = function (imgs) {
	      var atchImgs = imgs.map(function (e) {
	        return {
	          id: 'i' + Date.now() + Math.floor(Math.random() * 1000),
	          image: e,
	          uploadError: null,
	          uploaded: null
	        };
	      });
	      _this.addAttachedImgsToState(atchImgs);
	      atchImgs.forEach(function (atchImg) {
	        (0, _Uploader.uploadUserFile)(atchImg).then(function (atchImg2) {}).catch(function (err) {}).then(function () {
	          // finally
	          _this.setState({
	            attachedImgs: _this.state.attachedImgs.concat()
	          });
	        });
	      });
	    };

	    _this.onClickToolEmoji = function () {
	      var displayingPanel = _this.state.displayingPanel;

	      if (displayingPanel === PanelType.Emoji) {
	        return;
	      }
	      _this.blurThenOpenPanel(PanelType.Emoji);
	    };

	    _this.onEmojiPanelInput = function (val) {
	      _this.insertInputAreaValue(val);
	    };

	    _this.onEmojiPanelDelete = function () {
	      var inputAreaValue = _this.state.inputAreaValue;


	      var cursorPos = _this.inputAreaCursorPosition();
	      var strBeforeCursor = inputAreaValue.substring(0, cursorPos);
	      var reg = /\[[a-zA-Z]+:[^\]]+\]$/;
	      var r = reg.exec(strBeforeCursor);
	      if (r && r.length === 1) {
	        _this.deleteCharsFromInputArea(r.index, r.index + r[0].length);
	      }
	    };

	    _this.onClickToolAt = function () {
	      _this.inputAreaRef.blur();
	      _this.setState({
	        isShowUserPicker: true
	      });
	    };

	    _this.onClickToolAtAll = function () {
	      _this.insertInputAreaValue('@[所有同事:all_members]');
	      _this.closePanelThenFocus();
	    };

	    _this.onFetchDefaultUsers = function () {
	      var defaultUrl = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/Contact') + '?v=' + new Date().getTime();
	      (0, _index.callFetch)(defaultUrl, 'GET').then(function (resp) {
	        var usrs = [];
	        try {
	          usrs = (0, _keys2.default)(resp.Data).map(function (k) {
	            return resp.Data[k];
	          });
	        } catch (ex) {
	          usrs = [];
	        }
	        _this.setState({
	          defaultUsers: usrs,
	          currentUsers: usrs
	        });
	      });
	    };

	    _this.onFetchSearchUsers = function (keyword) {
	      if (!_this.searchUserDebounce) {
	        _this.searchUserDebounce = (0, _utils.debounce)(_this.doSearchUser, 300);
	      }
	      _this.searchUserKeywrod = keyword || '';
	      _this.searchUserDebounce();
	    };

	    _this.doSearchUser = function () {
	      var fetchUrl = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/user');
	      var params = {
	        v: new Date().getTime(),
	        filters: _this.searchUserKeywrod,
	        app: window.BSGlobal.application
	      };
	      fetchUrl = fetchUrl.replace('{filters}', _this.searchUserKeywrod);
	      if (fetchUrl.indexOf('?') > -1 && fetchUrl.indexOf('app') < 0) {
	        fetchUrl += '&app=' + params.app;
	        params = null;
	      }
	      (0, _index.callFetch)(fetchUrl, 'GET', params).then(function (resp) {
	        var usrs = [];
	        try {
	          usrs = (0, _keys2.default)(resp.Data.SimpleUserModel).map(function (k) {
	            return resp.Data.SimpleUserModel[k];
	          });
	        } catch (ex) {
	          usrs = [];
	        }
	        _this.setState({
	          currentUsers: usrs
	        });
	      });
	    };

	    _this.onUserSelectCancel = function () {
	      _this.setState({
	        isShowUserPicker: false
	      });
	    };

	    _this.onUserSelectConfirm = function (e, usrs) {
	      if (!usrs || usrs.length === 0) {
	        _this.showFixedOfflineToast(_this.props.translation.DynamicStates.AtNoPersonSelect, 'up');
	        return;
	      }
	      var inputAreaValue = _this.state.inputAreaValue;

	      var personNames = usrs.map(function (item) {
	        return '@[' + item.Name + ':' + item.Email + ']';
	      }).join('');
	      if (personNames && inputAreaValue.length > 0 && inputAreaValue.lastIndexOf('@') === inputAreaValue.length - 1) {
	        personNames = personNames.substring(1);
	      }
	      if (personNames) {
	        _this.insertInputAreaValue(personNames);
	      }
	      _this.setState({
	        isShowUserPicker: false,
	        selectedUsers: usrs
	      });
	      _this.closePanelThenFocus();
	    };

	    _this.onSwipToClearSelectedUser = function () {
	      _this.setState({
	        selectedUsers: [],
	        isShowUserPicker: false
	      });
	    };

	    _this.addAttachedImgsToState = function (atchImgs) {
	      var st = {
	        attachedImgs: [].concat((0, _toConsumableArray3.default)(_this.state.attachedImgs), (0, _toConsumableArray3.default)(atchImgs))
	      };
	      var orgInputVal = _this.state.inputAreaValue;
	      if (!orgInputVal) {
	        _this.insertInputAreaValue(_this.props.translation.DynamicStates.FileShareAutoText);
	      }
	      _this.setState(st);
	    };

	    _this.onDeleteAttachedImage = function (img, idx) {
	      var attachedImgs = _this.state.attachedImgs;

	      var newVal = attachedImgs.concat();
	      newVal.splice(idx, 1);
	      var st = {
	        attachedImgs: newVal
	      };
	      if (newVal.length === 0) {
	        var FileShareAutoText = _this.props.translation.DynamicStates.FileShareAutoText;
	        // on delete last image, also delete the auto-filled text
	        if (_this.state.inputAreaValue.indexOf(FileShareAutoText) !== -1) {
	          st.inputAreaValue = _this.state.inputAreaValue.replace(FileShareAutoText, '');
	        }
	      }
	      _this.setState(st);
	    };

	    _this.onViewAttachedImage = function (img, idx) {
	      _this.panelBeforeFullScreenAction = _this.state.displayingPanel;
	      _this.hasFocusBeforeFullScreenAction = _this.state.inputAreaHasFocus;
	      _this.inputAreaRef.blur();
	    };

	    _this.onViewAttachedImageClose = function (img, idx) {
	      if (_this.panelBeforeFullScreenAction === PanelType.None && _this.hasFocusBeforeFullScreenAction) {
	        _this.closePanelThenFocus();
	      }
	    };

	    _this.showFixedOfflineToast = function (str) {
	      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'down';

	      if (window.getMoleJS().platform.ios) {
	        var keyboardShowing = _this.initialWindowInnerHeight - window.innerHeight > 100;
	        if (keyboardShowing) {
	          var el = document.createElement('style');
	          el.setAttribute('id', 'mobileReplyIosToastStyleFix');
	          var styleVal = '';
	          var mb = Math.round((window.innerHeight - 120) * 0.5);
	          if (direction === 'down') {
	            styleVal = 'align-self: flex-end; margin-bottom: ' + mb + 'px;';
	          } else if (direction === 'up') {
	            styleVal = 'align-self: flex-start; margin-top: ' + mb + 'px;';
	          }
	          el.innerText = '.pm-toast-mn-prefixcls > span { ' + styleVal + ' }';
	          document.head.appendChild(el);
	          setTimeout(function () {
	            document.head.removeChild(el);
	          }, 2120);
	        }
	      }
	      _chaosUi.Toast.offline(str);
	    };

	    _this.onSend = function () {
	      if (!navigator.onLine) {
	        _this.showFixedOfflineToast(_this.props.translation.DynamicStates.OfflineTip);
	        return;
	      }

	      var _this$state = _this.state,
	          inputAreaValue = _this$state.inputAreaValue,
	          attachedImgs = _this$state.attachedImgs;
	      var _this$props = _this.props,
	          _feedId = _this$props.feedId,
	          replyPerson = _this$props.replyPerson,
	          isDetail = _this$props.isDetail,
	          afterSave = _this$props.afterSave;


	      if (!inputAreaValue) {
	        return;
	      }

	      if (inputAreaValue.length > 2000) {
	        _this.showFixedOfflineToast(_this.props.translation.DynamicStates.TextOverflowTip);
	        return;
	      }

	      var feedId = _feedId;
	      if (!isDetail) {
	        // 若为详情页，数据需要实时获取
	        feedId = _this.props.replyInfo.feedId;
	      }

	      var fileUrl = attachedImgs.filter(function (e) {
	        return !!e.uploaded;
	      }).map(function (e) {
	        return e.uploaded.DfsPath;
	      }).join(',');

	      var params = {
	        FeedId: feedId,
	        CommentId: replyPerson ? replyPerson.commentId : 0,
	        Content: _xmlEntities2.default.encode(inputAreaValue),
	        FileUrl: fileUrl,
	        ObjId: 0,
	        ObjType: 0,
	        IsSendSMS: false
	      };

	      var url = (0, _index.urlComplete)('/api/v2/{tenant_id}/{user_id}/comment/Add');

	      _this.inputAreaRef.blur();
	      _this.setState({
	        sending: true,
	        displayingPanel: PanelType.None
	      });
	      (0, _index.callFetch)(url, 'POST', params).then(function (resp) {
	        if (!resp || resp.Code !== 1) {
	          return _promise2.default.reject(new Error(resp.Message || _this.props.translation.DynamicStates.ConnectionFailed));
	        }
	        _this.setState({
	          inputAreaValue: ' ',
	          sdsbbowaipp: true,
	          attachedImgs: [],
	          selectedUsers: [],
	          sending: false
	        });
	        setTimeout(function () {
	          // workaround for the non-vertically-center-aligned placeholder
	          _this.setState({
	            inputAreaValue: '',
	            sdsbbowaipp: false
	          });
	        }, 100);
	        setTimeout(function () {
	          afterSave && afterSave(resp);
	        });
	      }).catch(function (err) {
	        _this.setState({
	          sending: false
	        });
	        var msg = '';
	        if (err instanceof Error) {
	          msg = err.message;
	        } else if (err && err.Message) {
	          msg = err.Message;
	        } else {
	          msg = _this.props.translation.DynamicStates.ConnectionFailed;
	        }
	        _chaosUi.Toast.fail(msg);
	      }).then(function () {
	        // finally
	      });
	    };

	    _this.state = {
	      isCurrentUserAdmin: false,
	      inputAreaValue: '',
	      sdsbbowaipp: false, // ShouldDisableSendBtnBecauseOfWorkAroundInputPlaceholderPosition
	      inputAreaHasFocus: false,
	      displayingPanel: PanelType.None,
	      isShowUserPicker: false,
	      voicePanelInterpreting: false,
	      defaultUsers: [],
	      currentUsers: [],
	      selectedUsers: [],
	      attachedImgs: [
	        // {image: {original: '', thumb: ''}, uploaded: {ClientUrl: 'asdf'}, id: '_' + Math.random()},
	        // {image: {original: '', thumb: ''}, uploaded: {ClientUrl: 'asdf'}, id: '_' + Math.random()},
	        // {image: {original: '', thumb: ''}, uploaded: {ClientUrl: 'asdf'}, id: '_' + Math.random()},
	        // {image: {original: '', thumb: ''}, uploaded: {ClientUrl: 'asdf'}, id: '_' + Math.random()},
	        // {image: {original: '', thumb: ''}, uploaded: {ClientUrl: 'asdf'}, id: '_' + Math.random()},
	        // {image: {original: '', thumb: ''}, uploaded: {ClientUrl: 'asdf'}, id: '_' + Math.random()},
	        // {image: {original: '', thumb: ''}, uploaded: {ClientUrl: 'asdf'}, id: '_' + Math.random()},
	        // {image: {original: '', thumb: ''}, uploaded: {ClientUrl: 'asdf'}, id: '_' + Math.random()},
	      ],
	      sending: false
	    };
	    _this.searchUserDebounce = null;
	    _this.searchUserKeywrod = '';
	    _this.inputAreaRef = null;
	    /** 在进行一些全屏的、会导致焦点发生转移的操作时，记录当前显示的panel */
	    _this.panelBeforeFullScreenAction = PanelType.None;
	    _this.hasFocusBeforeFullScreenAction = false;
	    _this.initialWindowInnerHeight = 0;
	    return _this;
	  }

	  (0, _createClass3.default)(MobileReply, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;

	      var onHeightChange = this.props.onHeightChange;

	      this.initialWindowInnerHeight = window.innerHeight;
	      this.loadUserInfo();
	      setTimeout(function () {
	        _this2.lastHeight = _this2.refs.elRef.offsetHeight;
	        onHeightChange && onHeightChange(_this2.lastHeight);
	      });
	      document.addEventListener('touchstart', this.onDocTouchStart);
	      this.refs.toolsRow.addEventListener('touchstart', function (evt) {
	        if (evt.target === _this2.refs.toolsRow) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.checkHeight();
	      setTimeout(this.checkHeight, 310); // animation
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('touchstart', this.onDocTouchStart);
	    }

	    /**
	     * 根据光标位置插入新的值
	     */


	    /** 在iOS上设置setSelectionRange会触发焦点，于是使用readonly解决 */


	    /**
	     * 在显示Toast时会添加一个<style>来修复在iOS上因为键盘显示导致的位置不正确
	     */

	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;

	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          colorStyle = _props.colorStyle,
	          enableVoice = _props.enableVoice,
	          enableAt = _props.enableAt,
	          enableImage = _props.enableImage,
	          enableEmoji = _props.enableEmoji,
	          enbaleCamera = _props.enbaleCamera,
	          replyPerson = _props.replyPerson,
	          isFocusInput = _props.isFocusInput,
	          feedId = _props.feedId,
	          isDetail = _props.isDetail,
	          afterSave = _props.afterSave,
	          footercls = _props.footercls,
	          onHeightChange = _props.onHeightChange,
	          translation = _props.translation,
	          restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'colorStyle', 'enableVoice', 'enableAt', 'enableImage', 'enableEmoji', 'enbaleCamera', 'replyPerson', 'isFocusInput', 'feedId', 'isDetail', 'afterSave', 'footercls', 'onHeightChange', 'translation']);
	      var _state = this.state,
	          isCurrentUserAdmin = _state.isCurrentUserAdmin,
	          inputAreaValue = _state.inputAreaValue,
	          sdsbbowaipp = _state.sdsbbowaipp,
	          inputAreaHasFocus = _state.inputAreaHasFocus,
	          displayingPanel = _state.displayingPanel,
	          isShowUserPicker = _state.isShowUserPicker,
	          voicePanelInterpreting = _state.voicePanelInterpreting,
	          defaultUsers = _state.defaultUsers,
	          currentUsers = _state.currentUsers,
	          selectedUsers = _state.selectedUsers,
	          attachedImgs = _state.attachedImgs,
	          sending = _state.sending;

	      var colorStyleCls = colorStyle === 'white' ? 'mobile-replay-white' : 'mobile-replay-gray';
	      var showPanel = displayingPanel !== PanelType.None;
	      var showTools = inputAreaHasFocus || showPanel;
	      var toolsRowStyle = {};
	      var panelRowStyle = {};
	      var panelRowTopSepLineStyle = {};
	      if (!showTools) {
	        toolsRowStyle.display = 'none';
	      }
	      if (!showPanel) {
	        panelRowStyle.height = 0;
	        panelRowTopSepLineStyle.display = 'none';
	      }
	      var disableSendBtn = !inputAreaValue || voicePanelInterpreting || sending || sdsbbowaipp;
	      var noInteractiveInputArea = sending || voicePanelInterpreting;
	      var noInteractive = sending;
	      var noInteractiveCls = noInteractive ? 'sub-no-interactive' : '';
	      var noInteractiveInputAreaCls = noInteractiveInputArea ? 'no-interactive' : '';
	      var homeIndicatorCls = !(0, _utils.isSafeAreaDevice)() && (0, _utils.hasHomeIndicator)() && !inputAreaHasFocus ? 'mobile-replay-with-home-indicator' : '';
	      // feed-input-content 是为了兼容外层以前的逻辑
	      var elExtraCs = 'feed-input-content ' + colorStyleCls + ' ' + noInteractiveCls + ' ' + homeIndicatorCls;
	      var userSelectPageTranslation = { // copied from chaos-ui
	        search: translation.MobileUpaasUI.SearchPersonPlaceholder,
	        confirm: translation.DynamicStates.Confirm,
	        clear: translation.DynamicStates.Clear,
	        cancel: translation.DynamicStates.Cancel,
	        loading: translation.DynamicStates.LoadingText,
	        empty: translation.MobileUpaasUI.NoData
	      };
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ ref: 'elRef', className: 'mobile-replay ' + elExtraCs + ' ' + className + ' ' + footercls }, restProps),
	        attachedImgs.length > 0 ? _react2.default.createElement(_AttachedImages2.default, { images: attachedImgs, onDelete: this.onDeleteAttachedImage,
	          onPreviewOpen: this.onViewAttachedImage, onPreviewClose: this.onViewAttachedImageClose }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile-replay-general-line' },
	          _react2.default.createElement('div', { className: 'down' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile-replay-input-row' },
	          _react2.default.createElement(_InputArea2.default, { className: 'mobile-replay-input-area ' + noInteractiveInputAreaCls,
	            autoFocus: isFocusInput, readonly: noInteractiveInputArea,
	            refCallback: function refCallback(el) {
	              return _this3.inputAreaRef = el;
	            },
	            placeholder: replyPerson ? translation.DynamicStates.Reply + ' @' + replyPerson.publishUser.name : translation.DynamicStates.ReplyPlaceholder,
	            value: inputAreaValue,
	            onChange: this.onInputAreaChange,
	            onFocus: this.onInputAreaFocus, onBlur: this.onInputAreaBlur }),
	          _react2.default.createElement(
	            _ActionButton2.default,
	            { className: 'mobile-replay-send-btn',
	              disabled: disableSendBtn, noMove: true, onClick: this.onSend },
	            _react2.default.createElement(
	              'span',
	              { style: sending ? { visibility: 'hidden' } : {} },
	              translation.DynamicStates.ConfirmSend
	            ),
	            sending ? _react2.default.createElement('div', { className: 'load-more' }) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { ref: 'toolsRow', className: 'mobile-replay-tools-row', style: toolsRowStyle },
	          enableVoice ? _react2.default.createElement(_ActionButton2.default, { noMove: true, className: 'voice', onClick: this.onClickToolVoice }) : null,
	          enableImage ? _react2.default.createElement(_ActionButton2.default, { noMove: true, className: 'image', onClick: this.onClickToolImage }) : null,
	          enableEmoji ? _react2.default.createElement(_ActionButton2.default, { noMove: true, className: 'emoji', onClick: this.onClickToolEmoji }) : null,
	          enbaleCamera ? _react2.default.createElement(_ActionButton2.default, { noMove: true, className: 'camera', onClick: this.onClickToolCamera }) : null,
	          enableAt ? _react2.default.createElement(_ActionButton2.default, { noMove: true, className: 'at', onClick: this.onClickToolAt }) : null,
	          enableAt && isCurrentUserAdmin ? _react2.default.createElement('div', { className: 'atsep' }) : null,
	          enableAt && isCurrentUserAdmin ? _react2.default.createElement(
	            _ActionButton2.default,
	            { noMove: true, className: 'atall', onClick: this.onClickToolAtAll },
	            _react2.default.createElement('div', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              translation.DynamicStates.AtAll
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { ref: 'panelRow', className: 'mobile-replay-panel-row', style: panelRowStyle },
	          _react2.default.createElement(
	            'div',
	            { className: 'mobile-replay-general-line', style: panelRowTopSepLineStyle },
	            _react2.default.createElement('div', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobile-reply-panel-bottom-cover' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            _reactTransitionGroup.CSSTransition,
	            { classNames: 'mobile-reply-panel-anim',
	              timeout: 300, 'in': displayingPanel === PanelType.Voice },
	            _react2.default.createElement(_VoicePanel2.default, { className: 'mobile-reply-panel mobile-replay-panel-voice',
	              translation: translation,
	              onResult: this.onVoicePanelResult, onClose: this.onVoicePanelClose,
	              onInterpretingStateChange: this.onVoicePanelInterpretingStateChange })
	          ),
	          _react2.default.createElement(
	            _reactTransitionGroup.CSSTransition,
	            { classNames: 'mobile-reply-panel-anim',
	              timeout: 300, 'in': displayingPanel === PanelType.Emoji },
	            _react2.default.createElement(_EmojiPanel2.default, { className: 'mobile-reply-panel mobile-replay-panel-emoji',
	              translation: translation,
	              onInput: this.onEmojiPanelInput, onDelete: this.onEmojiPanelDelete })
	          )
	        ),
	        isShowUserPicker ? _react2.default.createElement(
	          _chaosUi.PopUp,
	          { cls: 'mobile-reply-userSelct', visible: isShowUserPicker, style: { width: '100%', height: '100%' } },
	          _react2.default.createElement(_chaosUi.UserSelectPage, {
	            translation: userSelectPageTranslation,
	            singleSelect: false,
	            hideNavClear: true,
	            handleConfirm: this.onUserSelectConfirm,
	            handleCancel: this.onUserSelectCancel,
	            title: translation.MobileUpaasUI.ChooseAtPerson,
	            usersList: currentUsers,
	            defaultUsers: defaultUsers,
	            selectedDatas: [],
	            fetchDefaultUsers: this.onFetchDefaultUsers,
	            fetchSearchUsers: this.onFetchSearchUsers,
	            tapSwipeBtn: this.onSwipToClearSelectedUser
	          })
	        ) : null
	      );
	    }
	  }]);
	  return MobileReply;
	}(_react.Component);

	MobileReply.defaultProps = {
	  colorStyle: 'gray',
	  enableVoice: true,
	  enableAt: true,
	  enableImage: true,
	  enableEmoji: true,
	  enbaleCamera: true,
	  replyPerson: null,
	  isFocusInput: false,
	  feedId: null,
	  isDetail: false,
	  afterSave: null,
	  footercls: ''
	};
	exports.default = MobileReply;
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.debounce = debounce;
	exports.hasHomeIndicator = hasHomeIndicator;
	exports.isSafeAreaDevice = isSafeAreaDevice;
	function debounce(func) {
	  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	  var tm = null;
	  var toReturn = function toReturn() {
	    if (tm) {
	      clearTimeout(tm);
	      tm = null;
	    }
	    tm = setTimeout(func, delay);
	  };
	  return toReturn;
	}

	function hasHomeIndicator() {
	  var platform = window.getMoleJS().platform;
	  return platform.iPhoneX || platform.iPhoneXR || platform.iPhoneXSMax;
	}

	/** 是否已经处理了safe area */
	function isSafeAreaDevice() {
	  var ua = navigator.userAgent;
	  return !!ua.match(/DingTalk/i) || !!ua.match(/wxwork/i);
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(244);

	var ReplyImgPreview = function (_Component) {
		(0, _inherits3.default)(ReplyImgPreview, _Component);

		function ReplyImgPreview(props) {
			(0, _classCallCheck3.default)(this, ReplyImgPreview);

			var _this = (0, _possibleConstructorReturn3.default)(this, (ReplyImgPreview.__proto__ || (0, _getPrototypeOf2.default)(ReplyImgPreview)).call(this, props));

			_this.deleteImg = _this.deleteImg.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(ReplyImgPreview, [{
			key: 'deleteImg',
			value: function deleteImg(e) {
				e.preventDefault();
				this.props.deleteImg(e.target.getAttribute('data-dfspath'));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;

				var imgFiles = this.props.imgFiles;

				if (imgFiles.length == 0) {
					return null;
				}
				return React.createElement(
					'ul',
					{ className: 'reply-img-preview' },
					imgFiles.map(function (item, index) {
						return React.createElement(
							'li',
							{ className: 'reply-img-li', key: index },
							React.createElement('div', { className: 'reply-img-delete', 'data-dfspath': item.DfsPath,
								onTouchTap: _this2.deleteImg }),
							React.createElement('img', { className: 'reply-img', src: item.ClientUrl })
						);
					})
				);
			}
		}]);
		return ReplyImgPreview;
	}(_react.Component);

	exports.default = ReplyImgPreview;
	module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _values = __webpack_require__(167);

	var _values2 = _interopRequireDefault(_values);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _chaosUi = __webpack_require__(8);

	var _index = __webpack_require__(11);

	var _reactDom = __webpack_require__(24);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _FeedTextarea = __webpack_require__(135);

	var _FeedTextarea2 = _interopRequireDefault(_FeedTextarea);

	var _ReplyInputMoreOpt = __webpack_require__(130);

	var _ReplyInputMoreOpt2 = _interopRequireDefault(_ReplyInputMoreOpt);

	var _ReplyImgPreview = __webpack_require__(128);

	var _ReplyImgPreview2 = _interopRequireDefault(_ReplyImgPreview);

	var _xmlEntities = __webpack_require__(65);

	var _xmlEntities2 = _interopRequireDefault(_xmlEntities);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(245);

	var InputFooter = function (_Component) {
		(0, _inherits3.default)(InputFooter, _Component);

		function InputFooter(props) {
			(0, _classCallCheck3.default)(this, InputFooter);

			var _this = (0, _possibleConstructorReturn3.default)(this, (InputFooter.__proto__ || (0, _getPrototypeOf2.default)(InputFooter)).call(this, props));

			_this.showReplyInputMore = _this.showReplyInputMore.bind(_this);

			_this.textareaOnFocus = _this.textareaOnFocus.bind(_this);
			_this.textareaOnBlur = _this.textareaOnBlur.bind(_this);
			_this.changeTextarea = _this.changeTextarea.bind(_this);

			_this.inputEomticon = _this.inputEomticon.bind(_this);
			_this.deleteEomticon = _this.deleteEomticon.bind(_this);

			_this.showUserPicker = _this.showUserPicker.bind(_this);
			_this.confirmUserPicker = _this.confirmUserPicker.bind(_this);
			_this.cancelUserPicker = _this.cancelUserPicker.bind(_this);
			_this.clearUserPickerData = _this.clearUserPickerData.bind(_this);

			_this.addImgFiles = _this.addImgFiles.bind(_this);
			_this.deleteImgFile = _this.deleteImgFile.bind(_this);

			_this.saveReplyInfo = _this.saveReplyInfo.bind(_this);

			_this.fetchDefaultUsers = _this.fetchDefaultUsers.bind(_this);
			_this.fetchSearchUsers = _this.fetchSearchUsers.bind(_this);

			_this.state = {
				confirmBtnClass: 'footer-confirm-btn',
				isShowReplyInputMoreOpt: false,
				textareaValue: '',
				isShowUserPicker: false,
				imgFiles: [],
				selectedDatas: [],
				commentId: 0,
				isShowMask: false,
				allUsers: [],
				defaultUsers: [],
				replyInputFocus: false

			};
			return _this;
		}
		// 显示底部工具栏更多选项


		(0, _createClass3.default)(InputFooter, [{
			key: 'showReplyInputMore',
			value: function showReplyInputMore(e) {
				e.preventDefault();
				this.setState({
					isShowReplyInputMoreOpt: !this.state.isShowReplyInputMoreOpt,
					showItem: 'item'
				});
			}

			// 输入框聚焦样式

		}, {
			key: 'textareaOnFocus',
			value: function textareaOnFocus() {
				this.setState({
					isShowReplyInputMoreOpt: false,
					replyInputFocus: true
				});
			}
		}, {
			key: 'textareaOnBlur',
			value: function textareaOnBlur() {
				this.setState({
					replyInputFocus: false
				});
				// 暂时取消此处样式的调整，确定按钮样式完全有值决定
				// this.setState({
				// 	confirmBtnClass: 'footer-confirm-btn'
				// });
			}

			// 保存输入框数值

		}, {
			key: 'changeTextarea',
			value: function changeTextarea(value, height) {
				var confirmBtnClass = 'footer-confirm-btn';
				if (value.length > 0) {
					confirmBtnClass = 'footer-confirm-btn on';
				}
				this.setState({
					confirmBtnClass: confirmBtnClass,
					textareaValue: value
				});
			}

			// 向输入框输入表情

		}, {
			key: 'inputEomticon',
			value: function inputEomticon(eomticonValue) {
				this.setState({
					confirmBtnClass: 'footer-confirm-btn on',
					textareaValue: this.state.textareaValue + eomticonValue,
					showItem: 'eomticon'
				});
			}

			// 删除结尾处的表情

		}, {
			key: 'deleteEomticon',
			value: function deleteEomticon(e) {
				e.preventDefault();
				var textareaValue = this.state.textareaValue;
				// 获取匹配规则的表情字符

				var matchEomticons = textareaValue.match(/\[[a-z]+:[^\]]+\]/g);
				var matchEomticon = matchEomticons ? matchEomticons.pop() : null;
				// 如果存在表情
				if (matchEomticon) {
					var lastStr = textareaValue.slice(-matchEomticon.length);
					if (matchEomticon === lastStr) {
						// 截取最后一个表情
						this.setState({
							textareaValue: textareaValue.slice(0, textareaValue.length - matchEomticon.length),
							showItem: 'eomticon'
						});
					}
				}
			}

			// @人员

		}, {
			key: 'showUserPicker',
			value: function showUserPicker(e) {
				this.setState({
					isShowUserPicker: true
				});
			}

			// 保存人员

		}, {
			key: 'confirmUserPicker',
			value: function confirmUserPicker(e, data) {
				var personNames = data.map(function (item) {
					return '@[' + item.Name + ':' + item.Email + ']';
				});
				var textareaValue = this.state.textareaValue + personNames.join('');
				var confirmBtnClass = 'footer-confirm-btn';
				if (textareaValue.length > 0) {
					confirmBtnClass = 'footer-confirm-btn on';
				}

				this.setState({
					selectedDatas: data,
					isShowUserPicker: false,
					textareaValue: textareaValue,
					confirmBtnClass: confirmBtnClass,
					allUsers: [],
					defaultUsers: []
				});
			}
		}, {
			key: 'cancelUserPicker',
			value: function cancelUserPicker(e) {
				this.setState({
					isShowUserPicker: false,
					allUsers: [],
					defaultUsers: []
				});
			}

			// 清空人员数据

		}, {
			key: 'clearUserPickerData',
			value: function clearUserPickerData(e) {
				this.setState({
					selectedDatas: [],
					isShowUserPicker: false
				});
			}

			// 保存图片

		}, {
			key: 'addImgFiles',
			value: function addImgFiles(res, imgFile) {
				if (res == '') {
					return;
				}
				var _state = this.state,
				    imgFiles = _state.imgFiles,
				    textareaValue = _state.textareaValue;

				var newFiles = imgFiles.concat(imgFile);
				if (textareaValue.length == 0) {
					textareaValue = this.props.translation.DynamicStates.FileShareAutoText;
				}
				this.setState({
					confirmBtnClass: 'footer-confirm-btn on',
					imgFiles: newFiles,
					textareaValue: textareaValue
				});
			}

			// 删除图片

		}, {
			key: 'deleteImgFile',
			value: function deleteImgFile(dfsPath) {
				var imgFiles = this.state.imgFiles;

				this.setState({
					imgFiles: imgFiles.filter(function (imgFile) {
						return imgFile.DfsPath != dfsPath;
					})
				});
			}

			// 添加回复

		}, {
			key: 'saveReplyInfo',
			value: function saveReplyInfo(e) {
				var _this2 = this;

				this.refs.FeedTextarea && this.refs.FeedTextarea.textareaBlur();
				e.preventDefault();

				var _state2 = this.state,
				    textareaValue = _state2.textareaValue,
				    imgFiles = _state2.imgFiles;
				var _props = this.props,
				    feedId = _props.feedId,
				    replyPerson = _props.replyPerson,
				    isDetail = _props.isDetail;

				// 若为详情页，数据需要实时获取

				if (!isDetail) {
					feedId = this.props.replyInfo.feedId;
				}

				// 取消提示无任何操作
				if (textareaValue.length == 0) {
					return;
				}

				var FileUrl = imgFiles.map(function (item) {
					return item.DfsPath;
				}).toString();

				var params = {
					FeedId: feedId,
					CommentId: replyPerson ? replyPerson.commentId : 0,
					Content: _xmlEntities2.default.encode(textareaValue),
					FileUrl: FileUrl,
					ObjId: 0,
					ObjType: 0,
					IsSendSMS: false
				};

				var url = (0, _index.urlComplete)('/api/v2/{tenant_id}/{user_id}/comment/Add');
				// 遮罩
				this.setState({
					isShowMask: true
				});
				(0, _index.callFetch)(url, 'POST', params).then(function (respData) {
					_this2.props.afterSave(respData);
					_this2.setState({
						confirmBtnClass: 'footer-confirm-btn',
						isShowReplyInputMoreOpt: false,
						isShowUserPicker: false,
						textareaValue: '',
						imgFiles: [],
						selectedDatas: [],
						isShowMask: false
					});
				});
			}

			// 请求常用列表

		}, {
			key: 'fetchDefaultUsers',
			value: function fetchDefaultUsers() {
				var _this3 = this;

				var defaultUrl = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/Contact') + '?v=' + new Date().getTime();
				(0, _index.callFetch)(defaultUrl, 'GET').then(function (response) {
					_this3.setState({
						allUsers: (0, _values2.default)(response.Data),
						defaultUsers: (0, _values2.default)(response.Data)
					});
				});
			}

			// 请求搜索值列表
			// url = {urlComplete('/api/v1/{tenant_id}/{user_id}/user')}
			// isTita = {true}
			// defaultUrl={urlComplete('/api/v1/{tenant_id}/{user_id}/Contact') + '?v=' + (new Date()).getTime()}

		}, {
			key: 'fetchSearchUsers',
			value: function fetchSearchUsers(searchval) {
				var _this4 = this;

				var fetchUrl = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/user'),
				    params = {
					v: new Date().getTime(),
					filters: searchval,
					app: window.BSGlobal.application
				};
				fetchUrl = fetchUrl.replace('{filters}', searchval);
				if (fetchUrl.indexOf('?') > -1 && fetchUrl.indexOf('app') < 0) {
					fetchUrl += '&app=' + params.app;
					params = null;
				}
				(0, _index.callFetch)(fetchUrl, 'GET', params).then(function (response) {
					var Users = [],
					    UserData = response.Data;
					if (UserData && UserData.SimpleUserModel) {
						for (var key in UserData.SimpleUserModel) {
							var item = UserData.SimpleUserModel[key];
							Users.push(item);
						}
					}
					_this4.setState({ allUsers: Users });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state3 = this.state,
				    isShowReplyInputMoreOpt = _state3.isShowReplyInputMoreOpt,
				    textareaValue = _state3.textareaValue,
				    showItem = _state3.showItem,
				    isShowUserPicker = _state3.isShowUserPicker,
				    imgFiles = _state3.imgFiles,
				    selectedDatas = _state3.selectedDatas,
				    feedInputPlaceHolder = _state3.feedInputPlaceHolder,
				    isShowMask = _state3.isShowMask;
				var _props2 = this.props,
				    replyPerson = _props2.replyPerson,
				    isFocusInput = _props2.isFocusInput,
				    translation = _props2.translation;
				// 钉钉和企业微信自身已经做了适配

				var ua = navigator.userAgent;
				var hadSafeDevice = !!ua.match(/DingTalk/i) || !!ua.match(/wxwork/i);
				var userSelectPageTranslation = { // copied from chaos-ui
					search: translation.MobileUpaasUI.SearchPersonPlaceholder,
					confirm: translation.DynamicStates.Confirm,
					clear: translation.DynamicStates.Clear,
					cancel: translation.DynamicStates.Cancel,
					loading: translation.DynamicStates.LoadingText,
					empty: translation.MobileUpaasUI.NoData
				};
				return React.createElement(
					'div',
					{ className: 'feed-input-content ' + (this.props.footercls || '') + (!hadSafeDevice ? ' feed-need-safe-area' : '') },
					React.createElement(_ReplyImgPreview2.default, { imgFiles: imgFiles, deleteImg: this.deleteImgFile }),
					React.createElement('div', { className: 'feed-input-footer-line' }),
					React.createElement(
						'div',
						{ className: 'feed-input-footer-reply' + (this.state.replyInputFocus || this.state.isShowReplyInputMoreOpt ? ' focus' : '') },
						React.createElement(
							'div',
							{ className: 'footer-reply-icon',
								onClick: this.showUserPicker },
							React.createElement('span', { className: 'reply-icon person-picker-icon' })
						),
						React.createElement(
							'div',
							{ className: 'footer-reply-icon',
								onTouchTap: this.showReplyInputMore },
							React.createElement('span', { className: (0, _classnames2.default)('reply-icon', {
									'more-icon': !isShowReplyInputMoreOpt,
									'keyboard-icon': isShowReplyInputMoreOpt
								}) })
						),
						React.createElement(_FeedTextarea2.default, {
							ref: 'FeedTextarea',
							textareaOnFocus: this.textareaOnFocus,
							textareaOnBlur: this.textareaOnBlur,
							textareaValue: textareaValue,
							changeTextarea: this.changeTextarea,
							isFocus: isFocusInput,
							placeholder: replyPerson ? translation.DynamicStates.Reply + '@' + replyPerson.publishUser.name : translation.DynamicStates.Reply
						}),
						React.createElement(
							'div',
							{ className: 'footer-confirm-btn-content' },
							React.createElement(
								'div',
								{ className: this.state.confirmBtnClass, ref: 'confirmbtn',
									onTouchTap: this.saveReplyInfo
								},
								isShowMask ? React.createElement('div', { className: 'load-model' }) : translation.DynamicStates.ConfirmSend
							)
						)
					),
					React.createElement(_ReplyInputMoreOpt2.default, {
						translation: translation,
						isShow: isShowReplyInputMoreOpt,
						inputEomticon: this.inputEomticon,
						deleteEomticon: this.deleteEomticon,
						addImgFiles: this.addImgFiles,
						showItem: showItem }),
					isShowUserPicker ? React.createElement(
						_chaosUi.PopUp,
						{ cls: 'feed-userSelct', visible: isShowUserPicker, style: { width: '100%', height: '100%' } },
						React.createElement(_chaosUi.UserSelectPage, {
							translation: userSelectPageTranslation,
							handleCancel: this.cancelUserPicker,
							singleSelect: false,
							hideNavClear: true,
							handleConfirm: this.confirmUserPicker,
							title: translation.MobileUpaasUI.ChooseAtPerson,
							usersList: this.state.allUsers,
							defaultUsers: this.state.defaultUsers,
							selectedDatas: [],
							fetchDefaultUsers: this.fetchDefaultUsers,
							fetchSearchUsers: this.fetchSearchUsers,
							tapSwipeBtn: this.clearUserPickerData
						})
					) : null,
					isShowMask ? React.createElement(_chaosUi.PopUp, { visible: isShowMask, wrapClassName: 'reply-wrap' }) : null
				);
			}
		}]);
		return InputFooter;
	}(_react.Component);

	exports.default = InputFooter;
	module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ReplyInputMoreOptItem = undefined;

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _Eomticon = __webpack_require__(69);

	var _Eomticon2 = _interopRequireDefault(_Eomticon);

	var _chaosUi = __webpack_require__(8);

	var _index = __webpack_require__(11);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(246);

	var ReplyInputMoreOptItem = exports.ReplyInputMoreOptItem = function (_Component) {
		(0, _inherits3.default)(ReplyInputMoreOptItem, _Component);

		function ReplyInputMoreOptItem(props) {
			(0, _classCallCheck3.default)(this, ReplyInputMoreOptItem);

			var _this = (0, _possibleConstructorReturn3.default)(this, (ReplyInputMoreOptItem.__proto__ || (0, _getPrototypeOf2.default)(ReplyInputMoreOptItem)).call(this, props));

			_this.onSuccess = _this.onSuccess.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(ReplyInputMoreOptItem, [{
			key: 'onSuccess',
			value: function onSuccess(res, file) {
				this.props.addImgFiles(res, file);
			}
		}, {
			key: 'render',
			value: function render() {
				//<li className='input-more-photograph'>拍照</li>
				var _props = this.props,
				    translation = _props.translation,
				    showEomticon = _props.showEomticon;
				var _BSGlobal$loginUserIn = BSGlobal.loginUserInfo,
				    TenantID = _BSGlobal$loginUserIn.TenantID,
				    UserID = _BSGlobal$loginUserIn.UserID;

				var action = 'api/v1/{tenant_id}/{user_id}/Upload/PostFiles?timestamp=' + new Date().getTime();
				return React.createElement(
					'ul',
					{ className: 'input-more' },
					React.createElement(
						_chaosUi.Upload,
						{
							action: (0, _index.urlComplete)(action),
							uploadType: 'iframe',
							component: 'li',
							className: 'input-more-photo',
							domain: window.location.host.split('.').slice(1, 3).join('.'),
							onSuccess: this.onSuccess },
						translation.MobileUpaasUI.Picture
					),
					React.createElement(
						'li',
						{ className: 'input-more-eomticon', onTouchTap: showEomticon },
						translation.MobileUpaasUI.Eomticon
					)
				);
			}
		}]);
		return ReplyInputMoreOptItem;
	}(_react.Component);

	var ReplyInputMoreOpt = function (_Component2) {
		(0, _inherits3.default)(ReplyInputMoreOpt, _Component2);

		function ReplyInputMoreOpt(props) {
			(0, _classCallCheck3.default)(this, ReplyInputMoreOpt);

			var _this2 = (0, _possibleConstructorReturn3.default)(this, (ReplyInputMoreOpt.__proto__ || (0, _getPrototypeOf2.default)(ReplyInputMoreOpt)).call(this, props));

			_this2.showEomticon = _this2.showEomticon.bind(_this2);
			_this2.state = {
				showItem: 'item'
			};
			return _this2;
		}

		(0, _createClass3.default)(ReplyInputMoreOpt, [{
			key: 'showEomticon',
			value: function showEomticon() {
				this.setState({
					showItem: 'eomticon'
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.setState({
					showItem: nextProps.showItem
				});
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.props.isShow !== true) {
					return null;
				}
				switch (this.state.showItem) {
					case 'eomticon':
						return React.createElement(
							'div',
							{ className: 'reply-input-more' },
							React.createElement(_Eomticon2.default, { inputEomticon: this.props.inputEomticon,
								deleteEomticon: this.props.deleteEomticon })
						);
						break;
					default:
						return React.createElement(
							'div',
							{ className: 'reply-input-more' },
							React.createElement(ReplyInputMoreOptItem, {
								translation: this.props.translation,
								showEomticon: this.showEomticon,
								addImgFiles: this.props.addImgFiles
							})
						);
						break;
				}
			}
		}]);
		return ReplyInputMoreOpt;
	}(_react.Component);

	exports.default = ReplyInputMoreOpt;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _chaosUi = __webpack_require__(8);

	var _index = __webpack_require__(11);

	var _Eomticon = __webpack_require__(69);

	var _Eomticon2 = _interopRequireDefault(_Eomticon);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(247);

	/*
	 * Name: 发布新分享 新动态 底部操作组件
	 * Desc: 可以进行图片上传，预览，选人，表情，权限选择等功能
	 * author: lilei@beisen.com
	 */

	var ShareInputFooter = function (_Component) {
		(0, _inherits3.default)(ShareInputFooter, _Component);

		function ShareInputFooter(props) {
			(0, _classCallCheck3.default)(this, ShareInputFooter);

			var _this = (0, _possibleConstructorReturn3.default)(this, (ShareInputFooter.__proto__ || (0, _getPrototypeOf2.default)(ShareInputFooter)).call(this, props));

			_this.onUploadSuccess = _this.onUploadSuccess.bind(_this);

			_this.showEomticon = _this.showEomticon.bind(_this);
			_this.getEomticonContent = _this.getEomticonContent.bind(_this);
			_this.inputEomticon = _this.inputEomticon.bind(_this);
			_this.deleteEomticon = _this.deleteEomticon.bind(_this);

			_this.showUserPicker = _this.showUserPicker.bind(_this);
			_this.getUserPickerPanel = _this.getUserPickerPanel.bind(_this);
			_this.confirmUserPicker = _this.confirmUserPicker.bind(_this);
			_this.cancelUserPicker = _this.cancelUserPicker.bind(_this);

			_this.showArrowContent = _this.showArrowContent.bind(_this);
			_this.getArrowContent = _this.getArrowContent.bind(_this);
			_this.selectArrowdown = _this.selectArrowdown.bind(_this);

			_this.getFooterMoreContent = _this.getFooterMoreContent.bind(_this);
			_this.fetchDefaultUsers = _this.fetchDefaultUsers.bind(_this);
			_this.fetchSearchUsers = _this.fetchSearchUsers.bind(_this);

			_this.state = {
				showItem: 'none',
				allUsers: [],
				defaultUsers: []
			};
			_this.arrowdownMap = {
				1: '公开',
				2: '部门',
				3: '@人'
			};
			return _this;
		}

		// 上传成功后调用


		(0, _createClass3.default)(ShareInputFooter, [{
			key: 'onUploadSuccess',
			value: function onUploadSuccess(res, file) {
				this.props.addImgFiles(res, file);
			}

			//===============动态表情相关==Start===============//

			// 显示表情

		}, {
			key: 'showEomticon',
			value: function showEomticon() {
				this.props.calcTextareaHeight(310);
				this.setState({
					showItem: 'eomticon'
				});
			}

			// 获取表情节点

		}, {
			key: 'getEomticonContent',
			value: function getEomticonContent() {
				return React.createElement(_Eomticon2.default, { inputEomticon: this.inputEomticon,
					deleteEomticon: this.deleteEomticon });
			}

			// 向输入框输入表情

		}, {
			key: 'inputEomticon',
			value: function inputEomticon(eomticonValue) {
				this.props.addTextareaValue(eomticonValue);
			}

			// 删除结尾处的表情

		}, {
			key: 'deleteEomticon',
			value: function deleteEomticon(e) {
				e.preventDefault();
				this.props.deleteEomticon();
			}

			//===============动态表情相关==End===============//

			//===============人员选择器相关==Start===============//

			// 显示人员选择器

		}, {
			key: 'showUserPicker',
			value: function showUserPicker(e) {
				this.setState({
					showItem: 'userPicker'
				});
			}

			// 请求常用列表

		}, {
			key: 'fetchDefaultUsers',
			value: function fetchDefaultUsers() {
				var _this2 = this;

				var defaultUrl = '/api/v2/Data/Contact?app=' + BSGlobal.application;
				(0, _index.callFetch)(defaultUrl, 'GET').then(function (response) {
					_this2.setState({
						allUsers: response,
						defaultUsers: response
					});
				});
			}

			// 请求搜索值列表
			// url = {urlComplete('/api/v1/{tenant_id}/{user_id}/user')}
			// defaultUrl={'/api/v2/Data/Contact?app=' + BSGlobal.application}

		}, {
			key: 'fetchSearchUsers',
			value: function fetchSearchUsers(searchval) {
				var _this3 = this;

				var fetchUrl = (0, _index.urlComplete)('/api/v1/{tenant_id}/{user_id}/user'),
				    params = {
					v: new Date().getTime(),
					filters: searchval,
					app: window.BSGlobal.application
				};
				fetchUrl = fetchUrl.replace('{filters}', searchval);
				if (fetchUrl.indexOf('?') > -1 && fetchUrl.indexOf('app') < 0) {
					fetchUrl += '&app=' + params.app;
					params = null;
				}
				(0, _index.callFetch)(fetchUrl, 'GET', params).then(function (response) {
					var Users = [],
					    UserData = response.Data;
					if (UserData && UserData.SimpleUserModel) {
						for (var key in UserData.SimpleUserModel) {
							var item = UserData.SimpleUserModel[key];
							Users.push(item);
						}
					}
					_this3.setState({ allUsers: Users });
				});
			}

			// 获取选人组件

		}, {
			key: 'getUserPickerPanel',
			value: function getUserPickerPanel() {
				return React.createElement(
					_chaosUi.PopUp,
					{ cls: 'feed-userSelct', visible: true, style: { width: '100%', height: '100%' } },
					React.createElement(_chaosUi.UserSelectPage, {
						handleCancel: this.cancelUserPicker,
						singleSelect: false,
						hideNavClear: true,
						handleConfirm: this.confirmUserPicker,
						title: '\u901A\u8BAF\u5F55',
						usersList: this.state.allUsers,
						defaultUsers: this.state.defaultUsers,
						selectedDatas: [],
						fetchDefaultUsers: this.fetchDefaultUsers,
						fetchSearchUsers: this.fetchSearchUsers
					})
				);
			}

			// 保存人员

		}, {
			key: 'confirmUserPicker',
			value: function confirmUserPicker(e, data) {
				var personNames = data.map(function (item) {
					return '@[' + item.Name + ':' + item.Email + ']';
				});
				this.props.addTextareaValue(personNames.join(''));
				this.setState({
					showItem: 'none',
					allUsers: [],
					defaultUsers: []
				});
			}

			// 取消显示人员选择器

		}, {
			key: 'cancelUserPicker',
			value: function cancelUserPicker(e) {
				this.setState({
					showItem: 'none',
					allUsers: [],
					defaultUsers: []
				});
			}

			//===============人员选择器相关==End===============//

			//===============动态权限相关==Start===============//

			// 显示权限选择区域

		}, {
			key: 'showArrowContent',
			value: function showArrowContent() {
				this.props.calcTextareaHeight(286);
				this.setState({
					showItem: 'arrowdown'
				});
			}

			// 获取动态权限

		}, {
			key: 'getArrowContent',
			value: function getArrowContent() {
				var visibility = this.props.visibility;

				return React.createElement(
					'ul',
					{ className: 'footer-arrowdown-content' },
					React.createElement(
						'li',
						{ className: (0, _classnames2.default)('arrowdown-all', {
								on: visibility == 1
							}), 'data-vis': 1, onTouchTap: this.selectArrowdown },
						'\u6240\u6709\u4EBA\u53EF\u89C1'
					),
					React.createElement(
						'li',
						{ className: (0, _classnames2.default)('arrowdown-dep', {
								on: visibility == 2
							}), 'data-vis': 2, onTouchTap: this.selectArrowdown },
						'\u8FDB\u90E8\u95E8\u53EF\u89C1'
					),
					React.createElement(
						'li',
						{ className: (0, _classnames2.default)('arrowdown-at', {
								on: visibility == 3
							}), 'data-vis': 3, onTouchTap: this.selectArrowdown },
						'\u4EC5@\u7684\u4EBA\u53EF\u89C1'
					)
				);
			}

			// 根据选取的节点获取权限参数

		}, {
			key: 'selectArrowdown',
			value: function selectArrowdown(e) {
				e.preventDefault();
				var visibility = e.target.getAttribute('data-vis');
				this.props.setVisibility(visibility);
				this.setState({
					showItem: 'none'
				});
			}

			//===============动态权限相关==End===============//

			// 根据内容获取底部显示内容

		}, {
			key: 'getFooterMoreContent',
			value: function getFooterMoreContent() {
				var showItem = this.state.showItem;

				switch (showItem) {
					case 'none':
						return null;
						break;
					case 'eomticon':
						return this.getEomticonContent();
						break;
					case 'userPicker':
						return this.getUserPickerPanel();
						break;
					case 'arrowdown':
						return this.getArrowContent();
						break;
					default:
						return null;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var visibility = this.props.visibility;
				var _state = this.state,
				    isShowEomticon = _state.isShowEomticon,
				    isShowUserPicker = _state.isShowUserPicker,
				    isShowArrowContent = _state.isShowArrowContent;

				var action = 'api/v1/{tenant_id}/{user_id}/Upload/PostFiles?timestamp=' + new Date().getTime();
				return React.createElement(
					'div',
					{ className: 'feed-input-footer' },
					React.createElement(_chaosUi.Upload, {
						action: (0, _index.urlComplete)(action),
						uploadType: 'iframe',
						component: 'span',
						className: 'footer-btn footer-upload-img',
						domain: window.location.host.split('.').slice(1, 3).join('.'),
						onSuccess: this.onUploadSuccess }),
					React.createElement('span', { className: 'footer-btn footer-person-picker', onTouchTap: this.showUserPicker }),
					React.createElement('span', { className: 'footer-btn footer-eomticon', onTouchTap: this.showEomticon }),
					React.createElement(
						'ul',
						{ className: 'footer-arrowdown', onTouchTap: this.showArrowContent },
						React.createElement('li', { className: 'arrowdown-img' }),
						React.createElement(
							'li',
							{ className: 'arrowdown-text' },
							this.arrowdownMap[visibility]
						),
						React.createElement('li', { className: 'arrowdown-btn' })
					),
					this.getFooterMoreContent()
				);
			}
		}]);
		return ShareInputFooter;
	}(_react.Component);

	exports.default = ShareInputFooter;
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _chaosUi = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(249);

	var Eomticon = function (_Component) {
		(0, _inherits3.default)(Eomticon, _Component);

		function Eomticon(props) {
			(0, _classCallCheck3.default)(this, Eomticon);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Eomticon.__proto__ || (0, _getPrototypeOf2.default)(Eomticon)).call(this, props));

			_this.onSwipe = _this.onSwipe.bind(_this);
			_this.onTouchTap = _this.onTouchTap.bind(_this);
			return _this;
		}

		// 表情左右滑动


		(0, _createClass3.default)(Eomticon, [{
			key: 'onSwipe',
			value: function onSwipe(evt) {
				var eomticonContent = this.refs.eomticonContent;
				var currentPage = this.props.currentPage;

				var contentLeft = parseInt(eomticonContent.style.left);

				if (evt.direction == 'Left') {
					var maxLeft = eomticonContent.clientWidth - document.body.clientWidth;
					if (maxLeft === Math.abs(contentLeft)) return;
					this.props.changeEomticonPage(currentPage + 1);
				}
				if (evt.direction == 'Right') {
					if (contentLeft === 0) return;
					this.props.changeEomticonPage(currentPage - 1);
				}
			}

			// 点击表情添加至文版框

		}, {
			key: 'onTouchTap',
			value: function onTouchTap(e) {
				e.preventDefault();
				e.stopPropagation();
				this.props.inputEomticon(e.currentTarget.getAttribute('data-name'));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;

				var _props = this.props,
				    eomticonData = _props.eomticonData,
				    eomticonTabCount = _props.eomticonTabCount,
				    eomticonHost = _props.eomticonHost,
				    currentPage = _props.currentPage;

				// 计算表情外框宽度高度及行高 左移宽度

				var bodyWidth = document.body.clientWidth,
				    tableWidth = bodyWidth + 'px',
				    tableTrHeight = bodyWidth * 0.11 + 'px',
				    currentTableLeft = -(bodyWidth * currentPage) + 'px',
				    eomticonTables = [];

				// 循环构造表情页

				var _loop = function _loop(i) {
					// 根据当前页数获取当前需要渲染的表情数据
					var currentEomticons = eomticonData.slice(i * 20, i * 20 + 20),
					    currentEomticonsTds = [];
					// 构建表情Td
					currentEomticons.map(function (item, index) {
						currentEomticonsTds.push(React.createElement(
							'div',
							{ className: 'eomticon-cell', key: index,
								'data-name': item.name, onTouchTap: _this2.onTouchTap },
							React.createElement('img', { 'data-name': item.name, src: eomticonHost + item.address })
						));
					});
					// 尾部追加删除按钮
					currentEomticonsTds.push(React.createElement(
						'div',
						{ className: 'eomticon-cell', key: currentEomticonsTds.length + 1 },
						React.createElement('span', { className: 'eomticon-delete-btn',
							onTouchTap: _this2.props.deleteEomticon })
					));

					// 不足7位的补足7位
					var extralTdCount = 7 - (currentEomticonsTds.length % 7 === 0 ? 7 : currentEomticonsTds.length % 7);
					for (var _i = 0; _i < extralTdCount; _i++) {
						currentEomticonsTds.push(React.createElement('div', { key: currentEomticonsTds.length + 1 + _i }));
					}

					//构建整个表情Table
					eomticonTables.push(React.createElement(
						'div',
						{ className: 'eomticon-table', style: { width: tableWidth }, key: i },
						React.createElement(
							'div',
							{ style: { width: tableWidth } },
							React.createElement(
								'div',
								{ className: 'eomticon-row', style: { width: tableWidth, height: tableTrHeight } },
								currentEomticonsTds.slice(0, 7)
							),
							React.createElement(
								'div',
								{ className: 'eomticon-row', style: { width: tableWidth, height: tableTrHeight } },
								currentEomticonsTds.slice(7, 14)
							),
							React.createElement(
								'div',
								{ div: true, className: 'eomticon-row', style: { width: tableWidth, height: tableTrHeight } },
								currentEomticonsTds.slice(14, 21)
							)
						)
					));
				};

				for (var i = 0; i < eomticonTabCount; i++) {
					_loop(i);
				}

				// // 循环构造表情页
				// for(let i = 0; i < eomticonTabCount; i++ ){
				// 	// 根据当前页数获取当前需要渲染的表情数据
				// 	const currentEomticons = eomticonData.slice(i*20, (i*20)+20),
				// 		currentEomticonsTds = [];
				// 	// 构建表情Td
				// 	currentEomticons.map((item, index) => {
				// 		currentEomticonsTds.push(<td key={index} 
				// 			data-name={item.name} onTouchTap = { this.onTouchTap }>
				// 			<img data-name={item.name} src={eomticonHost + item.address}/>
				// 		</td>);
				// 	});
				// 	// 尾部追加删除按钮
				// 	currentEomticonsTds.push(<td key={currentEomticonsTds.length + 1}>
				// 		<span className='eomticon-delete-btn' 
				// 			onTouchTap = {this.props.deleteEomticon}></span>
				// 	</td>);

				// 	// 不足7位的补足7位
				// 	const extralTdCount = 7 - (currentEomticonsTds.length % 7 === 0 ? 7 : currentEomticonsTds.length % 7);
				// 	for(let i = 0; i < extralTdCount; i++){
				// 		currentEomticonsTds.push(<td key={currentEomticonsTds.length + 1 + i}></td>);
				// 	}

				// 	//构建整个表情Table
				// 	eomticonTables.push(
				// 		<table className='eomticon-table' style = {{width: tableWidth}} key = {i}>
				// 			<tbody style = {{width: tableWidth}}>
				// 				<tr style = {{width: tableWidth}}>
				// 				{
				// 					currentEomticonsTds.slice(0,7)
				// 				}
				// 				</tr>
				// 				<tr style = {{width: tableWidth}}>
				// 				{
				// 					currentEomticonsTds.slice(7, 14)
				// 				}
				// 				</tr>
				// 				<tr style = {{width: tableWidth}}>
				// 				{
				// 					currentEomticonsTds.slice(14, 21)
				// 				}
				// 				</tr>
				// 			</tbody>
				// 		</table>
				// 	);
				// }

				return React.createElement(
					_chaosUi.AlloyFinger,
					{ onSwipe: this.onSwipe.bind(this) },
					React.createElement(
						'div',
						{ className: 'eomticon-content',
							style: { width: (this.props.eomticonTabCount || 1) + '00%', left: currentTableLeft },
							ref: 'eomticonContent' },
						eomticonTables
					)
				);
			}
		}]);
		return Eomticon;
	}(_react.Component);

	exports.default = Eomticon;
	module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(250);

	var Eomticon = function (_Component) {
		(0, _inherits3.default)(Eomticon, _Component);

		function Eomticon(props) {
			(0, _classCallCheck3.default)(this, Eomticon);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Eomticon.__proto__ || (0, _getPrototypeOf2.default)(Eomticon)).call(this, props));

			_this.onTouchTap = _this.onTouchTap.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(Eomticon, [{
			key: 'onTouchTap',
			value: function onTouchTap(e) {
				this.props.changeEomticonPage(e.target.getAttribute('data-eomticonpage'));
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    eomticonTabCount = _props.eomticonTabCount,
				    currentPage = _props.currentPage;
				// 构建分页栏

				var eomticonPagingBar = [];
				for (var i = 0; i < eomticonTabCount; i++) {
					eomticonPagingBar.push(React.createElement('li', { key: i,
						'data-eomticonpage': i,
						onTouchTap: this.onTouchTap,
						className: (0, _classnames2.default)({ 'on': currentPage === i })
					}));
				}
				return React.createElement(
					'ul',
					{ className: 'eomticon-page-bar' },
					eomticonPagingBar
				);
			}
		}]);
		return Eomticon;
	}(_react.Component);

	exports.default = Eomticon;
	module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(251);

	var Eomticon = function (_Component) {
		(0, _inherits3.default)(Eomticon, _Component);

		function Eomticon(props) {
			(0, _classCallCheck3.default)(this, Eomticon);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Eomticon.__proto__ || (0, _getPrototypeOf2.default)(Eomticon)).call(this, props));

			_this.onTouchTap = _this.onTouchTap.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(Eomticon, [{
			key: 'onTouchTap',
			value: function onTouchTap(e) {
				this.props.changeEomticonType(e.target.getAttribute('data-eomticontype'));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;

				var _props = this.props,
				    eomticonTypeData = _props.eomticonTypeData,
				    currentType = _props.currentType;


				return React.createElement(
					'ul',
					{ className: 'eomticon-type' },
					eomticonTypeData.map(function (item, index) {
						return React.createElement(
							'li',
							{ key: index, 'data-eomticontype': index,
								className: (0, _classnames2.default)({ 'on': currentType === index }),
								onTouchTap: _this2.onTouchTap
							},
							item
						);
					})
				);
			}
		}]);
		return Eomticon;
	}(_react.Component);

	exports.default = Eomticon;
	module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _reactDom = __webpack_require__(24);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(252);

	var FeedTextarea = function (_Component) {
		(0, _inherits3.default)(FeedTextarea, _Component);

		function FeedTextarea(props) {
			(0, _classCallCheck3.default)(this, FeedTextarea);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedTextarea.__proto__ || (0, _getPrototypeOf2.default)(FeedTextarea)).call(this, props));

			_this.changeHandler = _this.changeHandler.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(FeedTextarea, [{
			key: 'changeHandler',
			value: function changeHandler(e) {
				e.target.style.height = '0.34rem';
				this.props.changeTextarea(e.target.value, e.target.scrollHeight);
			}
		}, {
			key: 'textareaBlur',
			value: function textareaBlur() {
				this.refs.textarea.blur();
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    textareaValue = _props.textareaValue,
				    textareaOnFocus = _props.textareaOnFocus,
				    textareaOnBlur = _props.textareaOnBlur,
				    placeholder = _props.placeholder,
				    isFocus = _props.isFocus;

				return React.createElement(
					'div',
					{ className: 'footer-reply-textarea-content', ref: 'textareaContent' },
					React.createElement('textarea', {
						className: 'footer-reply-textarea',
						ref: 'textarea',
						placeholder: placeholder,
						onChange: this.changeHandler,
						onFocus: textareaOnFocus,
						onBlur: textareaOnBlur,
						value: textareaValue,
						autofocus: isFocus
					})
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.isFocus) {
					this.refs.textarea.focus();
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.refs.textarea.style.height = '0.34rem';
				var scrollHeight = this.refs.textarea.scrollHeight + 'px';
				this.refs.textarea.style.height = scrollHeight;
				this.refs.textareaContent.style.height = scrollHeight;
				if (this.props.isFocus) {
					this.refs.textarea.focus();
				}
			}
		}]);
		return FeedTextarea;
	}(_react.Component);

	exports.default = FeedTextarea;
	module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(254);

	/*
	 * Name: 回复顶部统计栏
	 * Desc: 区分列表也和详情页，用于决定是否显示展开操作按钮
	 * author: lilei@beisen.com
	 */

	var FeedReplyBar = function (_Component) {
		(0, _inherits3.default)(FeedReplyBar, _Component);

		function FeedReplyBar(props) {
			(0, _classCallCheck3.default)(this, FeedReplyBar);
			return (0, _possibleConstructorReturn3.default)(this, (FeedReplyBar.__proto__ || (0, _getPrototypeOf2.default)(FeedReplyBar)).call(this, props));
			//this.expandReply = this.expandReply.bind(this);
		}

		// 显示更多评论
		// expandReply(){
		// 	this.props.expandReply(!this.props.isExpand);
		// }

		(0, _createClass3.default)(FeedReplyBar, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    total = _props.total,
				    isShowMore = _props.isShowMore,
				    isExpand = _props.isExpand,
				    translation = _props.translation;

				return React.createElement(
					'div',
					{ className: 'reply-total' },
					React.createElement(
						'span',
						{ className: 'reply-total-text' },
						translation.MobileUpaasUI.Comment + ' ' + total
					)
				);
			}
		}]);
		return FeedReplyBar;
	}(_react.Component);

	exports.default = FeedReplyBar;
	module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedFileList = __webpack_require__(44);

	var _FeedFileList2 = _interopRequireDefault(_FeedFileList);

	var _chaosUi = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(255);

	var userLinkReg = /\/u\/(\d+)/;

	window.getMoleJS_FRI = function () {
		// Ref: FeedFileList.js
		// 平台已将MoleJs挂到window.env上 如想使用MoleJs中的方法 直接调用window.env即可;
		// 文档：https://wiki.beisen.co/display/paasdev/MoleJS-SDK
		return window.env;
	};

	function getInfoFromLinkEvent(evt) {
		if (evt.target.tagName.toLocaleUpperCase() === 'A') {
			var href = evt.target.getAttribute('href');
			var mtch = (href || '').match(userLinkReg);
			if (mtch && mtch.length > 1) {
				return { type: 'link', subType: 'user', value: mtch[1] };
			} else {
				return { type: 'link', subType: 'other', value: href };
			}
		} else {
			return { type: 'other', subType: 'other' };
		}
	}

	/*
	 * Name: 回复内容页
	 * Desc: 包含点击回复此条，详情页时可以弹出固定框可以删除回复和回复自己
	 * author: lilei@beisen.com
	 */

	var FeedReplyItem = function (_Component) {
		(0, _inherits3.default)(FeedReplyItem, _Component);

		function FeedReplyItem(props) {
			(0, _classCallCheck3.default)(this, FeedReplyItem);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedReplyItem.__proto__ || (0, _getPrototypeOf2.default)(FeedReplyItem)).call(this, props));

			_this.handleTouchTap = _this.handleTouchTap.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(FeedReplyItem, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refs.replyContentRef.addEventListener('click', function (evt) {
					var info = getInfoFromLinkEvent(evt);
					if (info.type === 'link') {
						evt.preventDefault();
						if (info.subType === 'user') {
							var userId = info.value;
							window.getMoleJS_FRI().openProfile({
								userId: userId,
								showBack: true
							});
						} else {
							window.getMoleJS_FRI().openNewPage({
								url: info.value,
								useDocumentTitle: true
							});
						}
					}
				});
				this.refs.replyContentRef.addEventListener('touchstart', function (evt) {
					var info = getInfoFromLinkEvent(evt);
					if (info.type === 'link') {
						evt.stopPropagation();
					}
				});
			}
		}, {
			key: 'handleTouchTap',
			value: function handleTouchTap(evt) {
				var _props = this.props,
				    touchCommentItem = _props.touchCommentItem,
				    isEdit = _props.isEdit,
				    commentId = _props.commentId,
				    publishUser = _props.publishUser;

				if (isEdit) {
					evt.preventDefault();
				}
				// 监听点击，由父组件确认具体操作
				touchCommentItem(isEdit, { commentId: commentId, publishUser: publishUser });
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    parentCommentId = _props2.parentCommentId,
				    content = _props2.content,
				    publishUser = _props2.publishUser,
				    createDate = _props2.createDate,
				    parentUser = _props2.parentUser,
				    attachments = _props2.attachments,
				    isDetail = _props2.isDetail,
				    translation = _props2.translation;

				var replyTitle = publishUser.name;
				// 若存在回复父对象，拼接回复标题内容
				if (parentCommentId) {
					replyTitle = ['<span class="reply-publish">', publishUser.name, '</span>&nbsp;' + translation.DynamicStates.ReplyToUser + '&nbsp;<span class="reply-parent">', parentUser.name, ':</span>'].join('');
				}
				// 人像使用相关数据
				var user = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar
				};
				return React.createElement(
					'div',
					{ className: 'reply-item', onTouchTap: this.handleTouchTap },
					isDetail ? React.createElement(_chaosUi.Avatar, (0, _extends3.default)({}, user, { scale: 'medium' })) : null,
					React.createElement(
						'div',
						{ className: (0, _classnames2.default)('reply-right', { 'detail-reply': isDetail }) },
						React.createElement(
							'div',
							{ className: 'reply-info' },
							React.createElement('span', { className: 'reply-title', dangerouslySetInnerHTML: { __html: replyTitle } }),
							React.createElement(
								'span',
								{ className: 'reply-create-date' },
								createDate
							)
						),
						React.createElement('div', { ref: 'replyContentRef',
							className: (0, _classnames2.default)('reply-content', { 'simple-reply': !isDetail }),
							dangerouslySetInnerHTML: { __html: content } }),
						attachments ? React.createElement(_FeedFileList2.default, { attachments: attachments }) : null
					)
				);
			}
		}]);
		return FeedReplyItem;
	}(_react.Component);

	exports.default = FeedReplyItem;
	module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedTimeLineBar = __webpack_require__(71);

	var _FeedTimeLineBar2 = _interopRequireDefault(_FeedTimeLineBar);

	var _FeedTimeLineItem = __webpack_require__(72);

	var _FeedTimeLineItem2 = _interopRequireDefault(_FeedTimeLineItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(102);
	__webpack_require__(259);

	/*
	 * Name: 签到时间线
	 * Desc: 签到时间线，逻辑较为特殊，单独提取出来
	 * author: lilei@beisen.com
	 */

	var FeedTimeSiteList = function (_Component) {
		(0, _inherits3.default)(FeedTimeSiteList, _Component);

		function FeedTimeSiteList(props) {
			(0, _classCallCheck3.default)(this, FeedTimeSiteList);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedTimeSiteList.__proto__ || (0, _getPrototypeOf2.default)(FeedTimeSiteList)).call(this, props));

			_this.expandRecord = _this.expandRecord.bind(_this);
			_this.state = {
				isExpand: false
			};
			return _this;
		}

		//展开操作记录信息


		(0, _createClass3.default)(FeedTimeSiteList, [{
			key: 'expandRecord',
			value: function expandRecord(e) {
				e.preventDefault();
				this.setState({
					isExpand: !this.state.isExpand
				});
			}

			// 获取渲染内容

		}, {
			key: 'getRenderOpts',
			value: function getRenderOpts() {
				// 处理数据
				var timeSites = this.props.timeSites;
				var isExpand = this.state.isExpand;

				var renderFeedOpts = [];
				// 收缩
				if (!isExpand && timeSites.length > 1) {
					// 列表页仅展示首尾两条
					timeSites = [timeSites[0], timeSites.pop()];
				}
				timeSites.map(function (item, index) {
					renderFeedOpts.push(React.createElement(
						'li',
						{ className: 'record-item time-site-item', key: index },
						React.createElement('span', { className: 'record-state' }),
						React.createElement(
							'div',
							{ className: 'record-right' },
							React.createElement(
								'span',
								{ className: 'record-time' },
								item.time
							),
							React.createElement(
								'span',
								{ className: 'record-content' },
								item.site
							)
						)
					));
				});
				return renderFeedOpts;
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    showBar = _props.showBar,
				    timeSites = _props.timeSites;
				var isExpand = this.state.isExpand;

				if (timeSites.length == 0) {
					return null;
				}
				return React.createElement(
					'div',
					{ className: 'record-list' },
					React.createElement(
						'span',
						{ className: (0, _classnames2.default)('record-show-more', {
								'expand': isExpand
							}), onTouchTap: this.expandRecord },
						isExpand ? '收起' : '展开'
					),
					React.createElement(
						'ul',
						{ className: (0, _classnames2.default)('record-list-content', {
								'only-one': !showBar || timeSites.length == 1
							}), style: { width: 'calc(100% - 50px)' } },
						this.getRenderOpts()
					)
				);
			}
		}]);
		return FeedTimeSiteList;
	}(_react.Component);

	exports.default = FeedTimeSiteList;
	module.exports = exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(260);

	/*
	 * Name: Feed标题下日期
	 * Desc: Feed标题下日期
	 * Author: lilei@beisen.com
	 */

	var FeedTitleDate = function (_Component) {
		(0, _inherits3.default)(FeedTitleDate, _Component);

		function FeedTitleDate(props) {
			(0, _classCallCheck3.default)(this, FeedTitleDate);
			return (0, _possibleConstructorReturn3.default)(this, (FeedTitleDate.__proto__ || (0, _getPrototypeOf2.default)(FeedTitleDate)).call(this, props));
		}

		(0, _createClass3.default)(FeedTitleDate, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    dateData = _props.dateData,
				    children = _props.children;

				return React.createElement(
					'span',
					{ className: 'feed-title-date' },
					dateData,
					children
				);
			}
		}]);
		return FeedTitleDate;
	}(_react.Component);

	exports.default = FeedTitleDate;
	module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(261);

	/*
	 * Name: Feed标题下隐私标示
	 * Desc: Feed标题下隐私标示，根据传入isPrivate判定是否显示
	 * Author: lilei@beisen.com
	 */

	var FeedTitleJur = function (_Component) {
		(0, _inherits3.default)(FeedTitleJur, _Component);

		function FeedTitleJur(props) {
			(0, _classCallCheck3.default)(this, FeedTitleJur);
			return (0, _possibleConstructorReturn3.default)(this, (FeedTitleJur.__proto__ || (0, _getPrototypeOf2.default)(FeedTitleJur)).call(this, props));
		}

		(0, _createClass3.default)(FeedTitleJur, [{
			key: 'render',
			value: function render() {
				var isPrivate = this.props.isPrivate;

				return isPrivate ? null : React.createElement('div', { className: 'feed-title-jur' });
			}
		}]);
		return FeedTitleJur;
	}(_react.Component);

	exports.default = FeedTitleJur;
	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _chaosUi = __webpack_require__(8);

	var _FeedDetailNav = __webpack_require__(142);

	var _FeedDetailNav2 = _interopRequireDefault(_FeedDetailNav);

	var _ShowMorePanel = __webpack_require__(143);

	var _ShowMorePanel2 = _interopRequireDefault(_ShowMorePanel);

	var _SimpleFeedDetail = __webpack_require__(75);

	var _SimpleFeedDetail2 = _interopRequireDefault(_SimpleFeedDetail);

	var _index = __webpack_require__(11);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: FeedDetail
	 * Desc: 各类Feed详情通用组件，根据Type甄别渲染类型
	 * author: lilei@beisen.com
	 */
	var FeedDetail = function (_Component) {
		(0, _inherits3.default)(FeedDetail, _Component);

		function FeedDetail(props) {
			(0, _classCallCheck3.default)(this, FeedDetail);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedDetail.__proto__ || (0, _getPrototypeOf2.default)(FeedDetail)).call(this, props));

			_this.handleBack = _this.handleBack.bind(_this);
			_this.handleTapMore = _this.handleTapMore.bind(_this);
			_this.closePanel = _this.closePanel.bind(_this);
			_this.deleteFeed = _this.deleteFeed.bind(_this);
			_this.getEdit = _this.getEdit.bind(_this);
			_this.state = {
				feedType: null,
				isFocusInput: false,
				replyItem: null,
				hideComments: false,
				showMorePanel: false,
				isEdit: false
			};
			return _this;
		}

		// 返回


		(0, _createClass3.default)(FeedDetail, [{
			key: 'handleBack',
			value: function handleBack(e) {
				e.preventDefault();
				this.props.handleBack();
			}

			// 点击更多

		}, {
			key: 'handleTapMore',
			value: function handleTapMore() {
				this.setState({ showMorePanel: true });
			}

			// 关闭更多弹层

		}, {
			key: 'closePanel',
			value: function closePanel() {
				this.setState({ showMorePanel: false });
			}

			// 删除一条feed

		}, {
			key: 'deleteFeed',
			value: function deleteFeed() {
				var _this2 = this;

				var url = (0, _index.urlComplete)('/api/v2/{tenant_id}/{user_id}/user/feed/Delete');
				var urlParams = 'feed_id=' + this.props.feedId;
				// 操作提示 有具体设计再添加此功能 let tipInfo; 
				(0, _index.callFetch)(url + '?' + urlParams, 'DELETE').then(function (respData) {
					if (respData.Code == 1) {
						//tipInfo = {feedTipShow: true, feedTipMessage: '删除成功',feedTipType: 'success'};
						_this2.props.handleBack();
					} else {}
					//tipInfo = {feedTipShow: true, feedTipMessage: '删除失败',feedTipType: 'error'};

					// this.props.showTip(tipInfo);
				});
			}
		}, {
			key: 'getEdit',
			value: function getEdit(isEdit) {
				this.setState({ isEdit: isEdit });
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    feedId = _props.feedId,
				    hideComments = _props.hideComments;

				return React.createElement(
					_chaosUi.Page,
					{ cls: 'detail-page widget-page feed-detail-page' },
					React.createElement(_FeedDetailNav2.default, { handleBack: this.handleBack, isEdit: this.state.isEdit, handleTapMore: this.handleTapMore }),
					React.createElement(_SimpleFeedDetail2.default, { feedId: feedId, hideComments: hideComments, getEdit: this.getEdit }),
					React.createElement(_ShowMorePanel2.default, { show: this.state.showMorePanel, handlePanelClose: this.closePanel, handleDeleteFeed: this.deleteFeed })
				);
			}
		}]);
		return FeedDetail;
	}(_react.Component);

	exports.default = FeedDetail;
	module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _chaosUi = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(265);

	/*
	 * Name: FeedDetail导航
	 * Desc: Feed详情导航
	 * author: lilei@beisen.com
	 */

	var FeedDetailNav = function (_Component) {
		(0, _inherits3.default)(FeedDetailNav, _Component);

		function FeedDetailNav(props) {
			(0, _classCallCheck3.default)(this, FeedDetailNav);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedDetailNav.__proto__ || (0, _getPrototypeOf2.default)(FeedDetailNav)).call(this, props));

			_this.handleTapMore = _this.handleTapMore.bind(_this);
			return _this;
		}

		// 点击更多操作


		(0, _createClass3.default)(FeedDetailNav, [{
			key: 'handleTapMore',
			value: function handleTapMore() {
				if (this.props.isEdit) {
					this.props.handleTapMore && this.props.handleTapMore();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    handleBack = _props.handleBack,
				    isEdit = _props.isEdit;

				return React.createElement(
					_chaosUi.Nav,
					{ style: { background: '#11ABE8' }, title: '\u52A8\u6001\u8BE6\u60C5' },
					React.createElement('span', { className: 'feed-detail-btn back-btn',
						onTouchTap: handleBack, role: 'left' }),
					isEdit ? React.createElement(
						'div',
						{ className: 'feed-more-btn', role: 'right' },
						React.createElement(Icon, { icon: 'm-sys-gengduo', onTouchTap: this.handleTapMore })
					) : null
				);
			}
		}]);
		return FeedDetailNav;
	}(_react.Component);

	exports.default = FeedDetailNav;
	module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _chaosUi = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(266);

	/*
	 * Name: FeedDetail点击更多弹层
	 */

	var ShowMorePanel = function (_Component) {
	  (0, _inherits3.default)(ShowMorePanel, _Component);

	  function ShowMorePanel(props) {
	    (0, _classCallCheck3.default)(this, ShowMorePanel);

	    var _this = (0, _possibleConstructorReturn3.default)(this, (ShowMorePanel.__proto__ || (0, _getPrototypeOf2.default)(ShowMorePanel)).call(this, props));

	    _this.handleDelet = _this.handleDelet.bind(_this);
	    _this.handlePanelClose = _this.handlePanelClose.bind(_this);
	    return _this;
	  }

	  // 点击删除


	  (0, _createClass3.default)(ShowMorePanel, [{
	    key: 'handleDelet',
	    value: function handleDelet(e) {
	      e.preventDefault && e.preventDefault();
	      this.props.handleDeleteFeed && this.props.handleDeleteFeed();
	    }

	    // 点击遮罩或者取消

	  }, {
	    key: 'handlePanelClose',
	    value: function handlePanelClose(e) {
	      e && e.preventDefault && e.preventDefault();
	      this.props.handlePanelClose && this.props.handlePanelClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var show = this.props.show;

	      if (show) {
	        return React.createElement(
	          _chaosUi.PopUp,
	          { cls: 'feed-showmore-panel', visible: true, style: { width: '100%', height: '112px', bottom: 0 }, animation: 'bottom-slide-fade', onClose: this.handlePanelClose },
	          React.createElement(
	            'div',
	            { className: 'delet', onTouchTap: this.handleDelet },
	            '\u5220\u9664'
	          ),
	          React.createElement(
	            'div',
	            { onTouchTap: this.handlePanelClose },
	            '\u53D6\u6D88'
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return ShowMorePanel;
	}(_react.Component);

	exports.default = ShowMorePanel;
	module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _chaosUi = __webpack_require__(8);

	var _FeedListNav = __webpack_require__(146);

	var _FeedListNav2 = _interopRequireDefault(_FeedListNav);

	var _SimpleFeedList = __webpack_require__(76);

	var _SimpleFeedList2 = _interopRequireDefault(_SimpleFeedList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: FeedList
	 * Desc: Feed列表通用组件，根据Type甄别渲染类型
	 * author: lilei@beisen.com
	 */
	var FeedList = function (_Component) {
		(0, _inherits3.default)(FeedList, _Component);

		function FeedList(props) {
			(0, _classCallCheck3.default)(this, FeedList);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedList.__proto__ || (0, _getPrototypeOf2.default)(FeedList)).call(this, props));

			_this.onSelectType = _this.onSelectType.bind(_this);
			_this.handleBack = _this.handleBack.bind(_this);
			_this.handlePublish = _this.handlePublish.bind(_this);

			_this.state = {
				type: 2,
				dropDownTitle: '相关的'
			};
			return _this;
		}

		// 返回


		(0, _createClass3.default)(FeedList, [{
			key: 'handleBack',
			value: function handleBack(e) {
				e.preventDefault();
				this.props.handleBack();
			}
		}, {
			key: 'handlePublish',
			value: function handlePublish(e) {
				e.preventDefault();
				this.props.handlePublish();
			}

			// 修正Type，更新列表

		}, {
			key: 'onSelectType',
			value: function onSelectType(e, selectedType) {
				this.setState({
					type: selectedType.value,
					dropDownTitle: selectedType.label
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state,
				    type = _state.type,
				    dropDownTitle = _state.dropDownTitle;
				var _props = this.props,
				    detailHash = _props.detailHash,
				    hideComments = _props.hideComments;

				return React.createElement(
					_chaosUi.Page,
					{ cls: 'detail-page widget-page feed-list-page' },
					React.createElement(_FeedListNav2.default, { dropDownTitle: dropDownTitle,
						onSelectType: this.onSelectType,
						handleBack: this.handleBack,
						handlePublish: this.handlePublish
					}),
					React.createElement(_SimpleFeedList2.default, { type: type,
						detailHash: detailHash,
						hideComments: hideComments,
						handleBack: this.handleBack })
				);
			}
		}]);
		return FeedList;
	}(_react.Component);

	exports.default = FeedList;
	module.exports = exports['default'];

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _index = __webpack_require__(11);

	var _index2 = __webpack_require__(77);

	var _index3 = _interopRequireDefault(_index2);

	var _index4 = __webpack_require__(70);

	var _index5 = _interopRequireDefault(_index4);

	var _FeedReplyList = __webpack_require__(50);

	var _FeedReplyList2 = _interopRequireDefault(_FeedReplyList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: FeedList
	 * Desc: Feed列表通用组件，根据Type甄别渲染类型
	 * author: lilei@beisen.com
	 */
	var FeedListItem = function (_Component) {
		(0, _inherits3.default)(FeedListItem, _Component);

		function FeedListItem(props) {
			(0, _classCallCheck3.default)(this, FeedListItem);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedListItem.__proto__ || (0, _getPrototypeOf2.default)(FeedListItem)).call(this, props));

			_this.contentTouchTap = _this.contentTouchTap.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(FeedListItem, [{
			key: 'contentTouchTap',
			value: function contentTouchTap(e) {
				e.preventDefault();
				var _props = this.props,
				    feedId = _props.feedId,
				    hideInputFooter = _props.hideInputFooter;

				hideInputFooter(feedId);
			}
		}, {
			key: 'render',
			value: function render() {
				// 获取数据
				var _props2 = this.props,
				    feedId = _props2.feedId,
				    feedType = _props2.feedType,
				    feedComments = _props2.feedComments,
				    focusReplyInput = _props2.focusReplyInput,
				    hideComments = _props2.hideComments;

				var FeedMain = _index3.default[feedType];
				return React.createElement(
					'li',
					null,
					React.createElement(FeedMain, (0, _extends3.default)({}, this.props, { contentTouchTap: this.contentTouchTap })),
					React.createElement(_index5.default, { focusReplyInput: focusReplyInput, feedId: feedId, hideComments: hideComments }),
					feedComments.comments && hideComments != true ? React.createElement(
						'div',
						{ className: 'reply-container detail' },
						React.createElement(_FeedReplyList2.default, (0, _extends3.default)({}, feedComments, { contentTouchTap: this.contentTouchTap }))
					) : null
				);
			}
		}]);
		return FeedListItem;
	}(_react.Component);

	exports.default = FeedListItem;
	module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _chaosUi = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(268);

	/*
	 * Name: FeedListNav
	 * Desc: Feed列表顶部导航
	 * author: lilei@beisen.com
	 */

	var FeedListNav = function (_Component) {
		(0, _inherits3.default)(FeedListNav, _Component);

		function FeedListNav(props) {
			(0, _classCallCheck3.default)(this, FeedListNav);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedListNav.__proto__ || (0, _getPrototypeOf2.default)(FeedListNav)).call(this, props));

			_this.feedListType = [{
				label: '发表的',
				value: 1
			}, {
				label: '相关的',
				value: 2
			}, {
				label: '用户公开的',
				value: 3
			}, {
				label: '部门',
				value: 4
			}, {
				label: '租户的',
				value: 7
			}, {
				label: '@我的',
				value: 23
			}, {
				label: '回复我的',
				value: 25
			}, {
				label: '收藏',
				value: 26
			}, {
				label: '置顶',
				value: 27
			}];
			return _this;
		}

		(0, _createClass3.default)(FeedListNav, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    dropDownTitle = _props.dropDownTitle,
				    onSelectType = _props.onSelectType,
				    handleBack = _props.handleBack,
				    handlePublish = _props.handlePublish;


				return React.createElement(
					_chaosUi.Nav,
					{ style: { background: '#11ABE8' } },
					React.createElement('span', { className: 'feed-list-btn back-btn',
						onTouchTap: handleBack, role: 'left' }),
					React.createElement(_chaosUi.DropDown, { className: 'feed-list-drop-down', title: dropDownTitle,
						data: this.feedListType, role: 'center', onTouchTap: onSelectType }),
					React.createElement('span', { className: 'feed-list-btn publish-btn',
						onTouchTap: handlePublish, role: 'right' })
				);
			}
		}]);
		return FeedListNav;
	}(_react.Component);

	exports.default = FeedListNav;
	module.exports = exports['default'];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedFileList = __webpack_require__(44);

	var _FeedFileList2 = _interopRequireDefault(_FeedFileList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(270);

	/*
	 * Name: Feed类型1-分享类
	 * Desc: 分享型Feed图表，根据isDetail确立是否采用详情样式
	 * Author: lilei@beisen.com
	 */

	var FeedType1 = function (_Component) {
		(0, _inherits3.default)(FeedType1, _Component);

		function FeedType1(props) {
			(0, _classCallCheck3.default)(this, FeedType1);
			return (0, _possibleConstructorReturn3.default)(this, (FeedType1.__proto__ || (0, _getPrototypeOf2.default)(FeedType1)).call(this, props));
		}

		(0, _createClass3.default)(FeedType1, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    content = _props.content,
				    attachments = _props.attachments,
				    type = _props.type,
				    publishUser = _props.publishUser,
				    createDate = _props.createDate,
				    isPrivate = _props.isPrivate,
				    obj = _props.obj;
				// 头像信息

				var avatarInfo = {};
				var imgType = 'avatar';
				var logoSrc = '';

				// 标题信息组装
				var textData = [];
				if (obj) {
					textData.push(obj.objName);
					textData.push('项目中');
					textData.push(publishUser.name);
					textData.push('说');
					imgType = 'logo';
					logoSrc = obj.objLogo;
				} else {
					textData.push(publishUser.name);
					// 组装人像
					avatarInfo = {
						Id: publishUser.userId,
						Name: publishUser.name,
						avatars: publishUser.avatar
					};
				}

				// 标题组信息
				var titleData = {
					textData: textData,
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: imgType,
					avatarInfo: avatarInfo,
					logoSrc: logoSrc
				};

				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: this.props.contentTouchTap },
					React.createElement(_index2.default, titleData),
					React.createElement(
						_index4.default,
						null,
						React.createElement('div', { className: 'feed-content-text', dangerouslySetInnerHTML: { __html: content } })
					),
					attachments ? React.createElement(_FeedFileList2.default, { attachments: attachments }) : null
				);
			}
		}]);
		return FeedType1;
	}(_react.Component);

	exports.default = FeedType1;
	module.exports = exports['default'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedContentTitle = __webpack_require__(29);

	var _FeedContentTitle2 = _interopRequireDefault(_FeedContentTitle);

	var _FeedContentDetail = __webpack_require__(43);

	var _FeedContentDetail2 = _interopRequireDefault(_FeedContentDetail);

	var _FeedContentAvatar = __webpack_require__(42);

	var _FeedContentAvatar2 = _interopRequireDefault(_FeedContentAvatar);

	var _FeedContentDesc = __webpack_require__(28);

	var _FeedContentDesc2 = _interopRequireDefault(_FeedContentDesc);

	var _FeedTimeLineList = __webpack_require__(30);

	var _FeedTimeLineList2 = _interopRequireDefault(_FeedTimeLineList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: Feed类型10-项目类
	 * Desc: 项目型
	 * Author: lilei@beisen.com
	 */
	var FeedType10 = function (_Component) {
		(0, _inherits3.default)(FeedType10, _Component);

		function FeedType10(props) {
			(0, _classCallCheck3.default)(this, FeedType10);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedType10.__proto__ || (0, _getPrototypeOf2.default)(FeedType10)).call(this, props));

			_this.getProgressFile = _this.getProgressFile.bind(_this);
			return _this;
		}

		// 获取进度字段


		(0, _createClass3.default)(FeedType10, [{
			key: 'getProgressFile',
			value: function getProgressFile() {
				var progress = this.props.progress;

				return React.createElement(
					'li',
					null,
					React.createElement(
						'label',
						null,
						'\u9879\u76EE\u8FDB\u5EA6\uFF1A'
					),
					React.createElement(
						'span',
						null,
						React.createElement(
							'div',
							{ className: 'progress-line' },
							React.createElement('div', { className: (0, _classnames2.default)('compeleted-line', {
									'all': parseInt(progress) == 100
								}), style: { width: progress } }),
							React.createElement('div', { className: (0, _classnames2.default)('undone-line', {
									'all': parseInt(progress) == 0
								}), style: { width: 100 - parseInt(progress) + '%' } })
						),
						React.createElement(
							'div',
							{ className: 'progress-text' },
							progress
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    publishUser = _props.publishUser,
				    createDate = _props.createDate,
				    startDate = _props.startDate,
				    isPrivate = _props.isPrivate,
				    obj = _props.obj,
				    feedId = _props.feedId,
				    contentTouchTap = _props.contentTouchTap,
				    isDetail = _props.isDetail,
				    principalUser = _props.principalUser,
				    description = _props.description,
				    deadline = _props.deadline,
				    feedOperations = _props.feedOperations;
				// 头像信息

				var avatarInfo = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar

					// 项目负责人头像
				};var principalAvatarInfo = {
					Id: principalUser.userId,
					Name: principalUser.name,
					avatars: principalUser.avatar

					// 标题信息组装
				};var textData = [publishUser.name, '创建了项目'];

				// 描述宽度
				var descWidth = window.innerWidth - (isDetail ? 121 : 146);
				var preWidth = isDetail ? 195 : 220;

				// 详情数据
				var detailData = [{
					name: '起止时间',
					value: startDate + ' - ' + deadline
				}];

				// 标题组数据
				var titleData = {
					textData: textData,
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: 'avatar',
					avatarInfo: avatarInfo
				};

				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: contentTouchTap },
					React.createElement(_index2.default, titleData),
					React.createElement(
						_index4.default,
						{ isDetail: isDetail },
						React.createElement(
							'div',
							{ className: 'feed-content-top' },
							React.createElement(_FeedContentTitle2.default, { isDetail: isDetail,
								textData: [obj.objName], contentTitle: '项目',
								logoSrc: obj.objLogo, preWidth: preWidth }),
							React.createElement(
								_FeedContentDesc2.default,
								{ descWidth: descWidth },
								description
							),
							React.createElement(_FeedContentAvatar2.default, { avatarInfo: principalAvatarInfo })
						),
						React.createElement(
							_FeedContentDetail2.default,
							{ detailData: detailData },
							this.getProgressFile()
						)
					),
					React.createElement(_FeedTimeLineList2.default, { showBar: isDetail,
						feedOperations: feedOperations,
						feedId: feedId
					})
				);
			}
		}]);
		return FeedType10;
	}(_react.Component);

	exports.default = FeedType10;
	module.exports = exports['default'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedContentDesc = __webpack_require__(28);

	var _FeedContentDesc2 = _interopRequireDefault(_FeedContentDesc);

	var _FeedContentTitle = __webpack_require__(29);

	var _FeedContentTitle2 = _interopRequireDefault(_FeedContentTitle);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: Feed类型2-绩效管理
	 * Desc: 绩效管理增加目标时，Feed结构
	 * Author: lilei@beisen.com
	 */
	var FeedType2 = function (_Component) {
		(0, _inherits3.default)(FeedType2, _Component);

		function FeedType2(props) {
			(0, _classCallCheck3.default)(this, FeedType2);
			return (0, _possibleConstructorReturn3.default)(this, (FeedType2.__proto__ || (0, _getPrototypeOf2.default)(FeedType2)).call(this, props));
		}

		(0, _createClass3.default)(FeedType2, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    publishUser = _props.publishUser,
				    createDate = _props.createDate,
				    isPrivate = _props.isPrivate,
				    feedId = _props.feedId,
				    isDetail = _props.isDetail,
				    feedOperations = _props.feedOperations,
				    app = _props.app,
				    status = _props.status,
				    contentTouchTap = _props.contentTouchTap;

				// 标题信息组装

				var textData = [app.appName, publishUser.name];

				// 头像
				var avatarInfo = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar

					// 宽度
				};var descWidth = window.innerWidth - (isDetail ? 123 : 148);

				// 标题组数据
				var titleData = {
					textData: textData,
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: 'avatar',
					avatarInfo: avatarInfo
				};

				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: contentTouchTap },
					React.createElement(_index2.default, titleData),
					React.createElement(
						_index4.default,
						{ isDetail: isDetail },
						React.createElement(
							'div',
							{ className: 'feed-content-top' },
							React.createElement(_FeedContentTitle2.default, { isDetail: isDetail,
								textData: [app.appObj.appObjTitle],
								contentTitle: app.appObj.appObjName,
								logoSrc: app.appLogo }),
							React.createElement(
								_FeedContentDesc2.default,
								{ descWidth: descWidth },
								'暂无描述'
							)
						)
					),
					React.createElement(FeedTimeLineList, { showBar: isDetail,
						feedOperations: feedOperations,
						feedId: feedId
					})
				);
			}
		}]);
		return FeedType2;
	}(_react.Component);

	exports.default = FeedType2;
	module.exports = exports['default'];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedContentTitle = __webpack_require__(29);

	var _FeedContentTitle2 = _interopRequireDefault(_FeedContentTitle);

	var _FeedContentDetail = __webpack_require__(43);

	var _FeedContentDetail2 = _interopRequireDefault(_FeedContentDetail);

	var _FeedContentAvatar = __webpack_require__(42);

	var _FeedContentAvatar2 = _interopRequireDefault(_FeedContentAvatar);

	var _FeedContentDesc = __webpack_require__(28);

	var _FeedContentDesc2 = _interopRequireDefault(_FeedContentDesc);

	var _FeedContentCount = __webpack_require__(115);

	var _FeedContentCount2 = _interopRequireDefault(_FeedContentCount);

	var _FeedTimeLineList = __webpack_require__(30);

	var _FeedTimeLineList2 = _interopRequireDefault(_FeedTimeLineList);

	var _FeedEvaluation = __webpack_require__(74);

	var _FeedEvaluation2 = _interopRequireDefault(_FeedEvaluation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(271);

	/*
	 * Name: Feed类型20-任务类
	 * Desc: 
	 * Author: lilei@beisen.com
	 */

	var FeedType20 = function (_Component) {
		(0, _inherits3.default)(FeedType20, _Component);

		function FeedType20(props) {
			(0, _classCallCheck3.default)(this, FeedType20);
			return (0, _possibleConstructorReturn3.default)(this, (FeedType20.__proto__ || (0, _getPrototypeOf2.default)(FeedType20)).call(this, props));
		}

		(0, _createClass3.default)(FeedType20, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    publishUser = _props.publishUser,
				    createDate = _props.createDate,
				    isPrivate = _props.isPrivate,
				    feedId = _props.feedId,
				    counter = _props.counter,
				    contentTouchTap = _props.contentTouchTap,
				    isDetail = _props.isDetail,
				    principalUser = _props.principalUser,
				    feedOperations = _props.feedOperations,
				    taskName = _props.taskName,
				    evaluation = _props.evaluation;
				// 头像信息

				var avatarInfo = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar

					// 项目负责人头像
				};var principalAvatarInfo = {
					Id: principalUser.userId,
					Name: principalUser.name,
					avatars: principalUser.avatar

					// 标题信息组装
				};var textData = [publishUser.name, '发起的任务'];

				// 描述宽度
				var descWidth = window.innerWidth - (isDetail ? 123 : 148);

				// 标题组数据
				var titleData = {
					textData: textData,
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: 'avatar',
					avatarInfo: avatarInfo
				};

				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: contentTouchTap },
					React.createElement(_index2.default, titleData),
					React.createElement(
						_index4.default,
						{ isDetail: isDetail },
						React.createElement(
							'div',
							{ className: 'feed-content-top' },
							React.createElement('span', { className: 'feed-content-line' }),
							React.createElement(_FeedContentTitle2.default, { isDetail: isDetail,
								textData: [taskName], contentTitle: '任务' }),
							React.createElement(
								_FeedContentDesc2.default,
								{ descWidth: descWidth, hasEva: evaluation ? true : false },
								evaluation ? React.createElement(_FeedEvaluation2.default, evaluation) : React.createElement(_FeedContentCount2.default, { counter: counter })
							),
							React.createElement(_FeedContentAvatar2.default, { avatarInfo: principalAvatarInfo })
						)
					),
					React.createElement(_FeedTimeLineList2.default, { showBar: isDetail,
						feedOperations: feedOperations,
						feedId: feedId
					})
				);
			}
		}]);
		return FeedType20;
	}(_react.Component);

	exports.default = FeedType20;
	module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedFileList = __webpack_require__(44);

	var _FeedFileList2 = _interopRequireDefault(_FeedFileList);

	var _FeedEvaluation = __webpack_require__(74);

	var _FeedEvaluation2 = _interopRequireDefault(_FeedEvaluation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(272);

	var reportTypeMap = {
		8: '日报',
		26: '周报',
		27: '月报'
	};

	/*
	 * Name: Feed类型5-日月报类
	 * Desc: 分享型Feed图表，根据isDetail确立是否采用详情样式
	 * Author: lilei@beisen.com liuqichao@beisen.com
	 */

	var FeedType5 = function (_Component) {
		(0, _inherits3.default)(FeedType5, _Component);

		function FeedType5(props) {
			(0, _classCallCheck3.default)(this, FeedType5);
			return (0, _possibleConstructorReturn3.default)(this, (FeedType5.__proto__ || (0, _getPrototypeOf2.default)(FeedType5)).call(this, props));
		}

		(0, _createClass3.default)(FeedType5, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    content = _props.content,
				    createDate = _props.createDate,
				    publishUser = _props.publishUser,
				    attachments = _props.attachments,
				    isPrivate = _props.isPrivate,
				    reportType = _props.reportType,
				    name = _props.name,
				    evaluation = _props.evaluation,
				    contentTouchTap = _props.contentTouchTap;

				// 组装人像

				var avatarInfo = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar

					// 标题组信息
				};var titleData = {
					textData: [publishUser.name],
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: 'avatar',
					avatarInfo: avatarInfo

					// 日月周报标题数据
				};var reportTypeTitle = reportTypeMap[reportType];
				var reportTypeClassName = ['report-type', 'type' + reportType].join(' ');

				// const testEva = {
				// 	ctype: 0,
				// 	editable: false,
				// 	goal: 2,
				// 	name: "综合评分",
				// 	remark: "",
				// 	type: 2,
				// 	user: null,
				// 	value: 2
				// }
				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: contentTouchTap },
					React.createElement(_index2.default, titleData),
					evaluation ? React.createElement(
						'div',
						{ className: 'feed-title-evaluation' },
						React.createElement(_FeedEvaluation2.default, evaluation)
					) : null,
					React.createElement(
						_index4.default,
						null,
						React.createElement(
							'div',
							{ className: 'feed-content-report-title' },
							React.createElement(
								'span',
								{ className: reportTypeClassName },
								reportTypeTitle
							),
							React.createElement(
								'span',
								null,
								name.replace('日报', '')
							)
						),
						React.createElement('div', { className: 'feed-content-text', dangerouslySetInnerHTML: { __html: content } }),
						attachments ? React.createElement(_FeedFileList2.default, { attachments: attachments }) : null
					)
				);
			}
		}]);
		return FeedType5;
	}(_react.Component);

	exports.default = FeedType5;
	module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedContentTitle = __webpack_require__(29);

	var _FeedContentTitle2 = _interopRequireDefault(_FeedContentTitle);

	var _FeedContentAvatar = __webpack_require__(42);

	var _FeedContentAvatar2 = _interopRequireDefault(_FeedContentAvatar);

	var _FeedContentDesc = __webpack_require__(28);

	var _FeedContentDesc2 = _interopRequireDefault(_FeedContentDesc);

	var _FeedContentState = __webpack_require__(116);

	var _FeedContentState2 = _interopRequireDefault(_FeedContentState);

	var _FeedTimeLineList = __webpack_require__(30);

	var _FeedTimeLineList2 = _interopRequireDefault(_FeedTimeLineList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: Feed类型7-标准考核
	 * Desc: 某某的考核，无附件--需要继续观察
	 * Author: lilei@beisen.com
	 */
	var FeedType7 = function (_Component) {
		(0, _inherits3.default)(FeedType7, _Component);

		function FeedType7(props) {
			(0, _classCallCheck3.default)(this, FeedType7);
			return (0, _possibleConstructorReturn3.default)(this, (FeedType7.__proto__ || (0, _getPrototypeOf2.default)(FeedType7)).call(this, props));
		}

		(0, _createClass3.default)(FeedType7, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    publishUser = _props.publishUser,
				    createDate = _props.createDate,
				    isPrivate = _props.isPrivate,
				    feedId = _props.feedId,
				    isDetail = _props.isDetail,
				    deadline = _props.deadline,
				    principalUser = _props.principalUser,
				    app = _props.app,
				    feedOperations = _props.feedOperations,
				    assessName = _props.assessName,
				    status = _props.status,
				    startDate = _props.startDate,
				    contentTouchTap = _props.contentTouchTap;
				// 头像信息

				var avatarInfo = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar

					// 项目负责人头像
				};var principalAvatarInfo = {
					Id: principalUser.userId,
					Name: principalUser.name,
					avatars: principalUser.avatar

					// 标题信息组装
				};var textData = [publishUser.name, '的考核'];

				// 描述宽度
				var descWidth = window.innerWidth - (isDetail ? 131 : 156);

				// 标题组数据
				var titleData = {
					textData: textData,
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: 'logo',
					logoSrc: app.appLogo
				};

				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: contentTouchTap },
					React.createElement(_index2.default, titleData),
					React.createElement(
						_index4.default,
						{ isDetail: isDetail },
						React.createElement(
							'div',
							{ className: 'feed-content-top' },
							React.createElement(_FeedContentTitle2.default, { isDetail: isDetail,
								textData: [assessName],
								contentTitle: '考核' }),
							React.createElement(
								_FeedContentDesc2.default,
								{ descWidth: descWidth },
								startDate + '—' + deadline
							),
							React.createElement(_FeedContentAvatar2.default, { avatarInfo: principalAvatarInfo }),
							React.createElement(_FeedContentState2.default, { status: status })
						)
					),
					React.createElement(_FeedTimeLineList2.default, { showBar: isDetail,
						feedOperations: feedOperations,
						feedId: feedId
					})
				);
			}
		}]);
		return FeedType7;
	}(_react.Component);

	exports.default = FeedType7;
	module.exports = exports['default'];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedContentTitle = __webpack_require__(29);

	var _FeedContentTitle2 = _interopRequireDefault(_FeedContentTitle);

	var _FeedContentDesc = __webpack_require__(28);

	var _FeedContentDesc2 = _interopRequireDefault(_FeedContentDesc);

	var _FeedContentDetail = __webpack_require__(43);

	var _FeedContentDetail2 = _interopRequireDefault(_FeedContentDetail);

	var _FeedTimeLineList = __webpack_require__(30);

	var _FeedTimeLineList2 = _interopRequireDefault(_FeedTimeLineList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: Feed类型8-应用类
	 * Desc: 应用类--标准类型
	 * Author: lilei@beisen.com
	 */
	var FeedType8 = function (_Component) {
		(0, _inherits3.default)(FeedType8, _Component);

		function FeedType8(props) {
			(0, _classCallCheck3.default)(this, FeedType8);
			return (0, _possibleConstructorReturn3.default)(this, (FeedType8.__proto__ || (0, _getPrototypeOf2.default)(FeedType8)).call(this, props));
		}

		(0, _createClass3.default)(FeedType8, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    publishUser = _props.publishUser,
				    createDate = _props.createDate,
				    isPrivate = _props.isPrivate,
				    feedId = _props.feedId,
				    isDetail = _props.isDetail,
				    principalUser = _props.principalUser,
				    feedOperations = _props.feedOperations,
				    app = _props.app,
				    customizeData = _props.customizeData,
				    contentTouchTap = _props.contentTouchTap;
				// 头像信息

				var avatarInfo = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar

					// 标题信息组装
				};var textData = [app ? app.appName : ''];

				// 描述宽度
				var preWidth = isDetail ? 181 : 206;
				var descWidth = window.innerWidth - (isDetail ? 131 : 156);

				// 标题组数据
				var titleData = {
					textData: textData,
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: 'avatar',
					avatarInfo: avatarInfo
				};

				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: contentTouchTap },
					React.createElement(_index2.default, titleData),
					React.createElement(
						_index4.default,
						{ isDetail: isDetail },
						React.createElement(
							'div',
							{ className: 'feed-content-top' },
							React.createElement(_FeedContentTitle2.default, { isDetail: isDetail,
								textData: [app.appObj.appObjTitle],
								contentTitle: app.appObj.appObjName,
								logoSrc: app.appLogo, preWidth: preWidth }),
							React.createElement(
								_FeedContentDesc2.default,
								{ descWidth: descWidth },
								'暂无描述'
							)
						),
						React.createElement(_FeedContentDetail2.default, { detailData: customizeData })
					),
					React.createElement(_FeedTimeLineList2.default, { showBar: isDetail,
						feedOperations: feedOperations,
						feedId: feedId
					})
				);
			}
		}]);
		return FeedType8;
	}(_react.Component);

	exports.default = FeedType8;
	module.exports = exports['default'];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedFileList = __webpack_require__(44);

	var _FeedFileList2 = _interopRequireDefault(_FeedFileList);

	var _FeedTimeSiteList = __webpack_require__(138);

	var _FeedTimeSiteList2 = _interopRequireDefault(_FeedTimeSiteList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(273);

	/*
	 * Name: Feed类型80-签到
	 * Desc: 签到
	 * Author: lilei@beisen.com liuqichao@beisen.com
	 */

	var FeedType80 = function (_Component) {
		(0, _inherits3.default)(FeedType80, _Component);

		function FeedType80(props) {
			(0, _classCallCheck3.default)(this, FeedType80);
			return (0, _possibleConstructorReturn3.default)(this, (FeedType80.__proto__ || (0, _getPrototypeOf2.default)(FeedType80)).call(this, props));
		}

		(0, _createClass3.default)(FeedType80, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    createDate = _props.createDate,
				    publishUser = _props.publishUser,
				    workHours = _props.workHours,
				    isPrivate = _props.isPrivate,
				    date = _props.date,
				    timeSites = _props.timeSites,
				    isDetail = _props.isDetail,
				    contentTouchTap = _props.contentTouchTap;

				// 组装人像

				var avatarInfo = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar

					// 标题组信息
				};var titleData = {
					textData: [publishUser.name, '的签到'],
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: 'avatar',
					avatarInfo: avatarInfo
				};

				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: contentTouchTap },
					React.createElement(_index2.default, titleData),
					React.createElement(
						_index4.default,
						{ isDetail: isDetail },
						React.createElement(
							'div',
							{ className: 'feed-content-report-title' },
							React.createElement(
								'span',
								{ className: 'report-type type-blue' },
								'\u7B7E\u5230'
							),
							React.createElement(
								'span',
								null,
								date.split('(')[0]
							),
							React.createElement(
								'span',
								{ className: 'report-type-hour' },
								workHours + '小时'
							)
						)
					),
					React.createElement(_FeedTimeSiteList2.default, { showBar: isDetail, timeSites: timeSites })
				);
			}
		}]);
		return FeedType80;
	}(_react.Component);

	exports.default = FeedType80;
	module.exports = exports['default'];

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _FeedMain = __webpack_require__(19);

	var _FeedMain2 = _interopRequireDefault(_FeedMain);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(17);

	var _index4 = _interopRequireDefault(_index3);

	var _FeedContentTitle = __webpack_require__(29);

	var _FeedContentTitle2 = _interopRequireDefault(_FeedContentTitle);

	var _FeedContentDetail = __webpack_require__(43);

	var _FeedContentDetail2 = _interopRequireDefault(_FeedContentDetail);

	var _FeedContentAvatar = __webpack_require__(42);

	var _FeedContentAvatar2 = _interopRequireDefault(_FeedContentAvatar);

	var _FeedContentDesc = __webpack_require__(28);

	var _FeedContentDesc2 = _interopRequireDefault(_FeedContentDesc);

	var _FeedTimeLineList = __webpack_require__(30);

	var _FeedTimeLineList2 = _interopRequireDefault(_FeedTimeLineList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(274);

	/*
	 * Name: Feed类型9--通用模板
	 * Desc: 通用模板
	 * Author: lilei@beisen.com
	 */

	var FeedType9 = function (_Component) {
		(0, _inherits3.default)(FeedType9, _Component);

		function FeedType9(props) {
			(0, _classCallCheck3.default)(this, FeedType9);

			var _this = (0, _possibleConstructorReturn3.default)(this, (FeedType9.__proto__ || (0, _getPrototypeOf2.default)(FeedType9)).call(this, props));

			_this.getPriAvtarInfo = _this.getPriAvtarInfo.bind(_this);
			return _this;
		}

		(0, _createClass3.default)(FeedType9, [{
			key: 'getPriAvtarInfo',
			value: function getPriAvtarInfo() {
				var principalUser = this.props.principalUser;

				if (principalUser) {
					// 项目负责人头像
					var principalAvatarInfo = {
						Id: principalUser.userId,
						Name: principalUser.name,
						avatars: principalUser.avatar
					};
					return React.createElement(_FeedContentAvatar2.default, { avatarInfo: principalAvatarInfo });
				}
				return null;
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    publishUser = _props.publishUser,
				    createDate = _props.createDate,
				    isPrivate = _props.isPrivate,
				    feedId = _props.feedId,
				    isDetail = _props.isDetail,
				    principalUser = _props.principalUser,
				    feedOperations = _props.feedOperations,
				    app = _props.app,
				    customizeData = _props.customizeData,
				    contentTouchTap = _props.contentTouchTap;
				// 头像信息

				var avatarInfo = {
					Id: publishUser.userId,
					Name: publishUser.name,
					avatars: publishUser.avatar

					// 标题信息组装
				};var textData = [publishUser.name, '的审批'];
				// 内容标题
				var contentTextData = [, app.appObj.appObjTitle];

				// 标题组数据
				var titleData = {
					textData: textData,
					createDate: createDate,
					isPrivate: isPrivate,
					imgType: 'avatar',
					avatarInfo: avatarInfo

					// 描述宽度
				};var descWidth = window.innerWidth - (isDetail ? 131 : 156);

				return React.createElement(
					_FeedMain2.default,
					{ contentTouchTap: contentTouchTap },
					React.createElement(_index2.default, titleData),
					React.createElement(
						_index4.default,
						{ isDetail: isDetail },
						React.createElement(
							'div',
							{ className: 'feed-content-top line' },
							React.createElement(_FeedContentTitle2.default, { isDetail: isDetail,
								textData: contentTextData,
								contentTitle: app.appObj.appObjName }),
							React.createElement(
								_FeedContentDesc2.default,
								{ descWidth: descWidth },
								'审批描述字段'
							),
							this.getPriAvtarInfo()
						),
						React.createElement(_FeedContentDetail2.default, { detailData: customizeData })
					),
					React.createElement(_FeedTimeLineList2.default, { showBar: isDetail,
						feedOperations: feedOperations,
						feedId: feedId
					})
				);
			}
		}]);
		return FeedType9;
	}(_react.Component);

	exports.default = FeedType9;
	module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _chaosUi = __webpack_require__(8);

	var _PublishNewsNav = __webpack_require__(157);

	var _PublishNewsNav2 = _interopRequireDefault(_PublishNewsNav);

	var _index = __webpack_require__(11);

	var _SimplePublishNews = __webpack_require__(158);

	var _SimplePublishNews2 = _interopRequireDefault(_SimplePublishNews);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 * Name: PublishNews--发布新动态
	 * Desc: 发布新动态主页，同样分为两部分
	 * author: lilei@beisen.com
	 */
	var PublishNews = function (_Component) {
		(0, _inherits3.default)(PublishNews, _Component);

		function PublishNews(props) {
			(0, _classCallCheck3.default)(this, PublishNews);

			var _this = (0, _possibleConstructorReturn3.default)(this, (PublishNews.__proto__ || (0, _getPrototypeOf2.default)(PublishNews)).call(this, props));

			_this.publishNews = _this.publishNews.bind(_this);
			_this.setImgFiles = _this.setImgFiles.bind(_this);
			_this.setTextareaValue = _this.setTextareaValue.bind(_this);
			_this.setVisibility = _this.setVisibility.bind(_this);

			_this.state = {
				textareaValue: '',
				imgFiles: [],
				visibility: 1,
				isShowReplyTip: false,
				replyTipType: 'warning',
				message: '回复内容不能为空'
			};
			return _this;
		}

		// 发布动态


		(0, _createClass3.default)(PublishNews, [{
			key: 'publishNews',
			value: function publishNews(e) {
				var _this2 = this;

				e.preventDefault();
				var _state = this.state,
				    textareaValue = _state.textareaValue,
				    imgFiles = _state.imgFiles,
				    visibility = _state.visibility;


				if (textareaValue.length == 0) {
					this.setState({
						isShowReplyTip: true,
						replyTipType: 'warning',
						message: '回复内容不能为空'
					});
					return;
				}

				var FileUrl = imgFiles.map(function (item) {
					return item.DfsPath;
				}).toString();

				var objId = 0;
				var objType = 0;

				// 仅@人不需要objId
				if (visibility == 2) {
					objId = BSGlobal.loginUserInfo.DepartmentId;
					objType = 15;
				}

				// 3在前端表示仅@人，后端2、3表示私密
				if (visibility == 3) {
					visibility = 2;
				}

				var params = {
					Content: textareaValue,
					FileUrl: FileUrl,
					ObjId: objId,
					ObjType: objType,
					Visibility: visibility,
					IsSendSMS: false
				};

				var url = (0, _index.urlComplete)('/api/v2/{tenant_id}/{user_id}/user/feed/AddShare');

				(0, _index.callFetch)(url, 'POST', params).then(function (respData) {
					if (respData.Code == 1) {
						_this2.props.handleBack();
						_this2.setState({
							isShowReplyTip: true,
							replyTipType: 'success',
							message: '发布成功',
							textareaValue: '',
							imgFiles: [],
							selectedDatas: []
						});
					} else {
						_this2.setState({
							isShowReplyTip: true,
							replyTipType: 'error',
							message: '发布失败，请刷新页面后重试'
						});
					}
				});
			}

			// 图片路径

		}, {
			key: 'setImgFiles',
			value: function setImgFiles(imgFiles) {
				this.setState({
					imgFiles: imgFiles
				});
			}

			// 赋值

		}, {
			key: 'setTextareaValue',
			value: function setTextareaValue(value) {
				this.setState({
					textareaValue: value
				});
			}

			// 权限

		}, {
			key: 'setVisibility',
			value: function setVisibility(visibility) {
				this.setState({
					visibility: visibility
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state2 = this.state,
				    isShowReplyTip = _state2.isShowReplyTip,
				    replyTipType = _state2.replyTipType,
				    message = _state2.message;

				return React.createElement(
					_chaosUi.Page,
					{ cls: 'feed-publish-page' },
					React.createElement(_PublishNewsNav2.default, { handleBack: this.props.handleBack, handleSave: this.publishNews }),
					React.createElement(_SimplePublishNews2.default, (0, _extends3.default)({}, this.state, {
						setImgFiles: this.setImgFiles,
						setTextareaValue: this.setTextareaValue,
						setVisibility: this.setVisibility })),
					isShowReplyTip ? React.createElement(_chaosUi.Prompts, { message: message, type: replyTipType }) : null
				);
			}
		}]);
		return PublishNews;
	}(_react.Component);

	exports.default = PublishNews;
	module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _chaosUi = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(276);

	/*
	 * Name: PublishNewsNav导航
	 * Desc: 发布动态的导航
	 * author: lilei@beisen.com
	 */

	var PublishNewsNav = function (_Component) {
	  (0, _inherits3.default)(PublishNewsNav, _Component);

	  function PublishNewsNav(props) {
	    (0, _classCallCheck3.default)(this, PublishNewsNav);
	    return (0, _possibleConstructorReturn3.default)(this, (PublishNewsNav.__proto__ || (0, _getPrototypeOf2.default)(PublishNewsNav)).call(this, props));
	  }

	  (0, _createClass3.default)(PublishNewsNav, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleBack = _props.handleBack,
	          handleSave = _props.handleSave;

	      return React.createElement(
	        _chaosUi.Nav,
	        { sytle: { 'border-bottom': '2px solid #11ABE8' }, title: '\u53D1\u5206\u4EAB' },
	        React.createElement(
	          'span',
	          { onTouchTap: handleBack, role: 'left' },
	          '\u53D6\u6D88'
	        ),
	        React.createElement(
	          'span',
	          { onTouchTap: handleSave, role: 'right' },
	          '\u53D1\u9001'
	        )
	      );
	    }
	  }]);
	  return PublishNewsNav;
	}(_react.Component);

	exports.default = PublishNewsNav;
	module.exports = exports['default'];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _getPrototypeOf = __webpack_require__(2);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(3);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(4);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(6);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(5);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(1);

	var _classnames = __webpack_require__(7);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _chaosUi = __webpack_require__(8);

	var _ShareInputFooter = __webpack_require__(131);

	var _ShareInputFooter2 = _interopRequireDefault(_ShareInputFooter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(277);

	/*
	 * Name: SimpleFeedDetail
	 * Desc: 发布
	 * author: lilei@beisen.com
	 */

	var SimplePublishNews = function (_Component) {
		(0, _inherits3.default)(SimplePublishNews, _Component);

		function SimplePublishNews(props) {
			(0, _classCallCheck3.default)(this, SimplePublishNews);

			var _this = (0, _possibleConstructorReturn3.default)(this, (SimplePublishNews.__proto__ || (0, _getPrototypeOf2.default)(SimplePublishNews)).call(this, props));

			_this.handleTextChange = _this.handleTextChange.bind(_this);
			_this.addImgFiles = _this.addImgFiles.bind(_this);
			_this.deleteImgFile = _this.deleteImgFile.bind(_this);
			_this.getImgPreview = _this.getImgPreview.bind(_this);
			_this.addTextareaValue = _this.addTextareaValue.bind(_this);
			_this.deleteEomticon = _this.deleteEomticon.bind(_this);
			_this.setVisibility = _this.setVisibility.bind(_this);
			_this.calcTextareaHeight = _this.calcTextareaHeight.bind(_this);

			_this.state = {
				textareaHeight: document.body.scrollHeight - 115
			};
			return _this;
		}

		// 记录数值变化


		(0, _createClass3.default)(SimplePublishNews, [{
			key: 'handleTextChange',
			value: function handleTextChange(e) {
				e.preventDefault();
				var textareaValue = e.target.value;
				if (textareaValue.length > 1000) {
					textareaValue = textareaValue.slice(0, 1000);
				}
				this.props.setTextareaValue(textareaValue);
			}

			// 添加图片dfs路径

		}, {
			key: 'addImgFiles',
			value: function addImgFiles(res, imgFile) {
				if (res == '') {
					return;
				}
				var textareaHeight = this.state.textareaHeight;
				var imgFiles = this.props.imgFiles;

				var newFiles = imgFiles.concat(imgFile);

				var previewHeight = 0;
				if (newFiles.length == 1) {
					previewHeight = 50;
				}
				this.props.setImgFiles(newFiles);
				this.setState({
					textareaHeight: textareaHeight - previewHeight
				});
			}

			// 删除图片

		}, {
			key: 'deleteImgFile',
			value: function deleteImgFile(e) {
				e.preventDefault();
				var textareaHeight = this.state.textareaHeight;
				var imgFiles = this.props.imgFiles;


				imgFiles = imgFiles.filter(function (imgFile) {
					return imgFile.DfsPath != e.target.getAttribute('data-dfspath');
				});

				var previewHeight = 0;
				if (imgFiles.length > 0) {
					previewHeight = 50;
				}
				this.props.setImgFiles(newFiles);
				this.setState({
					textareaHeight: textareaHeight + previewHeight
				});
			}

			// 获取图片预览

		}, {
			key: 'getImgPreview',
			value: function getImgPreview() {
				var _this2 = this;

				var imgFiles = this.props.imgFiles;

				if (imgFiles.length == 0) {
					return null;
				}
				return React.createElement(
					'ul',
					{ className: 'share-img-perview' },
					imgFiles.map(function (item, index) {
						return React.createElement(
							'li',
							{ className: 'share-img-li', key: index },
							React.createElement('div', { className: 'share-img-delete', 'data-dfspath': item.DfsPath,
								onTouchTap: _this2.deleteImgFile }),
							React.createElement('img', { className: 'share-img', src: item.ClientUrl })
						);
					})
				);
			}

			// 添加textarea数值

		}, {
			key: 'addTextareaValue',
			value: function addTextareaValue(value) {
				var _props = this.props,
				    textareaValue = _props.textareaValue,
				    setTextareaValue = _props.setTextareaValue;

				setTextareaValue((textareaValue + value).slice(0, 1000));
			}

			// 仅能删除文本末尾处的表情

		}, {
			key: 'deleteEomticon',
			value: function deleteEomticon() {
				var _props2 = this.props,
				    textareaValue = _props2.textareaValue,
				    setTextareaValue = _props2.setTextareaValue;
				// 获取匹配规则的表情字符

				var matchEomticons = textareaValue.match(/\[[a-z]+:[^\]]+\]/g);
				var matchEomticon = matchEomticons ? matchEomticons.pop() : null;
				// 如果存在表情
				if (matchEomticon) {
					var lastStr = textareaValue.slice(-matchEomticon.length);
					if (matchEomticon === lastStr) {
						// 截取最后一个表情
						setTextareaValue(textareaValue.slice(0, textareaValue.length - matchEomticon.length));
					}
				}
			}

			// 设定权限

		}, {
			key: 'setVisibility',
			value: function setVisibility(visibility) {
				var previewHeight = 0;
				if (this.props.imgFiles.length > 0) {
					previewHeight = 50;
				}

				this.props.setVisibility(visibility);

				this.setState({
					textareaHeight: document.body.scrollHeight - 115 - previewHeight
				});
			}

			// 根据当前渲染内容计算高度

		}, {
			key: 'calcTextareaHeight',
			value: function calcTextareaHeight(height) {
				var previewHeight = 0;
				if (this.props.imgFiles.length > 0) {
					previewHeight = 50;
				}
				this.setState({
					textareaHeight: document.body.scrollHeight - (height || 115) - previewHeight
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _props3 = this.props,
				    textareaValue = _props3.textareaValue,
				    visibility = _props3.visibility;
				var textareaHeight = this.state.textareaHeight;

				var fontCount = 1000 - textareaValue.length;
				return React.createElement(
					_chaosUi.Content,
					null,
					React.createElement('textarea', { style: { height: textareaHeight },
						className: 'publish-textarea',
						onChange: this.handleTextChange,
						value: textareaValue }),
					this.getImgPreview(),
					React.createElement(
						'div',
						{ className: (0, _classnames2.default)('font-count', {
								warning: fontCount <= 10
							}) },
						fontCount
					),
					React.createElement(_ShareInputFooter2.default, { visibility: visibility,
						addImgFiles: this.addImgFiles,
						addTextareaValue: this.addTextareaValue,
						deleteEomticon: this.deleteEomticon,
						setVisibility: this.setVisibility,
						calcTextareaHeight: this.calcTextareaHeight
					})
				);
			}
		}]);
		return SimplePublishNews;
	}(_react.Component);

	exports.default = SimplePublishNews;
	module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _promise = __webpack_require__(45);

	var _promise2 = _interopRequireDefault(_promise);

	var _extends2 = __webpack_require__(9);

	var _extends3 = _interopRequireDefault(_extends2);

	var _stringify = __webpack_require__(162);

	var _stringify2 = _interopRequireDefault(_stringify);

	exports.default = callFetch;

	var _es6Promise = __webpack_require__(288);

	__webpack_require__(289);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * 封装fetch请求
	 * @liuqichao
	 *
	 */

	var URLSearchParams = __webpack_require__(287);

	//const API_ROOT = '/';

	//序列化url
	function serialize(obj) {
	    var result = [];
	    for (var k in obj) {
	        result.push(encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]));
	    }
	    return result.join('&');
	}
	//判断是否数组
	function isArray(obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]';
	}
	/**
	 * url 请求路径
	 * method 请求方法 GET POST
	 * params 请求参数
	 */

	function callFetch(url, method, params, headers, dataType) {
	    var fullUrl = url,
	        data = {},
	        defaultHeaders = {
	        'Accept': 'application/json, application/xml, text/play, text/html, *.*',
	        'Content-Type': 'application/json; charset=utf-8',
	        'x-useragent': "web"
	    };

	    if (method == "GET" && params) {
	        fullUrl = fullUrl + "?" + serialize(params);
	    } else if (headers && headers['Content-Type'] == 'application/x-www-form-urlencoded') {
	        var urlSear = new URLSearchParams();
	        for (var i in params) {
	            urlSear.append(i, params[i]);
	        }
	        data.body = urlSear.toString();
	        data.method = method;
	    } else {
	        data.body = (0, _stringify2.default)(params);
	        data.method = method;
	    }

	    var newHeaders;
	    if (window.customHeaders && typeof window.customHeaders == 'function') {
	        newHeaders = (0, _extends3.default)({}, defaultHeaders, window.customHeaders());
	    } else {
	        newHeaders = (0, _extends3.default)({}, defaultHeaders, headers);
	    }
	    data.headers = newHeaders;

	    data.credentials = 'include'; //传递cookie信息
	    return fetch(fullUrl, data).then(function (response) {
	        return response.json().then(function (json) {
	            return { json: json, response: response };
	        });
	    }).then(function (_ref) {
	        var json = _ref.json,
	            response = _ref.response;

	        if (!response.ok) {
	            return _promise2.default.reject(json);
	        }
	        return json;
	    });
	}
	module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _keys = __webpack_require__(79);

	var _keys2 = _interopRequireDefault(_keys);

	exports.default = urlComplete;
	exports.urlComplete2 = urlComplete2;

	var _helper = __webpack_require__(110);

	var _helper2 = _interopRequireDefault(_helper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * [urlComplete description]
	 * @param  {string} url      要转换的url
	 * @param  {string||number||undefined} talentId 租户id 非必填参数 不填的话走当前登陆租户ID
	 * @param  {string||number||undefined} userId   用户id 不填的话走当前登陆用户ID
	 * @param  {string||undefined} params 追加到url中的参数
	 * @return {string}  处理后的url
	 */
	function urlComplete(ajaxUrl, userId, talentId, params) {
		ajaxUrl = ajaxUrl.replace('{tenant_id}', talentId || BSGlobal.tenantInfo.Id).replace('{user_id}', BSGlobal.loginUserInfo.Id);
		if (ajaxUrl.indexOf('/') !== 0) {
			ajaxUrl = '/' + ajaxUrl;
		}
		if (params) {
			var paramsSymbol = ajaxUrl.indexOf('?') >= 0 ? '&' : '?';
			ajaxUrl = ajaxUrl + paramsSymbol + params;
		}
		// 钉钉中打开新窗口时链接必须有协议 否则打不开
		return location.protocol + _helper2.default.getHostByType('italent') + ajaxUrl;
	}

	/**
	 *
	 * @param ajaxUrl
	 * @param options params, host (http://gitlab.beisencorp.com/ux-upaas-app/ux-helper)
	 */
	function urlComplete2(ajaxUrl) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		var url = ajaxUrl;
		url = url.replace('{tenant_id}', BSGlobal.tenantInfo.Id);
		url = url.replace('{user_id}', BSGlobal.loginUserInfo.Id);
		if (options.params) {
			var paramsStr = (0, _keys2.default)(options.params).map(function (k) {
				var v = options.params[k];
				return encodeURIComponent(k) + '=' + encodeURIComponent(v);
			}).join('&');
			url += (url.indexOf('?') > 0 ? '&' : '?') + paramsStr;
		}
		var host = options.host || 'italent';
		return location.protocol + _helper2.default.getHostByType(host) + url;
	}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component_index = __webpack_require__(112);

	var TitaFeed = _interopRequireWildcard(_component_index);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	window['@pbeisen/tita-feed'] = TitaFeed;
	exports.default = TitaFeed;
	module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(172), __esModule: true };

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(173), __esModule: true };

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(174), __esModule: true };

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(175), __esModule: true };

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(178), __esModule: true };

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(179), __esModule: true };

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(181), __esModule: true };

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(182), __esModule: true };

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _from = __webpack_require__(78);

	var _from2 = _interopRequireDefault(_from);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }

	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(64);
	__webpack_require__(205);
	module.exports = __webpack_require__(10).Array.from;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(10);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(207);
	module.exports = __webpack_require__(10).Object.assign;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(208);
	var $Object = __webpack_require__(10).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(209);
	var $Object = __webpack_require__(10).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(210);
	module.exports = __webpack_require__(10).Object.getPrototypeOf;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(211);
	module.exports = __webpack_require__(10).Object.keys;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(212);
	module.exports = __webpack_require__(10).Object.setPrototypeOf;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(215);
	module.exports = __webpack_require__(10).Object.values;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(100);
	__webpack_require__(64);
	__webpack_require__(101);
	__webpack_require__(213);
	__webpack_require__(216);
	__webpack_require__(217);
	module.exports = __webpack_require__(10).Promise;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(214);
	__webpack_require__(100);
	__webpack_require__(218);
	__webpack_require__(219);
	module.exports = __webpack_require__(10).Symbol;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(64);
	__webpack_require__(101);
	module.exports = __webpack_require__(63).f('iterator');


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(27);
	var toLength = __webpack_require__(60);
	var toAbsoluteIndex = __webpack_require__(203);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(21);
	var createDesc = __webpack_require__(40);

	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(33);
	var gOPS = __webpack_require__(56);
	var pIE = __webpack_require__(39);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(31);
	var call = __webpack_require__(86);
	var isArrayIter = __webpack_require__(85);
	var anObject = __webpack_require__(20);
	var toLength = __webpack_require__(60);
	var getIterFn = __webpack_require__(99);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(36);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(55);
	var descriptor = __webpack_require__(40);
	var setToStringTag = __webpack_require__(47);
	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(26)(IteratorPrototype, __webpack_require__(13)('iterator'), function () { return this; });

	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(48)('meta');
	var isObject = __webpack_require__(23);
	var has = __webpack_require__(25);
	var setDesc = __webpack_require__(21).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(32)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var macrotask = __webpack_require__(98).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(36)(process) == 'process';

	module.exports = function () {
	  var head, last, notify;

	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };

	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }

	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(16);
	var getKeys = __webpack_require__(33);
	var gOPS = __webpack_require__(56);
	var pIE = __webpack_require__(39);
	var toObject = __webpack_require__(34);
	var IObject = __webpack_require__(84);
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(32)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(21);
	var anObject = __webpack_require__(20);
	var getKeys = __webpack_require__(33);

	module.exports = __webpack_require__(16) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(27);
	var gOPN = __webpack_require__(90).f;
	var toString = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(16);
	var getKeys = __webpack_require__(33);
	var toIObject = __webpack_require__(27);
	var isEnum = __webpack_require__(39).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(26);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(23);
	var anObject = __webpack_require__(20);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(31)(Function.call, __webpack_require__(89).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(12);
	var core = __webpack_require__(10);
	var dP = __webpack_require__(21);
	var DESCRIPTORS = __webpack_require__(16);
	var SPECIES = __webpack_require__(13)('species');

	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(59);
	var defined = __webpack_require__(51);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(59);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var navigator = global.navigator;

	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(31);
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(34);
	var call = __webpack_require__(86);
	var isArrayIter = __webpack_require__(85);
	var toLength = __webpack_require__(60);
	var createProperty = __webpack_require__(186);
	var getIterFn = __webpack_require__(99);

	$export($export.S + $export.F * !__webpack_require__(88)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(183);
	var step = __webpack_require__(192);
	var Iterators = __webpack_require__(37);
	var toIObject = __webpack_require__(27);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(87)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(14);

	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(195) });


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(55) });


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperty: __webpack_require__(21).f });


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(34);
	var $getPrototypeOf = __webpack_require__(91);

	__webpack_require__(93)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(34);
	var $keys = __webpack_require__(33);

	__webpack_require__(93)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(14);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(200).set });


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(38);
	var global = __webpack_require__(12);
	var ctx = __webpack_require__(31);
	var classof = __webpack_require__(81);
	var $export = __webpack_require__(14);
	var isObject = __webpack_require__(23);
	var aFunction = __webpack_require__(46);
	var anInstance = __webpack_require__(184);
	var forOf = __webpack_require__(188);
	var speciesConstructor = __webpack_require__(97);
	var task = __webpack_require__(98).set;
	var microtask = __webpack_require__(194)();
	var newPromiseCapabilityModule = __webpack_require__(54);
	var perform = __webpack_require__(94);
	var userAgent = __webpack_require__(204);
	var promiseResolve = __webpack_require__(95);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(13)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();

	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};

	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(199)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(47)($Promise, PROMISE);
	__webpack_require__(201)(PROMISE);
	Wrapper = __webpack_require__(10)[PROMISE];

	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(88)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(12);
	var has = __webpack_require__(25);
	var DESCRIPTORS = __webpack_require__(16);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(96);
	var META = __webpack_require__(193).KEY;
	var $fails = __webpack_require__(32);
	var shared = __webpack_require__(58);
	var setToStringTag = __webpack_require__(47);
	var uid = __webpack_require__(48);
	var wks = __webpack_require__(13);
	var wksExt = __webpack_require__(63);
	var wksDefine = __webpack_require__(62);
	var enumKeys = __webpack_require__(187);
	var isArray = __webpack_require__(190);
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(23);
	var toObject = __webpack_require__(34);
	var toIObject = __webpack_require__(27);
	var toPrimitive = __webpack_require__(61);
	var createDesc = __webpack_require__(40);
	var _create = __webpack_require__(55);
	var gOPNExt = __webpack_require__(197);
	var $GOPD = __webpack_require__(89);
	var $GOPS = __webpack_require__(56);
	var $DP = __webpack_require__(21);
	var $keys = __webpack_require__(33);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });

	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(90).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(39).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;

	  if (DESCRIPTORS && !__webpack_require__(38)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(14);
	var $values = __webpack_require__(198)(false);

	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(14);
	var core = __webpack_require__(10);
	var global = __webpack_require__(12);
	var speciesConstructor = __webpack_require__(97);
	var promiseResolve = __webpack_require__(95);

	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(14);
	var newPromiseCapability = __webpack_require__(54);
	var perform = __webpack_require__(94);

	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(62)('asyncIterator');


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(62)('observable');


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var _interopRequireDefault = __webpack_require__(109);

	exports.__esModule = true;
	exports.default = addClass;

	var _hasClass = _interopRequireDefault(__webpack_require__(221));

	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}

	module.exports = exports["default"];

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = hasClass;

	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}

	module.exports = exports["default"];

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	'use strict';

	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}

	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 223 */
102,
/* 224 */
102,
/* 225 */
102,
/* 226 */
102,
/* 227 */
102,
/* 228 */
102,
/* 229 */
102,
/* 230 */
102,
/* 231 */
102,
/* 232 */
102,
/* 233 */
102,
/* 234 */
102,
/* 235 */
102,
/* 236 */
102,
/* 237 */
102,
/* 238 */
102,
/* 239 */
102,
/* 240 */
102,
/* 241 */
102,
/* 242 */
102,
/* 243 */
102,
/* 244 */
102,
/* 245 */
102,
/* 246 */
102,
/* 247 */
102,
/* 248 */
102,
/* 249 */
102,
/* 250 */
102,
/* 251 */
102,
/* 252 */
102,
/* 253 */
102,
/* 254 */
102,
/* 255 */
102,
/* 256 */
102,
/* 257 */
102,
/* 258 */
102,
/* 259 */
102,
/* 260 */
102,
/* 261 */
102,
/* 262 */
102,
/* 263 */
102,
/* 264 */
102,
/* 265 */
102,
/* 266 */
102,
/* 267 */
102,
/* 268 */
102,
/* 269 */
102,
/* 270 */
102,
/* 271 */
102,
/* 272 */
102,
/* 273 */
102,
/* 274 */
102,
/* 275 */
102,
/* 276 */
102,
/* 277 */
102,
/* 278 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/

	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = __webpack_require__(66);
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	}

	module.exports = checkPropTypes;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';

	var ReactPropTypesSecret = __webpack_require__(66);

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';

	var ReactIs = __webpack_require__(103);
	var assign = __webpack_require__(278);

	var ReactPropTypesSecret = __webpack_require__(66);
	var checkPropTypes = __webpack_require__(279);

	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }

	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.8.6
	 * react-is.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';



	if (process.env.NODE_ENV !== "production") {
	  (function() {
	'use strict';

	Object.defineProperty(exports, '__esModule', { value: true });

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;

	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' ||
	  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
	}

	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var lowPriorityWarning = function () {};

	{
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };

	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }

	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}

	var lowPriorityWarning$1 = lowPriorityWarning;

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;
	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;
	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;
	              default:
	                return $$typeof;
	            }
	        }
	      case REACT_LAZY_TYPE:
	      case REACT_MEMO_TYPE:
	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}

	// AsyncMode is deprecated along with isAsyncMode
	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;

	var hasWarnedAboutDeprecatedIsAsyncMode = false;

	// AsyncMode should be deprecated
	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true;
	      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }
	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	exports.typeOf = typeOf;
	exports.AsyncMode = AsyncMode;
	exports.ConcurrentMode = ConcurrentMode;
	exports.ContextConsumer = ContextConsumer;
	exports.ContextProvider = ContextProvider;
	exports.Element = Element;
	exports.ForwardRef = ForwardRef;
	exports.Fragment = Fragment;
	exports.Lazy = Lazy;
	exports.Memo = Memo;
	exports.Portal = Portal;
	exports.Profiler = Profiler;
	exports.StrictMode = StrictMode;
	exports.Suspense = Suspense;
	exports.isValidElementType = isValidElementType;
	exports.isAsyncMode = isAsyncMode;
	exports.isConcurrentMode = isConcurrentMode;
	exports.isContextConsumer = isContextConsumer;
	exports.isContextProvider = isContextProvider;
	exports.isElement = isElement;
	exports.isForwardRef = isForwardRef;
	exports.isFragment = isFragment;
	exports.isLazy = isLazy;
	exports.isMemo = isMemo;
	exports.isPortal = isPortal;
	exports.isProfiler = isProfiler;
	exports.isStrictMode = isStrictMode;
	exports.isSuspense = isSuspense;
	  })();
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";

	exports.__esModule = true;
	exports.default = void 0;

	var PropTypes = _interopRequireWildcard(__webpack_require__(41));

	var _addClass = _interopRequireDefault(__webpack_require__(220));

	var _removeClass = _interopRequireDefault(__webpack_require__(222));

	var _react = _interopRequireDefault(__webpack_require__(1));

	var _Transition = _interopRequireDefault(__webpack_require__(105));

	var _PropTypes = __webpack_require__(108);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};

	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */


	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);

	  function CSSTransition() {
	    var _this;

	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;

	      _this.removeClasses(node, 'exit');

	      addClass(node, className);

	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };

	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;

	      _this.reflowAndAddClass(node, activeClassName);

	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };

	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;

	      var enterClassName = _this.getClassNames('enter').doneClassName;

	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

	      _this.removeClasses(node, appearing ? 'appear' : 'enter');

	      addClass(node, doneClassName);

	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };

	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;

	      _this.removeClasses(node, 'appear');

	      _this.removeClasses(node, 'enter');

	      addClass(node, className);

	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };

	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;

	      _this.reflowAndAddClass(node, activeClassName);

	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };

	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;

	      _this.removeClasses(node, 'exit');

	      addClass(node, doneClassName);

	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };

	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };

	    return _this;
	  }

	  var _proto = CSSTransition.prototype;

	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;

	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };

	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */

	      addClass(node, className);
	    }
	  };

	  _proto.render = function render() {
	    var props = _extends({}, this.props);

	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };

	  return CSSTransition;
	}(_react.default.Component);

	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,

	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,

	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,

	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,

	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,

	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,

	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";

	exports.__esModule = true;
	exports.default = void 0;

	var _propTypes = _interopRequireDefault(__webpack_require__(41));

	var _react = _interopRequireDefault(__webpack_require__(1));

	var _reactDom = __webpack_require__(24);

	var _TransitionGroup = _interopRequireDefault(__webpack_require__(106));

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);

	  function ReplaceTransition() {
	    var _this;

	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }

	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }

	      return _this.handleLifecycle('onEnter', 0, args);
	    };

	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }

	      return _this.handleLifecycle('onEntering', 0, args);
	    };

	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }

	      return _this.handleLifecycle('onEntered', 0, args);
	    };

	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }

	      return _this.handleLifecycle('onExit', 1, args);
	    };

	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }

	      return _this.handleLifecycle('onExiting', 1, args);
	    };

	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }

	      return _this.handleLifecycle('onExited', 1, args);
	    };

	    return _this;
	  }

	  var _proto = ReplaceTransition.prototype;

	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;

	    var children = this.props.children;

	    var child = _react.default.Children.toArray(children)[idx];

	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };

	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];

	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };

	  return ReplaceTransition;
	}(_react.default.Component);

	ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;

	var _react = __webpack_require__(1);

	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };

	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */


	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};

	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list


	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];

	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }

	  var i;
	  var childMapping = {};

	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }

	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`


	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }

	  return childMapping;
	}

	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}

	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}

	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	Copyright (C) 2015 by WebReflection

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.

	*/
	'use strict';

	function encode(str) {
	  return encodeURIComponent(str).replace(find, replacer);
	}

	function decode(str) {
	  return decodeURIComponent(str.replace(plus, ' '));
	}

	function URLSearchParams(query) {
	  this[secret] = Object.create(null);
	  if (!query) return;
	  if (query.charAt(0) === '?') {
	    query = query.slice(1);
	  }
	  for (var
	    index, value,
	    pairs = (query || '').split('&'),
	    i = 0,
	    length = pairs.length; i < length; i++
	  ) {
	    value = pairs[i];
	    index = value.indexOf('=');
	    if (-1 < index) {
	      this.append(
	        decode(value.slice(0, index)),
	        decode(value.slice(index + 1))
	      );
	    } else if (value.length){
	      this.append(
	        decode(value),
	        ''
	      );
	    }
	  }
	}

	var
	  URLSearchParamsProto = URLSearchParams.prototype,
	  find = /[!'\(\)~]|%20|%00/g,
	  plus = /\+/g,
	  replace = {
	    '!': '%21',
	    "'": '%27',
	    '(': '%28',
	    ')': '%29',
	    '~': '%7E',
	    '%20': '+',
	    '%00': '\x00'
	  },
	  replacer = function (match) {
	    return replace[match];
	  },
	  iterable = isIterable(),
	  secret = '__URLSearchParams__:' + Math.random()
	;

	function isIterable() {
	  try {
	    return !!Symbol.iterator;
	  } catch(error) {
	    return false;
	  }
	}

	URLSearchParamsProto.append = function append(name, value) {
	  var dict = this[secret];
	  if (name in dict) {
	    dict[name].push('' + value);
	  } else {
	    dict[name] = ['' + value];
	  }
	};

	URLSearchParamsProto.delete = function del(name) {
	  delete this[secret][name];
	};

	URLSearchParamsProto.get = function get(name) {
	  var dict = this[secret];
	  return name in dict ? dict[name][0] : null;
	};

	URLSearchParamsProto.getAll = function getAll(name) {
	  var dict = this[secret];
	  return name in dict ? dict[name].slice(0) : [];
	};

	URLSearchParamsProto.has = function has(name) {
	  return name in this[secret];
	};

	URLSearchParamsProto.set = function set(name, value) {
	  this[secret][name] = ['' + value];
	};

	URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
	  var dict = this[secret];
	  Object.getOwnPropertyNames(dict).forEach(function(name) {
	    dict[name].forEach(function(value) {
	      callback.call(thisArg, value, name, this);
	    }, this);
	  }, this);
	};

	URLSearchParamsProto.keys = function keys() {
	  var items = [];
	  this.forEach(function(value, name) { items.push(name); });
	  var iterator = {
	    next: function() {
	      var value = items.shift();
	      return {done: value === undefined, value: value};
	    }
	  };

	  if (iterable) {
	    iterator[Symbol.iterator] = function() {
	      return iterator;
	    };
	  }

	  return iterator;
	};

	URLSearchParamsProto.values = function values() {
	  var items = [];
	  this.forEach(function(value) { items.push(value); });
	  var iterator = {
	    next: function() {
	      var value = items.shift();
	      return {done: value === undefined, value: value};
	    }
	  };

	  if (iterable) {
	    iterator[Symbol.iterator] = function() {
	      return iterator;
	    };
	  }

	  return iterator;
	};

	URLSearchParamsProto.entries = function entries() {
	  var items = [];
	  this.forEach(function(value, name) { items.push([name, value]); });
	  var iterator = {
	    next: function() {
	      var value = items.shift();
	      return {done: value === undefined, value: value};
	    }
	  };

	  if (iterable) {
	    iterator[Symbol.iterator] = function() {
	      return iterator;
	    };
	  }

	  return iterator;
	};

	if (iterable) {
	  URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
	}

	/*
	URLSearchParamsProto.toBody = function() {
	  return new Blob(
	    [this.toString()],
	    {type: 'application/x-www-form-urlencoded'}
	  );
	};
	*/

	URLSearchParamsProto.toJSON = function toJSON() {
	  return {};
	};

	URLSearchParamsProto.toString = function toString() {
	  var dict = this[secret], query = [], i, key, name, value;
	  for (key in dict) {
	    name = encode(key);
	    for (
	      i = 0,
	      value = dict[key];
	      i < value.length; i++
	    ) {
	      query.push(name + '=' + encode(value[i]));
	    }
	  }
	  return query.join('&');
	};

	module.exports = global.URLSearchParams || URLSearchParams;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_288__;

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_289__;

/***/ })
/******/ ])))
});
;


//////////////////
// WEBPACK FOOTER
// ./~/@pbeisen/tita-feed/dist/TitaWidget.js
// module id = 125
// module chunks = 0